<template>
  <div class="fluxo-funerario-page">
    <!-- Loading -->
    <v-dialog v-model="isLoading" persistent max-width="320">
      <v-card class="pa-6 text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          size="56"
          width="4"
        ></v-progress-circular>
        <div class="mt-4 text-subtitle-1 font-weight-medium">
          Carregando tickets...
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog de Alerta para mensagens gerais -->
    <v-dialog v-model="alertDialog.show" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ alertDialog.title }}</v-card-title>
        <v-card-text class="d-flex justify-center">
          {{ alertDialog.message }}
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn small color="primary" @click="alertDialog.show = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Confirmação -->
    <v-dialog v-model="confirmDialog.show" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ confirmDialog.title }}</v-card-title>
        <v-card-text class="d-flex justify-center">
          {{ confirmDialog.message }}
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn
            small
            color="grey"
            text
            @click="confirmDialog.show = false"
            :disabled="confirmDialog.loading"
          >
            Cancelar
          </v-btn>
          <v-btn
            small
            color="error"
            :loading="confirmDialog.loading"
            @click="confirmDialog.onConfirm"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilter" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          A diferença entre as datas não pode ser superior a 30 dias.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilter = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Atribuição -->
    <v-dialog v-model="dialogAtribuir" max-width="400px" persistent>
      <v-card>
        <v-card-title class="headline">Confirmação de Atribuição</v-card-title>
        <v-card-text>
          <div class="mb-2">
            <strong>Falecido:</strong> {{ atribuirNomeFalecido }}<br />
            <strong>Etapa:</strong> {{ atribuirNomeEtapa }}
          </div>
          <div class="mt-2">
            Deseja se atribuir como responsável por esta atividade?
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text color="grey" @click="fecharDialogAtribuir"
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            @click="confirmarAtribuicao"
            small
            :disabled="!hasPermissionEdit"
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Conclusão -->
    <v-dialog v-model="dialogConcluir" max-width="400px" persistent>
      <v-card>
        <v-card-title class="headline">Finalizar Atendimento</v-card-title>
        <v-card-text class="pb-0">
          <div class="mb-2">
            <strong>Falecido:</strong> {{ servicoAtual?.nomeFalecido }}
          </div>
          <div class="mt-2">Como deseja finalizar este atendimento?</div>
          <div class="d-flex justify-center mt-2">
            <v-btn
              color="red"
              small
              class="mr-2"
              @click="abrirDialogPendencia(servicoAtual)"
              >Com pendência</v-btn
            >
            <v-btn
              color="green"
              small
              @click="concluirTicket('concluido', servicoAtual)"
              >Concluído</v-btn
            >
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text color="grey" @click="dialogConcluir = false"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Resposta do Procedimento -->
    <v-dialog v-model="dialogProcedimentoResposta" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-medium">
          {{
            modoRespostaProcedimento === "observacao"
              ? "Observação do"
              : modoRespostaProcedimento === "responder"
                ? "Responder"
                : "Editar"
          }}
          Procedimento
        </v-card-title>
        <v-card-text v-if="procedimentoRespondendo">
          <div class="mb-4">
            <strong>{{ procedimentoRespondendo.descricao }}</strong>
          </div>

          <v-row>
            <v-col
              v-if="
                modoRespostaProcedimento !== 'observacao' ||
                !procedimentoRespondendo.respondido
              "
              cols="12"
              class="py-1"
            >
              <div class="text-caption grey--text mb-1">Resposta</div>
              <v-btn-toggle
                v-if="procedimentoRespondendo.tipo === 'sim_nao'"
                v-model="procedimentoRespondendo.resposta"
                dense
                rounded
                class="elevation-0"
              >
                <v-btn small value="sim" color="success" outlined> Sim </v-btn>
                <v-btn small value="nao" color="error" outlined> Não </v-btn>
              </v-btn-toggle>

              <v-text-field
                v-else-if="procedimentoRespondendo.tipo === 'texto_curto'"
                v-model="procedimentoRespondendo.resposta"
                dense
                outlined
                hide-details
                placeholder="Resposta"
              ></v-text-field>

              <v-textarea
                v-else-if="procedimentoRespondendo.tipo === 'texto_longo'"
                v-model="procedimentoRespondendo.resposta"
                dense
                outlined
                hide-details
                rows="2"
                placeholder="Resposta"
              ></v-textarea>

              <v-text-field
                v-else
                v-model="procedimentoRespondendo.resposta"
                dense
                outlined
                hide-details
                placeholder="Resposta"
              ></v-text-field>
            </v-col>

            <v-col cols="12" class="py-1">
              <div class="text-caption grey--text mb-1">Observações</div>
              <v-text-field
                v-model="procedimentoRespondendo.observacoes"
                dense
                outlined
                hide-details
                placeholder="Opcional"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            text
            color="grey"
            @click="dialogProcedimentoResposta = false"
            :disabled="salvandoProcedimentoResposta"
          >
            Cancelar
          </v-btn>
          <v-btn
            small
            color="primary"
            @click="salvarProcedimentoResposta"
            :loading="salvandoProcedimentoResposta"
            :disabled="!procedimentoRespostaValida"
          >
            {{
              modoRespostaProcedimento === "editar" ? "Atualizar" : "Salvar"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Pendência -->
    <v-dialog v-model="dialogPendencia" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline"> Finalizar com Pendência </v-card-title>
        <v-card-text class="pb-0">
          <div class="mb-2">
            <strong>Falecido:</strong>
            {{ servicoConclusaoPendente?.nomeFalecido }}
          </div>
          <v-row class="my-2">
            <v-col cols="12" class="py-1">
              <v-select
                v-model="pendencia"
                :items="pendencias"
                label="Motivo da pendência *"
                outlined
                dense
                :rules="[(v) => !!v || 'Selecione o motivo da pendência']"
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            text
            color="grey"
            @click="
              dialogPendencia = false;
              dialogConcluir = true;
            "
            :disabled="salvandoPendencia"
          >
            Voltar
          </v-btn>
          <v-btn
            small
            color="primary"
            @click="finalizarComPendencia"
            :loading="salvandoPendencia"
            :disabled="!pendencia"
          >
            Finalizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Edição -->
    <v-dialog v-model="dialogEdicao" persistent max-width="1000">
      <v-card>
        <v-card-title class="text-h3">
          {{
            modoCriacaoManual
              ? "Novo atendimento funerário"
              : `Serviço Funerário ${formatarCodigoAtendimento(servicoEditando)}`
          }}
          <p v-if="servicoEditando?.contrato">
            Contrato: {{ servicoEditando?.contrato }}
          </p>
          <v-spacer></v-spacer>
          <v-chip small :color="servicoEditando?.etapa?.cor" text-color="white">
            {{ servicoEditando?.etapa?.nome }}
          </v-chip>
          <v-chip
            v-if="servicoEditando?.pendencia"
            small
            color="orange"
            text-color="white"
            class="ml-2"
          >
            {{ servicoEditando.pendencia }}
          </v-chip>
        </v-card-title>
        <v-tabs v-model="tab" centered show-arrows class="custom-tabs">
          <v-tab>Geral</v-tab>
          <v-tab v-if="!modoCriacaoManual">Itens</v-tab>
          <v-tab v-if="!modoCriacaoManual">Operacional</v-tab>
          <v-tab v-if="!modoCriacaoManual">Histórico</v-tab>
          <v-tab v-if="!modoCriacaoManual">Procedimentos</v-tab>
        </v-tabs>

        <v-tabs-slider></v-tabs-slider>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-container>
                  <!-- 1. DADOS DO ATENDIMENTO -->
                  <v-row>
                    <v-col cols="12" class="d-flex justify-end py-0">
                      <v-btn
                        v-if="!modoCriacaoManual"
                        small
                        color="primary"
                        class="mb-2"
                        :loading="sincronizandoAtendimento"
                        :disabled="
                          !hasPermissionEdit ||
                          sincronizandoAtendimento ||
                          !servicoEditando?.id
                        "
                        @click="sincronizarAtendimento"
                      >
                        <v-icon small left>mdi-sync</v-icon>
                        Sincronizar iVertex
                      </v-btn>
                    </v-col>
                    <v-col cols="12" class="my-2 pb-0">
                      <h3 class="mb-2 primary--text">Dados do Atendimento</h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Informações do atendimento.
                      </p>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.idAtendimento"
                        label="ID do Atendimento *"
                        type="number"
                        outlined
                        dense
                        :readonly="!modoCriacaoManual"
                        :rules="
                          modoCriacaoManual
                            ? [(v) => !!v || 'Informe o ID do atendimento']
                            : []
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.dataAtendimento"
                        label="Data do Atendimento"
                        type="datetime-local"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.valorAtendimento"
                        label="Valor (R$)"
                        type="number"
                        step="0.01"
                        prefix="R$"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.origem"
                        label="Local de Origem"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.destino"
                        label="Local de Destino"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-autocomplete
                        v-model="servicoEditando.donoAtendimento"
                        label="Dono do Atendimento"
                        :items="todosColaboradoresOrdenados"
                        item-text="nome"
                        item-value="id"
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-select
                        v-model="servicoEditando.pendencia"
                        :items="pendencias"
                        label="Pendência"
                        outlined
                        dense
                        clearable
                        hide-details
                      ></v-select>
                    </v-col>

                    <v-col
                      v-if="!modoCriacaoManual && servicoEditando?.id"
                      cols="12"
                      md="6"
                      class="py-0"
                    >
                      <v-autocomplete
                        v-model="tagsServicoEditando"
                        :items="tagsDisponiveis"
                        item-text="nome"
                        item-value="id"
                        label="Tags"
                        multiple
                        chips
                        small-chips
                        deletable-chips
                        clearable
                        outlined
                        dense
                        hide-details
                        :loading="salvandoTagsServico"
                        @change="sincronizarTagsServicoEditando"
                      >
                        <template v-slot:selection="{ item, attrs, selected }">
                          <v-chip
                            v-bind="attrs"
                            :input-value="selected"
                            small
                            :color="item.cor"
                            :text-color="isColorDark(item.cor) ? 'white' : 'black'"
                            close
                            @click:close="removerTagServicoEditando(item.id)"
                          >
                            {{ item.nome }}
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col
                      v-if="getDataConclusaoServico(servicoEditando)"
                      cols="12"
                      md="6"
                      class="py-0"
                    >
                      <v-text-field
                        :value="getDataConclusaoServico(servicoEditando)"
                        label="Data de Conclusão"
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" class="my-2 pb-0">
                      <h3 class="mb-2 primary--text">Velório e Sepultamento</h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Informações sobre velório e sepultamento.
                      </p>
                    </v-col>

                    <!-- Local do Velório -->
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.localVelorio"
                        label="Local do Velório"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <!-- Data do Velório -->
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.dataVelorio"
                        label="Data e Hora do Velório"
                        type="datetime-local"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <!-- Local do Sepultamento -->
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.localSepultamento"
                        label="Local do Sepultamento"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <!-- Data do Sepultamento -->
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.dataSepultamento"
                        label="Data e Hora do Sepultamento"
                        type="datetime-local"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" class="py-0">
                      <v-textarea
                        v-model="servicoEditando.obs"
                        label="Observações"
                        outlined
                        dense
                        rows="4"
                      ></v-textarea>
                    </v-col>
                  </v-row>

                  <!-- 2. DADOS DO CLIENTE -->
                  <v-row>
                    <v-col cols="12" class="my-2 pb-0">
                      <h3 class="mb-2 primary--text">Dados do Cliente</h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Informações do cliente.
                      </p>
                    </v-col>

                    <v-col cols="12" md="8" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.cliente"
                        label="Nome do Cliente"
                        :readonly="camposIvertexBloqueados"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.cpfCliente"
                        label="CPF"
                        :readonly="camposIvertexBloqueados"
                        v-mask="'###.###.###-##'"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.atendente"
                        label="Atendente Responsável"
                        :readonly="camposIvertexBloqueados"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.cpfAtendente"
                        label="CPF do Atendente"
                        :readonly="camposIvertexBloqueados"
                        v-mask="'###.###.###-##'"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.contrato"
                        label="Nº Contrato"
                        :readonly="camposIvertexBloqueados"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.tipoContrato"
                        label="Tipo Contrato"
                        :readonly="camposIvertexBloqueados"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <!-- 2. Dados do Declarante -->
                  <v-row>
                    <v-col cols="12" class="mt-6 pb-0">
                      <h3 class="mb-2 primary--text">Dados do Declarante</h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Informações do declarante responsável pelo atendimento.
                      </p>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.declarante"
                        label="Nome do Declarante"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.cpfDeclarante"
                        label="CPF do Declarante"
                        v-mask="'###.###.###-##'"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.parentescoDeclarante"
                        label="Parentesco com o Falecido"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.contatoDeclarante"
                        label="Contato do Declarante"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <!-- 3. DADOS DO FALECIDO -->
                  <v-row>
                    <v-col cols="12" class="my-2 pb-0">
                      <h3 class="mb-2 primary--text">Dados do Falecido</h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Informações do falecido.
                      </p>
                    </v-col>

                    <v-col cols="12" md="8" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.nomeFalecido"
                        :label="modoCriacaoManual ? 'Nome Completo *' : 'Nome Completo'"
                        :readonly="camposIvertexBloqueados"
                        outlined
                        dense
                        :rules="
                          modoCriacaoManual
                            ? [(v) => !!v || 'Informe o nome do falecido']
                            : []
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="py-0">
                      <v-select
                        v-model="servicoEditando.etapa.id"
                        label="Etapa"
                        :items="colunas"
                        item-text="nome"
                        item-value="id"
                        outlined
                        dense
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.cpfFalecido"
                        label="CPF"
                        v-mask="'###.###.###-##'"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.causaMorte"
                        label="Causa da Morte"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.causaPrincipal"
                        label="Causa Principal"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.numeroDeclaracaoObito"
                        label="DO/CO"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.dtFalecido"
                        label="Data do Falecimento"
                        :readonly="camposIvertexBloqueados"
                        type="datetime-local"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.nascimentoFalecido"
                        label="Data de Nascimento"
                        :readonly="camposIvertexBloqueados"
                        type="date"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.religiao"
                        label="Religião"
                        type="text"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.alturaFalecido"
                        label="Altura (m)"
                        type="number"
                        step="0.01"
                        suffix="m"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="2" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.pesoFalecido"
                        label="Peso (kg)"
                        type="number"
                        step="0.1"
                        suffix="kg"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="!modoCriacaoManual">
            <v-card flat>
              <v-card-text class="px-4">
                <v-container class="pa-0">
                  <v-row>
                    <v-col cols="12" class="my-2 pb-0">
                      <div class="mb-2">
                        <div
                          class="d-flex justify-space-between align-center flex-wrap"
                        >
                          <h3 class="mb-2 primary--text">
                            Itens do atendimento
                          </h3>
                          <div
                            class="d-flex flex-wrap gap-2 mb-2"
                            v-if="hasPermissionEdit"
                          >
                            <v-btn
                              color="success"
                              small
                              outlined
                              @click="abrirDialogAdicionarItem"
                              class="mr-2 mb-1"
                            >
                              <v-icon small left>mdi-plus</v-icon>
                              Adicionar Item
                            </v-btn>
                            <v-btn
                              color="primary"
                              small
                              outlined
                              @click="confirmarRecarregarCobertura"
                              class="mb-1"
                            >
                              <v-icon small left>mdi-refresh</v-icon>
                              Recarregar Cobertura
                            </v-btn>
                          </div>
                        </div>
                      </div>
                      <v-divider></v-divider>
                      <div
                        class="d-flex justify-space-between align-center mb-2"
                      >
                        <span class="text-caption grey--text">
                          Itens selecionados no atendimento.
                        </span>
                        <span class="text-caption grey--text">
                          {{ itensOrdenados.length }} item(s)
                        </span>
                      </div>
                      <!--
                      <div class="d-flex justify-end align-center my-3">
                        <span class="text-body-2 font-weight-bold primary--text">
                          Total: {{ formatarMoeda(itensOrdenados.reduce((sum, item) => sum + item.valorTotal, 0)) }}
                        </span>
                      </div> -->
                    </v-col>
                  </v-row>

                  <!-- Lista de Itens em Linhas -->
                  <div v-if="itensOrdenados.length > 0" class="itens-lista">
                    <div
                      v-for="(item, index) in itensOrdenados"
                      :key="item.id"
                      :class="[
                        'item-linha',
                        item.isUrna ? 'item-linha-urna' : '',
                        !item.isUrna && item.tipo === 1
                          ? 'item-linha-produto'
                          : '',
                        !item.isUrna && item.tipo === 2
                          ? 'item-linha-servico'
                          : '',
                        index % 2 === 0 ? 'item-linha-par' : 'item-linha-impar',
                      ]"
                    >
                      <!-- Primeira linha: Tipo | Nome | Qtd | Valor -->
                      <div class="d-flex align-center py-2 px-3">
                        <!-- Tipo (Chip colorido) -->
                        <div class="item-tipo mr-3">
                          <v-chip
                            v-if="item.isUrna"
                            small
                            color="blue darken-4"
                            text-color="white"
                          >
                            <v-icon left x-small>mdi-cross</v-icon>
                            URNA
                          </v-chip>
                          <v-chip
                            v-else-if="item.tipo === 1"
                            small
                            color="teal darken-3"
                            text-color="white"
                          >
                            <v-icon left x-small>mdi-package</v-icon>
                            Produto
                          </v-chip>
                          <v-chip
                            v-else
                            small
                            color="orange darken-3"
                            text-color="white"
                          >
                            <v-icon left x-small>mdi-basket</v-icon>
                            Serviço
                          </v-chip>
                        </div>

                        <!-- Nome e Grade -->
                        <div class="item-info flex-grow-1 mr-3">
                          <div class="font-weight-medium text-body-2 item-nome">
                            <span>{{ item.nomeItem }}</span>
                            <v-chip
                              v-if="getDestaqueServicoItem(item)"
                              x-small
                              :color="getDestaqueServicoItem(item).color"
                              text-color="white"
                              class="ml-2 item-destaque-chip"
                            >
                              {{ getDestaqueServicoItem(item).label }}
                            </v-chip>
                            <v-chip
                              v-if="item.isUrna && item.urnaValidada"
                              x-small
                              color="success"
                              text-color="white"
                              class="ml-2 item-destaque-chip"
                            >
                              <v-icon x-small left>mdi-check-circle</v-icon>
                              Validada
                            </v-chip>
                          </div>
                          <div
                            v-if="item.nomeGradeItem"
                            class="text-caption grey--text"
                          >
                            {{ item.nomeGradeItem }}
                          </div>
                        </div>

                        <!-- Quantidade -->
                        <div
                          class="item-qtd text-caption grey--text text-center"
                          style="min-width: 50px"
                        >
                          {{ item.quantidade }}x
                        </div>

                        <!-- Valor -->
                        <!--
                        <div
                          class="item-valor text-right"
                          style="min-width: 100px"
                        >
                          <div
                            v-if="item.descontoAplicado > 0"
                            class="text-caption grey--text text-decoration-line-through"
                          >
                            {{
                              formatarMoeda(
                                item.valorOriginal * item.quantidade,
                              )
                            }}
                          </div>
                          <div
                            v-if="item.descontoAplicado > 0"
                            class="font-weight-bold success--text"
                          >
                            {{ formatarMoeda(item.valorTotal) }}
                          </div>
                          <div v-else class="font-weight-bold primary--text">
                            {{ formatarMoeda(item.valorTotal) }}
                          </div>
                        </div> -->
                      </div>

                      <!-- Segunda linha: Botões de ação -->
                      <div
                        v-if="hasPermissionEdit"
                        :class="[
                          'item-acoes py-2 px-3 d-flex justify-end align-center',
                          item.isUrna ? 'item-acoes-urna' : '',
                        ]"
                      >
                        <v-select
                          v-if="item.isUrna"
                          v-model="item.estoque"
                          :items="estoquesUrna"
                          item-text="text"
                          item-value="value"
                          label="Estoque da urna"
                          dense
                          outlined
                          clearable
                          hide-details
                          class="item-estoque-select mr-2"
                          :loading="estoqueSalvandoItemId === item.id"
                          :disabled="
                            estoqueSalvandoItemId === item.id ||
                            item.urnaValidada
                          "
                          @focus="registrarEstoqueAnterior(item)"
                          @change="atualizarEstoqueItem(item)"
                        ></v-select>
                        <v-btn
                          v-if="item.isUrna"
                          x-small
                          outlined
                          color="success"
                          :disabled="item.urnaValidada"
                          @click="abrirDialogValidarUrna(item)"
                        >
                          <v-icon x-small left>
                            {{
                              item.urnaValidada
                                ? "mdi-check-circle"
                                : "mdi-qrcode-scan"
                            }}
                          </v-icon>
                          {{ item.urnaValidada ? "Validada" : "Validar" }}
                        </v-btn>
                        <v-btn
                          v-if="item.isUrna"
                          x-small
                          outlined
                          color="primary"
                          @click="abrirDialogTrocarUrna(item)"
                        >
                          <v-icon x-small left>mdi-swap-horizontal</v-icon>
                          Trocar
                        </v-btn>
                        <!--
                        <v-btn
                          v-if="item.valorTotal > 0"
                          x-small
                          outlined
                          color="warning"
                          @click="abrirDialogDescontoItem(item)"
                          
                        >
                          <v-icon x-small left>mdi-percent</v-icon>
                          Desconto
                        </v-btn>
                      -->
                        <v-btn
                          v-if="!item.isUrna"
                          x-small
                          outlined
                          color="primary"
                          @click="abrirDialogEditarItem(item)"
                          class="mr-2"
                        >
                          <v-icon x-small left>mdi-pencil</v-icon>
                          Editar
                        </v-btn>
                        <v-btn
                          v-if="
                            !item.isUrna &&
                            item.nomeItem !== 'ORNAMENTAÇÃO DA URNA'
                          "
                          x-small
                          outlined
                          color="error"
                          @click="confirmarExcluirItem(item)"
                        >
                          <v-icon x-small left>mdi-delete</v-icon>
                          Excluir
                        </v-btn>
                      </div>
                    </div>
                  </div>

                  <!-- Empty State -->
                  <v-alert v-else type="info" outlined class="mt-4">
                    Nenhum item encontrado para este atendimento.
                  </v-alert>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="!modoCriacaoManual">
            <v-card flat>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" class="my-2 pb-0">
                      <h3 class="mb-2 primary--text">Gestão Operacional</h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Horários e colaboradores responsáveis pelo serviço.
                      </p>
                    </v-col>

                    <v-col cols="12" md="12" class="py-0">
                      <v-expansion-panels v-model="panel" accordion>
                        <v-expansion-panel
                          v-for="(coluna, index) in colunas.filter(
                            (c) => c.tipo === 'Em andamento',
                          )"
                          :key="coluna.id"
                          class="mb-2 rounded-lg"
                        >
                          <v-expansion-panel-header class="font-weight-medium">
                            <template v-slot:actions>
                              <v-icon color="primary">$expand</v-icon>
                            </template>
                            {{ coluna.nome }}
                          </v-expansion-panel-header>

                          <v-expansion-panel-content>
                            <v-card class="pa-1" flat>
                              <v-row dense>
                                <v-col cols="12" class="py-0 mb-6">
                                  <v-checkbox
                                    :input-value="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .etapaDispensada
                                    "
                                    label="Etapa dispensada"
                                    color="primary"
                                    dense
                                    hide-details
                                    @change="
                                      dispensarEtapaOperacional(coluna.id, $event)
                                    "
                                  />
                                </v-col>
                              </v-row>
                              <v-row
                                v-if="
                                  coluna.nome === 'Preparação' &&
                                  !getEtapaRef(servicoEditando, coluna.id)
                                    .etapaDispensada
                                "
                              >
                                <v-col cols="12" class="my-2 py-0">
                                  <h3 class="mb-2 primary--text">
                                    Somatoconservação
                                  </h3>
                                  <v-divider></v-divider>
                                  <p class="text-caption grey--text mb-2">
                                    Informações sobre somatoconservação.
                                  </p>
                                </v-col>

                                <!-- Uso de Somatoconservação -->
                                <v-col cols="12" md="6" class="py-0">
                                  <v-select
                                    v-model="
                                      servicoEditando.usoSomatoConservacao
                                    "
                                    :items="[
                                      { text: 'Sim', value: true },
                                      { text: 'Não', value: false },
                                    ]"
                                    item-text="text"
                                    item-value="value"
                                    label="Uso de Somatoconservação"
                                    outlined
                                    dense
                                  ></v-select>
                                </v-col>

                                <!-- Data de Início da Somatoconservação -->
                                <v-col cols="12" md="6" class="py-0">
                                  <v-text-field
                                    v-model="servicoEditando.dataInicioSomato"
                                    label="Data de Início da Somatoconservação"
                                    type="datetime-local"
                                    outlined
                                    dense
                                    :disabled="
                                      !servicoEditando.usoSomatoConservacao
                                    "
                                  ></v-text-field>
                                </v-col>

                                <!-- Data de Fim da Somatoconservação -->
                                <v-col cols="12" md="6" class="py-0">
                                  <v-text-field
                                    v-model="servicoEditando.dataFimSomato"
                                    label="Data de Fim da Somatoconservação"
                                    type="datetime-local"
                                    outlined
                                    dense
                                    :disabled="
                                      !servicoEditando.usoSomatoConservacao
                                    "
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="6"
                                  class="py-0"
                                  v-if="
                                    servicoEditando.dataInicioSomato &&
                                    servicoEditando.dataFimSomato
                                  "
                                >
                                  <v-text-field
                                    label="Duração da Somatoconservação"
                                    type="text"
                                    outlined
                                    dense
                                    v-model="duracaoSomatoConservacao"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="6" class="py-0">
                                  <v-autocomplete
                                    v-model="
                                      servicoEditando.colaboradoresSomato
                                    "
                                    :items="listaColaboradores"
                                    item-text="nome"
                                    item-value="id"
                                    :label="`Colaboradores`"
                                    multiple
                                    clearable
                                    chips
                                    small-chips
                                    deletable-chips
                                    outlined
                                    dense
                                    height="60px"
                                  >
                                    <template
                                      v-slot:selection="{ item, index }"
                                    >
                                      <v-chip
                                        small
                                        v-if="index < 2"
                                        class="mr-1 mt-2"
                                      >
                                        {{ item.nome }}
                                      </v-chip>
                                      <span
                                        v-if="index === 2"
                                        class="grey--text text-caption ml-1 mt-2 d-inline-block"
                                      >
                                        (+{{
                                          servicoEditando.colaboradoresSomato
                                            .length - 2
                                        }})
                                      </span>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row
                                v-if="
                                  !getEtapaRef(servicoEditando, coluna.id)
                                    .etapaDispensada
                                "
                                dense
                              >
                                <v-col
                                  cols="12"
                                  class="my-2 py-0"
                                  v-if="coluna.nome === 'Preparação'"
                                >
                                  <h3 class="mb-2 primary--text">Preparação</h3>
                                  <v-divider></v-divider>
                                  <p class="text-caption grey--text mb-2">
                                    Informações sobre início e fim da etapa.
                                  </p>
                                </v-col>

                                <!-- Data Início -->
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .dtInicio
                                    "
                                    label="Início"
                                    type="datetime-local"
                                    dense
                                    outlined
                                    hide-details
                                  />
                                </v-col>

                                <!-- Data Fim -->
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .dtFim
                                    "
                                    label="Fim"
                                    type="datetime-local"
                                    dense
                                    outlined
                                    hide-details
                                  />
                                </v-col>

                                <!-- VTR -->
                                <v-col
                                  cols="6"
                                  v-if="coluna.nome !== 'Preparação'"
                                >
                                  <v-select
                                    v-model="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .vtr
                                    "
                                    label="Viatura"
                                    dense
                                    outlined
                                    hide-details
                                    :items="viaturasLista"
                                  />
                                </v-col>

                                <v-col
                                  cols="6"
                                  v-if="coluna.nome === 'Preparação'"
                                >
                                  <v-text-field
                                    v-model="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .salaPreparacao
                                    "
                                    label="Sala de Preparação"
                                    dense
                                    outlined
                                    hide-details
                                  />
                                </v-col>

                                <!-- Colaboradores -->
                                <v-col cols="12" class="pb-2">
                                  <v-autocomplete
                                    :items="listaColaboradores"
                                    item-text="nome"
                                    item-value="id"
                                    :label="`Colaboradores - ${coluna.nome}`"
                                    multiple
                                    clearable
                                    chips
                                    small-chips
                                    deletable-chips
                                    outlined
                                    dense
                                    hide-details
                                    height="60px"
                                    :value="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .colaboradores
                                    "
                                    @input="
                                      (val) => updateEtapa(coluna.id, val)
                                    "
                                  >
                                    <template
                                      v-slot:selection="{ item, index }"
                                    >
                                      <v-chip
                                        small
                                        v-if="index < 2"
                                        class="mr-1 mt-2"
                                      >
                                        {{ item.nome }}
                                      </v-chip>
                                      <span
                                        v-if="index === 2"
                                        class="grey--text text-caption ml-1 mt-2 d-inline-block"
                                      >
                                        (+{{
                                          getEtapaRef(
                                            servicoEditando,
                                            coluna.id,
                                          ).colaboradores.length - 2
                                        }})
                                      </span>
                                    </template>
                                  </v-autocomplete>
                                </v-col>

                                <!-- Supervisores -->
                                <v-col cols="12" class="pb-2">
                                  <v-autocomplete
                                    :items="listaColaboradores"
                                    item-text="nome"
                                    item-value="id"
                                    :label="`Supervisores - ${coluna.nome}`"
                                    multiple
                                    clearable
                                    chips
                                    small-chips
                                    deletable-chips
                                    outlined
                                    dense
                                    hide-details
                                    :value="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .supervisores
                                    "
                                    @input="
                                      (val) =>
                                        updateEtapaSupervisores(coluna.id, val)
                                    "
                                  >
                                    <template
                                      v-slot:selection="{ item, index }"
                                    >
                                      <v-chip
                                        small
                                        v-if="index < 2"
                                        class="mr-1 mt-2"
                                      >
                                        {{ item.nome }}
                                      </v-chip>
                                      <span
                                        v-if="index === 2"
                                        class="grey--text text-caption ml-1 mt-2 d-inline-block"
                                      >
                                        (+{{
                                          getEtapaRef(
                                            servicoEditando,
                                            coluna.id,
                                          ).supervisores.length - 2
                                        }})
                                      </span>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="6"
                                  class="py-0 pb-2"
                                  v-if="coluna.nome === 'Preparação'"
                                >
                                  <v-select
                                    v-model="
                                      servicoEditando.autorizacaoRetirada
                                    "
                                    :items="autorizacoesRetiradas"
                                    item-text="nome"
                                    item-value="id"
                                    multiple
                                    label="Autorização de Retirada"
                                    outlined
                                    hide-details
                                    dense
                                  ></v-select>
                                </v-col>

                                <!-- Observações -->
                                <v-col cols="12" class="pb-0 mb-4">
                                  <v-textarea
                                    v-model="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .observacoes
                                    "
                                    label="Observações"
                                    outlined
                                    dense
                                    rows="3"
                                    auto-grow
                                    hide-details
                                  ></v-textarea>
                                </v-col>

                                <!-- Toggle para Ocorrência e Atividades -->
                                <v-col cols="12" sm="6" class="py-1">
                                  <v-btn
                                    outlined
                                    small
                                    color="primary"
                                    @click="toggleOcorrenciaEdicao(coluna.id)"
                                    block
                                  >
                                    <v-icon left small>
                                      {{
                                        etapasComOcorrencia.includes(coluna.id)
                                          ? "mdi-chevron-up"
                                          : "mdi-chevron-down"
                                      }}
                                    </v-icon>
                                    {{
                                      etapasComOcorrencia.includes(coluna.id)
                                        ? "Ocultar"
                                        : "Mostrar"
                                    }}
                                    Ocorrência
                                  </v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" class="py-1">
                                  <v-btn
                                    outlined
                                    small
                                    color="success"
                                    @click="toggleAtividades(coluna.id)"
                                    block
                                  >
                                    <v-icon left small>
                                      {{
                                        etapasComAtividades.includes(coluna.id)
                                          ? "mdi-chevron-up"
                                          : "mdi-chevron-down"
                                      }}
                                    </v-icon>
                                    {{
                                      etapasComAtividades.includes(coluna.id)
                                        ? "Ocultar"
                                        : "Mostrar"
                                    }}
                                    Atividades
                                  </v-btn>
                                </v-col>

                                <!-- Campos de Ocorrência (condicionais) -->
                                <template
                                  v-if="etapasComOcorrencia.includes(coluna.id)"
                                >
                                  <!-- Ocorrência -->
                                  <v-col cols="12" md="4" class="pt-2">
                                    <v-select
                                      :value="
                                        obterOpcaoOcorrencia(
                                          getEtapaRef(servicoEditando, coluna.id)
                                        )
                                      "
                                      :items="opcoesOcorrencia"
                                      label="Ocorrência"
                                      outlined
                                      dense
                                      clearable
                                      @change="
                                        selecionarOcorrencia(
                                          getEtapaRef(servicoEditando, coluna.id),
                                          $event
                                        )
                                      "
                                    ></v-select>
                                  </v-col>

                                  <v-col
                                    v-if="
                                      deveExibirDescricaoOcorrencia(
                                        getEtapaRef(servicoEditando, coluna.id)
                                      )
                                    "
                                    cols="12"
                                    md="4"
                                    class="pt-2"
                                  >
                                    <v-textarea
                                      v-model="
                                        getEtapaRef(servicoEditando, coluna.id)
                                          .ocorrenciaJustificativa
                                      "
                                      label="Descrição da ocorrência"
                                      outlined
                                      dense
                                      rows="2"
                                      auto-grow
                                      placeholder="Descreva a ocorrência..."
                                    ></v-textarea>
                                  </v-col>

                                  <!-- Tempo da Ocorrência -->
                                  <v-col cols="12" md="4" class="pt-2">
                                    <v-text-field
                                      v-model="
                                        getEtapaRef(servicoEditando, coluna.id)
                                          .tempoOcorrenciaFormatted
                                      "
                                      label="Tempo (hh:mm)"
                                      outlined
                                      dense
                                      type="time"
                                      step="60"
                                      placeholder="00:00"
                                      @input="
                                        updateTempoOcorrencia(coluna.id, $event)
                                      "
                                    ></v-text-field>
                                  </v-col>
                                </template>

                                <!-- Campos de Atividades (condicionais) -->
                                <template
                                  v-if="etapasComAtividades.includes(coluna.id)"
                                >
                                  <v-col cols="12" class="pt-2">
                                    <v-card outlined class="pa-3 mb-3">
                                      <h4 class="mb-2">
                                        Atividades da Etapa - {{ coluna.nome }}
                                      </h4>

                                      <!-- Formulário para adicionar nova atividade na etapa -->
                                      <v-row>
                                        <v-col cols="12">
                                          <v-card
                                            class="pa-3 mb-3"
                                            :id="`atividade-form-${coluna.id}`"
                                            elevation="0"
                                          >
                                            <v-row>
                                              <v-col cols="12" md="6">
                                                <!-- Modo de edição: mostrar campo de texto desabilitado com a atividade atual -->
                                                <template
                                                  v-if="modoEdicaoAtividade"
                                                >
                                                  <v-text-field
                                                    v-model="
                                                      novaAtividade.atividadeFunerariaDescricao
                                                    "
                                                    label="Atividade"
                                                    outlined
                                                    dense
                                                    readonly
                                                    persistent-hint
                                                  ></v-text-field>
                                                </template>
                                                <!-- Modo normal: mostrar select para escolher atividade -->
                                                <template v-else>
                                                  <v-select
                                                    v-model="
                                                      novaAtividade.atividadeFunerariaId
                                                    "
                                                    :items="
                                                      getAtividadesDisponiveisDaEtapa(
                                                        servicoEditando,
                                                        coluna.id,
                                                      )
                                                    "
                                                    item-text="descricao"
                                                    item-value="id"
                                                    label="Selecionar Atividade"
                                                    outlined
                                                    dense
                                                    :loading="
                                                      atividadesDisponiveis ==
                                                      null
                                                    "
                                                    :disabled="
                                                      !getAtividadesDisponiveisDaEtapa(
                                                        servicoEditando,
                                                        coluna.id,
                                                      ) ||
                                                      getAtividadesDisponiveisDaEtapa(
                                                        servicoEditando,
                                                        coluna.id,
                                                      ).length === 0
                                                    "
                                                  ></v-select>
                                                </template>
                                              </v-col>
                                              <v-col cols="12" md="6">
                                                <v-text-field
                                                  v-model="
                                                    novaAtividade.dtInicio
                                                  "
                                                  label="Data/Hora Início"
                                                  type="datetime-local"
                                                  outlined
                                                  dense
                                                ></v-text-field>
                                              </v-col>
                                              <v-col cols="12" md="6">
                                                <v-text-field
                                                  v-model="novaAtividade.dtFim"
                                                  label="Data/Hora Fim"
                                                  type="datetime-local"
                                                  outlined
                                                  dense
                                                ></v-text-field>
                                              </v-col>
                                              <v-col cols="12" md="6">
                                                <v-autocomplete
                                                  v-model="
                                                    novaAtividade.colaboradores
                                                  "
                                                  :items="listaColaboradores"
                                                  item-text="nome"
                                                  item-value="id"
                                                  label="Colaboradores"
                                                  multiple
                                                  clearable
                                                  chips
                                                  small-chips
                                                  deletable-chips
                                                  outlined
                                                  dense
                                                >
                                                  <template
                                                    v-slot:selection="{
                                                      item,
                                                      index,
                                                    }"
                                                  >
                                                    <v-chip
                                                      small
                                                      v-if="index < 2"
                                                      class="mr-1 mt-2"
                                                    >
                                                      {{ item.nome }}
                                                    </v-chip>
                                                    <span
                                                      v-if="
                                                        index === 2 &&
                                                        getNovaAtividadeEtapaColaboradores(
                                                          coluna.id,
                                                        ).length > 2
                                                      "
                                                      class="grey--text text-caption ml-1 mt-2 d-inline-block"
                                                    >
                                                      (+{{
                                                        getNovaAtividadeEtapaColaboradores(
                                                          coluna.id,
                                                        ).length - 2
                                                      }})
                                                    </span>
                                                  </template>
                                                </v-autocomplete>
                                              </v-col>
                                            </v-row>
                                            <!-- dialog etapas operacionais -->
                                            <v-row>
                                              <v-col
                                                cols="12"
                                                class="text-right"
                                              >
                                                <v-btn
                                                  v-if="modoEdicaoAtividade"
                                                  color="red"
                                                  text
                                                  small
                                                  class="mr-2"
                                                  @click="
                                                    cancelarEdicaoAtividade
                                                  "
                                                  :disabled="
                                                    salvandoAtividadeEtapa ===
                                                    coluna.id
                                                  "
                                                >
                                                  Cancelar
                                                </v-btn>
                                                <v-btn
                                                  color="primary"
                                                  small
                                                  @click="
                                                    modoEdicaoAtividade
                                                      ? atualizarAtividade(
                                                          coluna.id,
                                                        )
                                                      : salvarAtividade(
                                                          coluna.id,
                                                          servicoEditando.id,
                                                        )
                                                  "
                                                  :loading="
                                                    salvandoAtividadeEtapa ===
                                                    coluna.id
                                                  "
                                                  :disabled="
                                                    !atividadeCompleta(
                                                      novaAtividade,
                                                    ) || !hasPermissionEdit
                                                  "
                                                >
                                                  <v-icon left>{{
                                                    modoEdicaoAtividade
                                                      ? "mdi-content-save"
                                                      : "mdi-plus"
                                                  }}</v-icon>
                                                  {{
                                                    modoEdicaoAtividade
                                                      ? "Atualizar Atividade"
                                                      : "Salvar Atividade"
                                                  }}
                                                </v-btn>
                                              </v-col>
                                            </v-row>
                                          </v-card>
                                        </v-col>
                                      </v-row>

                                      <!-- Tabela de atividades — desktop -->
                                      <v-data-table
                                        v-if="!isMobile"
                                        :headers="atividadesHeadersv2"
                                        :items="
                                          getAtividadesDaEtapa(
                                            servicoEditando,
                                            coluna.id,
                                          )
                                        "
                                        hide-default-footer
                                        dense
                                        class="elevation-0"
                                        :no-data-text="'Nenhuma atividade registrada nesta etapa'"
                                      >
                                        <template
                                          v-slot:item.detalhes="{ item }"
                                        >
                                          <div class="d-flex flex-column py-1">
                                            <span
                                              class="text-caption grey--text"
                                              >Atividade</span
                                            >
                                            <span class="font-weight-medium">{{
                                              item.atividadeFunerariaDescricao ||
                                              "-"
                                            }}</span>
                                            <span
                                              class="text-caption grey--text"
                                              >Início</span
                                            >
                                            <span class="font-weight-medium">{{
                                              formatarDataHora(item.dtInicio) ||
                                              "-"
                                            }}</span>
                                            <span
                                              class="text-caption grey--text mt-2"
                                              >Fim</span
                                            >
                                            <span class="font-weight-medium">{{
                                              formatarDataHora(item.dtFim) ||
                                              "-"
                                            }}</span>
                                            <span
                                              class="text-caption grey--text mt-2"
                                              >Colaboradores</span
                                            >
                                            <div
                                              v-if="item.colaboradores?.length"
                                            >
                                              <v-chip
                                                v-for="colaborador in item.colaboradores.slice(
                                                  0,
                                                  2,
                                                )"
                                                :key="colaborador.colaboradorId"
                                                x-small
                                                class="mr-1 mb-1"
                                              >
                                                {{
                                                  getNomeColaborador(
                                                    colaborador.colaboradorId,
                                                  )
                                                }}
                                              </v-chip>
                                              <span
                                                v-if="
                                                  item.colaboradores.length > 2
                                                "
                                                class="grey--text text-caption"
                                                >(+{{
                                                  item.colaboradores.length - 2
                                                }})</span
                                              >
                                            </div>
                                            <span
                                              v-else
                                              class="grey--text text-caption"
                                              >-</span
                                            >
                                          </div>
                                        </template>
                                        <template v-slot:item.acoes="{ item }">
                                          <div class="d-flex align-center">
                                            <v-btn
                                              text
                                              small
                                              color="primary"
                                              class="mr-1"
                                              @click="editarAtividade(item)"
                                              :disabled="
                                                editandoAtividade ||
                                                !hasPermissionEdit
                                              "
                                            >
                                              <v-icon x-small
                                                >mdi-pencil</v-icon
                                              >
                                            </v-btn>
                                            <v-btn
                                              text
                                              small
                                              color="error"
                                              @click="excluirAtividade(item.id)"
                                              :loading="
                                                excluindoAtividade === item.id
                                              "
                                              :disabled="!hasPermissionEdit"
                                            >
                                              <v-icon x-small
                                                >mdi-delete</v-icon
                                              >
                                            </v-btn>
                                          </div>
                                        </template>
                                      </v-data-table>
                                      <!-- Mobile: cards -->
                                      <template v-else>
                                        <div
                                          v-if="
                                            getAtividadesDaEtapa(
                                              servicoEditando,
                                              coluna.id,
                                            ).length === 0
                                          "
                                          class="text-caption grey--text text-center py-3"
                                        >
                                          Nenhuma atividade registrada nesta
                                          etapa
                                        </div>
                                        <v-card
                                          v-for="item in getAtividadesDaEtapa(
                                            servicoEditando,
                                            coluna.id,
                                          )"
                                          :key="item.id"
                                          outlined
                                          class="mb-2 pa-3"
                                        >
                                          <div
                                            class="font-weight-medium text-body-2 mb-1"
                                          >
                                            {{
                                              item.atividadeFunerariaDescricao
                                            }}
                                          </div>
                                          <div class="text-caption grey--text">
                                            Início:
                                            <span class="black--text">{{
                                              formatarDataHora(item.dtInicio) ||
                                              "-"
                                            }}</span>
                                          </div>
                                          <div class="text-caption grey--text">
                                            Fim:
                                            <span class="black--text">{{
                                              formatarDataHora(item.dtFim) ||
                                              "-"
                                            }}</span>
                                          </div>
                                          <div
                                            class="mt-1"
                                            v-if="
                                              item.colaboradores &&
                                              item.colaboradores.length
                                            "
                                          >
                                            <v-chip
                                              v-for="colaborador in item.colaboradores.slice(
                                                0,
                                                3,
                                              )"
                                              :key="colaborador.colaboradorId"
                                              x-small
                                              class="mr-1 mt-1"
                                              >{{
                                                getNomeColaborador(
                                                  colaborador.colaboradorId,
                                                )
                                              }}</v-chip
                                            >
                                            <span
                                              v-if="
                                                item.colaboradores.length > 3
                                              "
                                              class="grey--text text-caption"
                                              >(+{{
                                                item.colaboradores.length - 3
                                              }})</span
                                            >
                                          </div>
                                          <div
                                            class="d-flex mt-2"
                                            v-if="hasPermissionEdit"
                                          >
                                            <v-btn
                                              x-small
                                              outlined
                                              color="primary"
                                              class="mr-2"
                                              @click="editarAtividade(item)"
                                              :disabled="!!editandoAtividade"
                                            >
                                              <v-icon x-small left
                                                >mdi-pencil</v-icon
                                              >
                                              Editar
                                            </v-btn>
                                            <v-btn
                                              x-small
                                              outlined
                                              color="error"
                                              @click="excluirAtividade(item.id)"
                                              :loading="
                                                excluindoAtividade === item.id
                                              "
                                            >
                                              <v-icon x-small left
                                                >mdi-delete</v-icon
                                              >
                                              Excluir
                                            </v-btn>
                                          </div>
                                        </v-card>
                                      </template>
                                    </v-card>
                                  </v-col>
                                  <v-col cols="12">
                                    <!-- Checklist de atividades -->
                                    <v-row class="mt-0">
                                      <v-col cols="12">
                                        <v-card outlined class="pa-4">
                                          <h4 class="mb-3">
                                            Checklist de Atividades da Etapa
                                          </h4>

                                          <div
                                            v-if="
                                              getTodasAtividadesDisponiveis(
                                                coluna.id,
                                              ).length > 0
                                            "
                                          >
                                            <v-checkbox
                                              v-for="atividade in getTodasAtividadesDisponiveis(
                                                coluna.id,
                                              )"
                                              :key="atividade.id"
                                              :label="atividade.descricao"
                                              :input-value="
                                                isAtividadeCadastrada(
                                                  atividade.id,
                                                  coluna.id,
                                                )
                                              "
                                              disabled
                                              color="success"
                                              class="my-0"
                                            >
                                              <template v-slot:label>
                                                <span
                                                  :class="
                                                    isAtividadeCadastrada(
                                                      atividade.id,
                                                      coluna.id,
                                                    )
                                                      ? 'success--text font-weight-bold'
                                                      : 'grey--text'
                                                  "
                                                >
                                                  {{ atividade.descricao }}
                                                  <v-chip
                                                    v-if="
                                                      isAtividadeCadastrada(
                                                        atividade.id,
                                                        coluna.id,
                                                      )
                                                    "
                                                    x-small
                                                    color="success"
                                                    text-color="white"
                                                    class="ml-2"
                                                  >
                                                    ✓ Cadastrada
                                                  </v-chip>
                                                </span>
                                              </template>
                                            </v-checkbox>
                                          </div>
                                          <div
                                            v-else
                                            class="text-center grey--text"
                                          >
                                            Nenhuma atividade disponível para
                                            esta etapa
                                          </div>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </template>

                                <v-row
                                  v-if="coluna.nome === 'Transporte familiar'"
                                  class="mt-4"
                                >
                                  <v-col cols="12" class="my-2 py-0">
                                    <h3 class="mb-2 primary--text">
                                      Transporte
                                    </h3>
                                    <v-divider></v-divider>
                                    <p class="text-caption grey--text mb-2">
                                      Informações sobre transporte e
                                      autorizações.
                                    </p>
                                  </v-col>

                                  <!-- Solicitação de Transporte Familiar -->
                                  <v-col cols="12" md="6" class="py-0">
                                    <v-select
                                      v-model="
                                        servicoEditando.solicitacaoTransporteFamiliar
                                      "
                                      :items="[
                                        'A DEFINIR',
                                        'SOLICITADO',
                                        'SOLICITADO PARCIALMENTE',
                                        'DISPENSADO',
                                        'NÃO DISPONIBILIZADO FORA ÁREA DE COBERTURA',
                                      ]"
                                      label="Solicitação de Transporte Familiar"
                                      outlined
                                      dense
                                      @change="
                                        ajustarCamposTransporteFamiliar(
                                          servicoEditando,
                                        )
                                      "
                                    ></v-select>
                                  </v-col>

                                  <!-- Tipo de Transporte Familiar -->
                                  <v-col cols="12" md="6" class="py-0">
                                    <v-select
                                      v-model="
                                        servicoEditando.tipoTransporteFamiliar
                                      "
                                      label="Tipo de Transporte Familiar"
                                      outlined
                                      dense
                                      :items="[
                                        'FROTA PRÓPRIA',
                                        'FROTA TERCEIRIZADA',
                                      ]"
                                      :disabled="
                                        !(
                                          servicoEditando.solicitacaoTransporteFamiliar ||
                                          ''
                                        ).includes('SOLICITADO')
                                      "
                                    ></v-select>
                                  </v-col>
                                  <v-col
                                    cols="6"
                                    md="6"
                                    class="py-0"
                                    v-if="
                                      servicoEditando.solicitacaoTransporteFamiliar ===
                                      'SOLICITADO PARCIALMENTE'
                                    "
                                  >
                                    <v-checkbox
                                      v-model="
                                        servicoEditando.idaTransporteFamiliar
                                      "
                                      label="Ida de Transporte Familiar"
                                      outlined
                                      dense
                                    ></v-checkbox>
                                  </v-col>
                                  <v-col
                                    cols="6"
                                    md="6"
                                    class="py-0"
                                    v-if="
                                      servicoEditando.solicitacaoTransporteFamiliar ===
                                      'SOLICITADO PARCIALMENTE'
                                    "
                                  >
                                    <v-checkbox
                                      v-model="
                                        servicoEditando.voltaTransporteFamiliar
                                      "
                                      label="Volta de Transporte Familiar"
                                      outlined
                                      dense
                                    ></v-checkbox>
                                  </v-col>

                                  <!-- Origem do Transporte Familiar -->
                                  <v-col cols="12" md="6" class="py-0">
                                    <v-text-field
                                      v-model="
                                        servicoEditando.origemTransporteFamiliar
                                      "
                                      label="Origem do Transporte Familiar"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </v-col>

                                  <!-- Destino do Transporte Familiar -->
                                  <v-col cols="12" md="6" class="py-0">
                                    <v-text-field
                                      v-model="
                                        servicoEditando.destinoTransporteFamiliar
                                      "
                                      label="Destino do Transporte Familiar"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" md="6" class="py-0">
                                    <v-text-field
                                      v-model="
                                        servicoEditando.linkidaTransporteFamiliar
                                      "
                                      label="Link da ida"
                                      outlined
                                      dense
                                      prepend-inner-icon="mdi-link-variant"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" md="6" class="py-0">
                                    <v-text-field
                                      v-model="
                                        servicoEditando.linkvoltaTransporteFamiliar
                                      "
                                      label="Link da volta"
                                      outlined
                                      dense
                                      prepend-inner-icon="mdi-link-variant"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" md="12" class="py-0">
                                    <v-textarea
                                      v-model="
                                        servicoEditando.observacoesTransporteFamiliar
                                      "
                                      rows="2"
                                      label="Observações do Transporte Familiar"
                                      outlined
                                      dense
                                    ></v-textarea>
                                  </v-col>
                                </v-row>
                              </v-row>
                              <v-row
                                v-if="coluna.nome === 'Velório'"
                                class="mt-4"
                              >
                                <v-col cols="12" class="my-2 pb-0">
                                  <h3 class="mb-2 primary--text">
                                    Velório e Sepultamento
                                  </h3>
                                  <v-divider></v-divider>
                                  <p class="text-caption grey--text mb-2">
                                    Informações sobre velório e sepultamento.
                                  </p>
                                </v-col>

                                <!-- Local do Velório -->
                                <v-col cols="12" md="6" class="py-0">
                                  <v-text-field
                                    v-model="servicoEditando.localVelorio"
                                    label="Local do Velório"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>

                                <!-- Local do Sepultamento -->
                                <v-col cols="12" md="6" class="py-0">
                                  <v-text-field
                                    v-model="servicoEditando.localSepultamento"
                                    label="Local do Sepultamento"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>

                                <!-- Data do Sepultamento -->
                                <v-col cols="12" md="6" class="py-0">
                                  <v-text-field
                                    v-model="servicoEditando.dataSepultamento"
                                    label="Data e Hora do Sepultamento"
                                    type="datetime-local"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="!modoCriacaoManual">
            <v-card flat>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" class="my-2 pb-0">
                      <h3 class="mb-2 primary--text">
                        Histórico de Alterações
                      </h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Registro de alterações realizadas neste atendimento.
                      </p>
                    </v-col>
                  </v-row>

                  <v-data-table
                    :headers="historicoHeaders"
                    :items="historico"
                    :items-per-page="10"
                    class="mt-2"
                    :footer-props="{
                      'items-per-page-options': [10, 25, 50, 100],
                      'items-per-page-text': 'Registros por página',
                    }"
                    fixed-header
                    :loading="historico == null"
                    loading-text="Carregando histórico..."
                    no-data-text="Nenhum registro de histórico encontrado"
                  >
                    <!-- Linha customizada com classes -->
                    <template v-slot:item="{ item, index }">
                      <tr :class="[index % 2 === 0 ? 'cor-row' : '']">
                        <td
                          class="linha"
                          style="font-size: 12px; font-weight: 100"
                        >
                          {{ item.campoAlterado }}
                        </td>
                        <td class="linha" style="width: 15%">
                          {{ item.valorAntigo }}
                        </td>
                        <td class="linha" style="width: 15%">
                          {{ item.valorNovo }}
                        </td>
                        <td class="linha">{{ item.dataAlteracao }}</td>
                        <td class="linha">
                          {{ truncateString(item.usuarioResponsavel, 20) }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="!modoCriacaoManual">
            <v-card flat>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" class="my-2 pb-0">
                      <div
                        class="d-flex flex-wrap justify-space-between align-center mb-2"
                        style="gap: 4px 12px"
                      >
                        <h3 class="mb-0 primary--text">
                          Procedimentos do Atendimento
                        </h3>
                        <span class="text-caption grey--text text-no-wrap">
                          {{ procedimentosEdicao.length }} procedimento(s)
                        </span>
                      </div>
                      <v-divider></v-divider>
                      <div
                        class="d-flex flex-wrap justify-space-between align-center mt-2"
                        style="gap: 8px 12px"
                      >
                        <p class="text-caption grey--text mb-0">
                          Procedimentos disponíveis para este atendimento.
                        </p>
                        <v-chip
                          small
                          class="flex-shrink-0"
                          :color="
                            filtroProcedimentosPendentes ? 'orange' : 'default'
                          "
                          :text-color="
                            filtroProcedimentosPendentes ? 'white' : undefined
                          "
                          :outlined="!filtroProcedimentosPendentes"
                          @click="
                            filtroProcedimentosPendentes =
                              !filtroProcedimentosPendentes;
                            paginaProcedimentos = 1;
                          "
                        >
                          <v-icon small left>
                            {{
                              filtroProcedimentosPendentes
                                ? "mdi-checkbox-marked"
                                : "mdi-checkbox-blank-outline"
                            }}
                          </v-icon>
                          Sem resposta ({{ procedimentosSemRespostaCount }})
                        </v-chip>
                      </div>
                    </v-col>
                  </v-row>

                  <v-progress-linear
                    v-if="carregandoProcedimentosEdicao"
                    indeterminate
                    color="primary"
                    class="mb-4"
                  ></v-progress-linear>

                  <!-- Lista de procedimentos -->
                  <v-row v-if="procedimentosEdicao.length > 0">
                    <v-col cols="12" class="px-0">
                      <div class="procedimentos-lista">
                        <div
                          v-for="(
                            procedimento, index
                          ) in procedimentosEdicaoPaginados"
                          :key="procedimento.procedimentoId || index"
                          :class="[
                            'procedimento-linha',
                            index % 2 === 0
                              ? 'procedimento-linha-par'
                              : 'procedimento-linha-impar',
                            !procedimento.resposta
                              ? 'procedimento-linha-pendente'
                              : '',
                          ]"
                        >
                          <div class="procedimento-conteudo">
                            <div class="procedimento-info">
                              <div class="procedimento-descricao">
                                {{ procedimento.descricao }}
                              </div>
                              <div class="procedimento-resposta">
                                <v-chip
                                  v-if="procedimento.resposta"
                                  small
                                  outlined
                                  :color="
                                    procedimento.resposta === 'nao'
                                      ? 'error'
                                      : 'primary'
                                  "
                                >
                                  {{
                                    procedimento.resposta === "nao"
                                      ? "NÃO"
                                      : procedimento.resposta.toUpperCase()
                                  }}
                                </v-chip>
                                <v-chip v-else small outlined color="grey">
                                  Sem resposta
                                </v-chip>
                                <div
                                  v-if="procedimento.observacoes"
                                  class="text-caption grey--text mt-1"
                                >
                                  {{ procedimento.observacoes }}
                                </div>
                              </div>
                            </div>

                            <div
                              v-if="hasPermissionEdit"
                              class="procedimento-acoes"
                            >
                              <template
                                v-if="
                                  !procedimento.resposta &&
                                  procedimento.tipo === 'sim_nao'
                                "
                              >
                                <v-btn
                                  v-for="opcao in opcoesRespostaSimNao"
                                  :key="opcao.valor"
                                  small
                                  :color="opcao.cor"
                                  :outlined="
                                    !ehRespostaPadraoProcedimento(
                                      procedimento,
                                      opcao.valor,
                                    )
                                  "
                                  :depressed="
                                    ehRespostaPadraoProcedimento(
                                      procedimento,
                                      opcao.valor,
                                    )
                                  "
                                  class="mr-2"
                                  :loading="
                                    salvandoRespostaRapida ===
                                    `${procedimento.procedimentoId}:${opcao.valor}`
                                  "
                                  :disabled="
                                    carregandoProcedimentosEdicao ||
                                    !!salvandoRespostaRapida
                                  "
                                  @click="
                                    responderProcedimentoRapido(
                                      procedimento,
                                      opcao.valor,
                                    )
                                  "
                                >
                                  <v-icon small left>{{ opcao.icone }}</v-icon>
                                  {{ opcao.texto }}
                                </v-btn>
                              </template>
                              <v-btn
                                v-else-if="!procedimento.resposta"
                                small
                                color="primary"
                                outlined
                                class="mr-2"
                                :disabled="carregandoProcedimentosEdicao"
                                @click="
                                  abrirDialogProcedimento(
                                    procedimento,
                                    'responder',
                                  )
                                "
                              >
                                <v-icon small left>mdi-comment-edit</v-icon>
                                Responder
                              </v-btn>
                              <template v-else>
                                <v-btn
                                  v-if="procedimento.tipo !== 'sim_nao'"
                                  small
                                  color="primary"
                                  outlined
                                  class="mr-2"
                                  title="Editar resposta"
                                  :disabled="carregandoProcedimentosEdicao"
                                  @click="
                                    abrirDialogProcedimento(
                                      procedimento,
                                      'editar',
                                    )
                                  "
                                >
                                  <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn
                                  small
                                  color="orange"
                                  outlined
                                  class="mr-2"
                                  title="Limpar resposta"
                                  :disabled="carregandoProcedimentosEdicao"
                                  @click="
                                    confirmarResetProcedimento(procedimento)
                                  "
                                >
                                  <v-icon small>mdi-eraser</v-icon>
                                </v-btn>
                              </template>
                              <v-btn
                                small
                                color="blue-grey"
                                outlined
                                title="Observação"
                                :disabled="
                                  carregandoProcedimentosEdicao ||
                                  !!salvandoRespostaRapida
                                "
                                @click="
                                  abrirDialogProcedimento(
                                    procedimento,
                                    'observacao',
                                  )
                                "
                              >
                                <v-icon small>
                                  {{
                                    procedimento.observacoes
                                      ? "mdi-comment-text"
                                      : "mdi-comment-text-outline"
                                  }}
                                </v-icon>
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="
                      filtroProcedimentosPendentes &&
                      procedimentosEdicao.length > 0 &&
                      procedimentosEdicaoFiltrados.length === 0 &&
                      !carregandoProcedimentosEdicao
                    "
                  >
                    <v-col cols="12" class="text-center grey--text py-6">
                      <v-icon large class="mb-2 success--text">
                        mdi-check-all
                      </v-icon>
                      <div>Todos os procedimentos foram respondidos.</div>
                    </v-col>
                  </v-row>

                  <v-row v-if="procedimentosEdicaoFiltrados.length > 10">
                    <v-col cols="12" class="d-flex justify-center pb-2">
                      <v-pagination
                        v-model="paginaProcedimentos"
                        :length="Math.ceil(procedimentosEdicaoFiltrados.length / 10)"
                        total-visible="5"
                        dense
                      ></v-pagination>
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="
                      procedimentosEdicao.length === 0 &&
                      !carregandoProcedimentosEdicao
                    "
                  >
                    <v-col cols="12" class="text-center grey--text py-6">
                      <v-icon large class="mb-2 grey--text">
                        mdi-clipboard-text-outline
                      </v-icon>
                      <div>Nenhum procedimento disponível.</div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <v-alert
          v-if="servicoEditando?.isExcluido"
          type="error"
          text
          dense
          class="mx-6 mt-3 mb-2"
        >
          <div>
            <strong>Excluído por:</strong>
            {{ servicoEditando.excluidoPor || "Não informado" }}
          </div>
          <div>
            <strong>Excluído em:</strong>
            {{ formatarDataHoraExclusao(servicoEditando.excluidoEm) }}
          </div>
        </v-alert>

        <v-card-actions class="px-6 pb-4">
          <v-btn
            v-if="!modoCriacaoManual"
            color="error"
            outlined
            small
            :disabled="!podeExcluirAtendimento || servicoEditando?.isExcluido"
            @click="abrirDialogExcluirAtendimento"
          >
            <v-icon small left>mdi-delete-outline</v-icon>
            Excluir
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text small @click="fecharDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            small
            @click="salvarEdicao"
            v-if="
              (modoCriacaoManual && hasPermissionCreate) ||
              (!modoCriacaoManual && hasPermissionEdit && (tab === 0 || tab === 2))
            "
          >
            {{ modoCriacaoManual ? "Criar Atendimento" : "Salvar Alterações" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSincronizacaoIvertex" max-width="980">
      <v-card>
        <v-card-title class="primary white--text">
          Revisar dados do iVertex
        </v-card-title>
        <v-card-text class="pt-4">
          <v-data-table
            :headers="headersSincronizacaoIvertex"
            :items="diferencasIvertex"
            item-key="campo"
            dense
            disable-pagination
            hide-default-footer
          >
            <template v-slot:item.selecionado="{ item }">
              <v-checkbox
                v-model="item.selecionado"
                dense
                hide-details
              ></v-checkbox>
            </template>
            <template v-slot:item.valorAtual="{ item }">
              <span>{{ item.valorAtualExibicao || "-" }}</span>
            </template>
            <template v-slot:item.valorIvertex="{ item }">
              <span>{{ item.valorIvertexExibicao || "-" }}</span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="dialogSincronizacaoIvertex = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!diferencasIvertex.some((d) => d.selecionado)"
            @click="aplicarDiferencasIvertex"
          >
            Aplicar selecionados
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG DE ETAPA ESPECÍFICA (PLAY/CHECK) -->
    <v-dialog v-model="dialogExcluirAtendimento" persistent max-width="520">
      <v-card>
        <v-card-title class="text-h5 error--text">
          Excluir atendimento
        </v-card-title>
        <v-card-text>
          <p class="mb-2">
            O atendimento
            <strong>{{ formatarCodigoAtendimento(servicoEditando) }}</strong>
            será excluído do Fluxo Funerário.
          </p>
          <p class="mb-2" v-if="servicoEditando?.nomeFalecido">
            Falecido: <strong>{{ servicoEditando.nomeFalecido }}</strong>
          </p>
          <p class="mb-4">
            A exclusão é lógica: o histórico será mantido e o registro não
            aparecerá na listagem normal.
          </p>
          <v-checkbox
            v-model="confirmarExclusaoAtendimento"
            label="Estou ciente e confirmo a exclusão deste atendimento"
            color="error"
            hide-details
          ></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-1"
            :disabled="excluindoAtendimento"
            @click="fecharDialogExcluirAtendimento"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="error"
            :loading="excluindoAtendimento"
            :disabled="!confirmarExclusaoAtendimento"
            @click="excluirAtendimentoConfirmado"
          >
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEtapa" max-width="1000px" persistent>
      <v-card>
        <v-card-title class="text-h3">
          <h3
            class="mb-2"
            :class="etapaAcao === 'iniciar' ? 'primary--text' : 'success--text'"
          >
            {{ etapaAcao === "iniciar" ? "Iniciar" : "Finalizar" }} etapa <br />
          </h3>

          <v-divider></v-divider>

          <p class="text-caption grey--text mb-2">
            {{
              etapaAcao === "iniciar"
                ? "Registrar início"
                : "Registrar conclusão"
            }}
            da etapa
            <v-chip
              :color="etapaAtual?.cor"
              x-small
              class="ml-1"
              text-color="white"
              >{{ etapaAtual?.nome }}</v-chip
            >
          </p>
          <p>{{ servicoAtual?.nomeFalecido }}</p>
        </v-card-title>

        <v-card-text class="pt-0">
          <v-container>
            <v-row v-if="etapaAtual?.nome === 'Preparação'">
              <v-col cols="12" class="my-2 py-0">
                <h3 class="mb-2 primary--text">Somatoconservação</h3>
                <v-divider></v-divider>
                <p class="text-caption grey--text mb-2">
                  Informações sobre somatoconservação.
                </p>
              </v-col>

              <!-- Uso de Somatoconservação -->
              <v-col cols="12" md="6" class="py-0">
                <v-select
                  v-model="servicoAtual.usoSomatoConservacao"
                  :items="[
                    { text: 'Sim', value: true },
                    { text: 'Não', value: false },
                  ]"
                  item-text="text"
                  item-value="value"
                  label="Uso de Somatoconservação"
                  outlined
                  dense
                ></v-select>
              </v-col>

              <!-- Data de Início da Somatoconservação -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.dataInicioSomato"
                  label="Data de Início da Somatoconservação"
                  type="datetime-local"
                  outlined
                  dense
                  :disabled="!servicoAtual.usoSomatoConservacao"
                ></v-text-field>
              </v-col>

              <!-- Data de Fim da Somatoconservação -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.dataFimSomato"
                  label="Data de Fim da Somatoconservação"
                  type="datetime-local"
                  outlined
                  dense
                  :disabled="!servicoAtual.usoSomatoConservacao"
                ></v-text-field>
              </v-col>

              <v-col cols="6" md="6" class="py-0">
                <v-autocomplete
                  :disabled="!servicoAtual.usoSomatoConservacao"
                  v-model="colaboradoresTempSomato"
                  :items="listaColaboradores"
                  item-text="nome"
                  item-value="id"
                  :label="`Colaboradores`"
                  multiple
                  clearable
                  chips
                  small-chips
                  deletable-chips
                  outlined
                  dense
                  height="60px"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip small v-if="index < 2" class="mr-1 mt-2">
                      {{ item.nome }}
                    </v-chip>
                    <span
                      v-if="index === 2"
                      class="grey--text text-caption ml-1 mt-2 d-inline-block"
                    >
                      (+{{ colaboradoresTempSomato.length - 2 }})
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                class="my-2 py-0"
                v-if="etapaAtual?.nome === 'Preparação'"
              >
                <h3 class="mb-2 primary--text">Preparação</h3>
                <v-divider></v-divider>
                <p class="text-caption grey--text mb-2">
                  Informações sobre início e fim da etapa.
                </p>
              </v-col>
              <!-- Data e Hora -->
              <v-col cols="12">
                <v-text-field
                  v-model="etapaDadosTemp.dataHoraInicio"
                  label="Data/Hora de Início"
                  type="datetime-local"
                  dense
                  outlined
                  hide-details
                />
              </v-col>

              <!-- Data e Hora -->
              <v-col cols="12">
                <v-text-field
                  v-model="etapaDadosTemp.dataHoraFim"
                  label="Data/Hora de Conclusão"
                  type="datetime-local"
                  dense
                  outlined
                  hide-details
                />
              </v-col>

              <!-- VTR -->
              <v-col
                cols="6"
                class="pt-0"
                v-if="etapaAtual?.nome !== 'Preparação'"
              >
                <v-select
                  v-model="etapaDadosTemp.vtr"
                  label="Viatura"
                  dense
                  outlined
                  hide-details
                  :items="viaturasLista"
                />
              </v-col>

              <v-col
                cols="6"
                class="pt-0"
                v-if="etapaAtual?.nome === 'Preparação'"
              >
                <v-text-field
                  v-model="etapaDadosTemp.salaPreparacao"
                  label="Sala de Preparação"
                  dense
                  outlined
                  hide-details
                />
              </v-col>

              <v-col
                cols="12"
                md="6"
                class="py-0"
                v-if="etapaAtual?.nome === 'Preparação'"
              >
                <v-select
                  v-model="servicoAtual.autorizacaoRetirada"
                  :items="autorizacoesRetiradas"
                  item-text="nome"
                  item-value="id"
                  multiple
                  label="Autorização de Retirada"
                  outlined
                  hide-details
                  dense
                ></v-select>
              </v-col>

              <!-- Colaboradores -->
              <v-col cols="10" md="10" class="pb-0">
                <v-autocomplete
                  v-model="etapaDadosTemp.colaboradores"
                  :items="listaColaboradores"
                  item-text="nome"
                  item-value="id"
                  :label="`Colaboradores`"
                  multiple
                  clearable
                  chips
                  small-chips
                  deletable-chips
                  hide-details
                  outlined
                  dense
                  height="60px"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip small v-if="index < 2" class="mr-1 mt-2">
                      {{ item.nome }}
                    </v-chip>
                    <span
                      v-if="index === 2"
                      class="grey--text text-caption ml-1 mt-2 d-inline-block"
                    >
                      (+{{ etapaDadosTemp.colaboradores.length - 2 }})
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="2" md="2">
                <v-btn color="primary" small @click="adicionarColaboradorInput">
                  <v-icon>mdi-account-group</v-icon>
                </v-btn>
              </v-col>

              <!-- Supervisores -->
              <v-col cols="12" class="pb-0">
                <v-autocomplete
                  v-model="etapaDadosTemp.supervisores"
                  :items="listaColaboradores"
                  item-text="nome"
                  item-value="id"
                  :label="`Supervisores`"
                  multiple
                  clearable
                  chips
                  hide-details
                  small-chips
                  deletable-chips
                  outlined
                  dense
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip small v-if="index < 2" class="mr-1 mt-2">
                      {{ item.nome }}
                    </v-chip>
                    <span
                      v-if="index === 2"
                      class="grey--text text-caption ml-1 mt-2 d-inline-block"
                    >
                      (+{{ etapaDadosTemp.supervisores.length - 2 }})
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>

              <!-- Observações -->
              <v-col cols="12">
                <v-textarea
                  v-model="etapaDadosTemp.observacoes"
                  label="Observações"
                  outlined
                  hide-details
                  dense
                  rows="3"
                  auto-grow
                ></v-textarea>
              </v-col>

              <!-- Toggle para Ocorrência e Atividades -->
              <v-col cols="12" sm="6" class="py-1">
                <v-btn
                  outlined
                  small
                  color="primary"
                  @click="toggleOcorrenciaEtapa"
                  block
                >
                  <v-icon left small>
                    {{
                      etapasComOcorrencia.includes(etapaAtual?.id)
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}
                  </v-icon>
                  {{
                    etapasComOcorrencia.includes(etapaAtual?.id)
                      ? "Ocultar"
                      : "Mostrar"
                  }}
                  Ocorrência
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" class="py-1 mb-4">
                <v-btn
                  outlined
                  small
                  color="success"
                  @click="toggleAtividades(etapaAtual?.id)"
                  block
                >
                  <v-icon left small>
                    {{
                      etapasComAtividades.includes(etapaAtual?.id)
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}
                  </v-icon>
                  {{
                    etapasComAtividades.includes(etapaAtual?.id)
                      ? "Ocultar"
                      : "Mostrar"
                  }}
                  Atividades
                </v-btn>
              </v-col>

              <template v-if="etapasComAtividades.includes(etapaAtual?.id)">
                <v-col cols="12" class="pt-0">
                  <v-card flat class="pa-3 pt-0">
                    <!-- Formulário para adicionar nova atividade -->
                    <v-row class="mt-3">
                      <v-col cols="12" class="py-0">
                        <h4>
                          {{
                            modoEdicaoAtividade
                              ? "Editar Atividade"
                              : "Adicionar Nova Atividade"
                          }}
                        </h4>
                      </v-col>
                      <v-col cols="12" md="6">
                        <!-- Modo de edição: mostrar campo de texto desabilitado com a atividade atual -->
                        <template v-if="modoEdicaoAtividade">
                          <v-text-field
                            v-model="novaAtividade.atividadeFunerariaDescricao"
                            label="Atividade"
                            outlined
                            dense
                            readonly
                            persistent-hint
                            hide-details
                          ></v-text-field>
                        </template>
                        <!-- Modo normal: mostrar select para escolher atividade -->
                        <template v-else>
                          <v-select
                            v-model="novaAtividade.atividadeFunerariaId"
                            :items="
                              getAtividadesDisponiveisDaEtapa(
                                servicoAtual,
                                etapaAtual?.id,
                              )
                            "
                            item-text="descricao"
                            item-value="id"
                            label="Atividade"
                            outlined
                            dense
                            hide-details
                            :disabled="
                              !getAtividadesDisponiveisDaEtapa(
                                servicoAtual,
                                etapaAtual?.id,
                              ) ||
                              getAtividadesDisponiveisDaEtapa(
                                servicoAtual,
                                etapaAtual?.id,
                              ).length === 0
                            "
                          ></v-select>
                        </template>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="novaAtividade.colaboradores"
                          :items="listaColaboradores"
                          item-text="nome"
                          item-value="id"
                          label="Colaboradores"
                          multiple
                          clearable
                          chips
                          small-chips
                          deletable-chips
                          outlined
                          dense
                          hide-details
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="novaAtividade.dtInicio"
                          label="Data/Hora de Início"
                          type="datetime-local"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="novaAtividade.dtFim"
                          label="Data/Hora de Fim"
                          type="datetime-local"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <!-- dialog iniciar/finalizar etapa -->
                      <v-col cols="12" class="text-right mb-4">
                        <v-btn
                          v-if="modoEdicaoAtividade"
                          color="red"
                          text
                          small
                          class="mr-2"
                          @click="cancelarEdicaoAtividade"
                          :disabled="salvandoAtividadeEtapa === etapaAtual?.id"
                        >
                          Cancelar
                        </v-btn>
                        <v-btn
                          color="primary"
                          small
                          @click="
                            modoEdicaoAtividade
                              ? atualizarAtividade(etapaAtual?.id)
                              : salvarAtividade(etapaAtual?.id, servicoAtual.id)
                          "
                          :loading="salvandoAtividadeEtapa === etapaAtual?.id"
                          :disabled="
                            !atividadeCompleta(novaAtividade) ||
                            !hasPermissionEdit
                          "
                        >
                          <v-icon left small>{{
                            modoEdicaoAtividade
                              ? "mdi-content-save"
                              : "mdi-plus"
                          }}</v-icon>
                          {{
                            modoEdicaoAtividade
                              ? "Atualizar Atividade"
                              : "Salvar Atividade"
                          }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <h4 class="mb-2">Atividades da Etapa</h4>
                    <!-- Desktop: tabela -->
                    <v-data-table
                      v-if="!isMobile"
                      :headers="atividadesHeaders"
                      :items="
                        getAtividadesDaEtapa(servicoAtual, etapaAtual?.id)
                      "
                      hide-default-footer
                      dense
                      class="elevation-0"
                      :no-data-text="'Nenhuma atividade registrada nesta etapa'"
                    >
                      <template v-slot:item.dtInicio="{ item }">
                        {{ formatarDataHora(item.dtInicio) }}
                      </template>
                      <template v-slot:item.dtFim="{ item }">
                        {{ formatarDataHora(item.dtFim) }}
                      </template>
                      <template v-slot:item.colaboradores="{ item }">
                        <div
                          v-if="
                            item.colaboradores && item.colaboradores.length > 0
                          "
                        >
                          <v-chip
                            v-for="colaborador in item.colaboradores.slice(
                              0,
                              2,
                            )"
                            :key="colaborador.colaboradorId"
                            x-small
                            class="mr-1 mb-1"
                            >{{
                              getNomeColaborador(colaborador.colaboradorId)
                            }}</v-chip
                          >
                          <span
                            v-if="item.colaboradores.length > 2"
                            class="grey--text text-caption"
                          >
                            (+{{ item.colaboradores.length - 2 }})
                          </span>
                        </div>
                        <span v-else class="grey--text text-caption">-</span>
                      </template>
                      <template v-slot:item.acoes="{ item }">
                        <div class="d-flex align-center">
                          <v-btn
                            text
                            small
                            color="primary"
                            class="mr-1"
                            @click="editarAtividade(item)"
                            :disabled="editandoAtividade || !hasPermissionEdit"
                          >
                            <v-icon x-small>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            text
                            small
                            color="error"
                            @click="excluirAtividade(item.id)"
                            :loading="excluindoAtividade === item.id"
                            :disabled="!hasPermissionEdit"
                          >
                            <v-icon x-small>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </template>
                    </v-data-table>
                    <!-- Mobile: cards -->
                    <template v-else>
                      <div
                        v-if="
                          getAtividadesDaEtapa(servicoAtual, etapaAtual?.id)
                            .length === 0
                        "
                        class="text-caption grey--text text-center py-3"
                      >
                        Nenhuma atividade registrada nesta etapa
                      </div>
                      <v-card
                        v-for="item in getAtividadesDaEtapa(
                          servicoAtual,
                          etapaAtual?.id,
                        )"
                        :key="item.id"
                        outlined
                        class="mb-2 pa-3"
                      >
                        <div class="font-weight-medium text-body-2 mb-1">
                          {{ item.atividadeFunerariaDescricao }}
                        </div>
                        <div class="text-caption grey--text">
                          Início:
                          <span class="black--text">{{
                            formatarDataHora(item.dtInicio) || "-"
                          }}</span>
                        </div>
                        <div class="text-caption grey--text">
                          Fim:
                          <span class="black--text">{{
                            formatarDataHora(item.dtFim) || "-"
                          }}</span>
                        </div>
                        <div
                          class="text-caption grey--text mt-1"
                          v-if="item.colaboradores && item.colaboradores.length"
                        >
                          <v-chip
                            v-for="colaborador in item.colaboradores.slice(
                              0,
                              3,
                            )"
                            :key="colaborador.colaboradorId"
                            x-small
                            class="mr-1 mt-1"
                            >{{
                              getNomeColaborador(colaborador.colaboradorId)
                            }}</v-chip
                          >
                          <span
                            v-if="item.colaboradores.length > 3"
                            class="grey--text text-caption"
                            >(+{{ item.colaboradores.length - 3 }})</span
                          >
                        </div>
                        <div class="d-flex mt-2" v-if="hasPermissionEdit">
                          <v-btn
                            x-small
                            outlined
                            color="primary"
                            class="mr-2"
                            @click="editarAtividade(item)"
                            :disabled="!!editandoAtividade"
                          >
                            <v-icon x-small left>mdi-pencil</v-icon> Editar
                          </v-btn>
                          <v-btn
                            x-small
                            outlined
                            color="error"
                            @click="excluirAtividade(item.id)"
                            :loading="excluindoAtividade === item.id"
                          >
                            <v-icon x-small left>mdi-delete</v-icon> Excluir
                          </v-btn>
                        </div>
                      </v-card>
                    </template>
                  </v-card>
                </v-col>
              </template>

              <!-- Campos de Ocorrência (condicionais) -->
              <template v-if="etapasComOcorrencia.includes(etapaAtual?.id)">
                <!-- Ocorrência -->
                <v-col cols="12" md="4" class="pt-0">
                  <v-select
                    :value="obterOpcaoOcorrencia(etapaDadosTemp)"
                    :items="opcoesOcorrencia"
                    label="Ocorrência"
                    outlined
                    dense
                    clearable
                    @change="selecionarOcorrencia(etapaDadosTemp, $event)"
                  ></v-select>
                </v-col>

                <v-col
                  v-if="deveExibirDescricaoOcorrencia(etapaDadosTemp)"
                  cols="12"
                  md="4"
                  class="pt-0"
                >
                  <v-textarea
                    v-model="etapaDadosTemp.ocorrenciaJustificativa"
                    label="Descrição da ocorrência"
                    outlined
                    dense
                    rows="2"
                    auto-grow
                    placeholder="Descreva a ocorrência..."
                  ></v-textarea>
                </v-col>

                <!-- Tempo da Ocorrência -->
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="etapaDadosTemp.tempoOcorrenciaFormatted"
                    label="Tempo (hh:mm)"
                    outlined
                    dense
                    type="time"
                    step="60"
                    placeholder="00:00"
                    @input="updateTempoOcorrenciaEtapa"
                  ></v-text-field>
                </v-col>
              </template>
            </v-row>
            <v-row
              v-if="
                etapaAtual?.nome === 'Transporte familiar' ||
                etapaAtual?.nome === 'Acolhimento de óbito'
              "
            >
              <v-col cols="12" class="my-2 py-0">
                <h3 class="mb-2 primary--text">Transporte</h3>
                <v-divider></v-divider>
                <p class="text-caption grey--text mb-2">
                  Informações sobre transporte e autorizações.
                </p>
              </v-col>

              <!-- Solicitação de Transporte Familiar -->
              <v-col cols="12" md="6" class="py-0">
                <v-select
                  v-model="servicoAtual.solicitacaoTransporteFamiliar"
                  :items="[
                    'A DEFINIR',
                    'SOLICITADO',
                    'SOLICITADO PARCIALMENTE',
                    'DISPENSADO',
                    'NÃO DISPONIBILIZADO FORA ÁREA DE COBERTURA',
                  ]"
                  label="Solicitação de Transporte Familiar"
                  outlined
                  dense
                  @change="ajustarCamposTransporteFamiliar(servicoAtual)"
                ></v-select>
              </v-col>

              <!-- Tipo de Transporte Familiar -->
              <v-col cols="12" md="6" class="py-0">
                <v-select
                  v-model="servicoAtual.tipoTransporteFamiliar"
                  label="Tipo de Transporte Familiar"
                  outlined
                  dense
                  :items="['FROTA PRÓPRIA', 'FROTA TERCEIRIZADA']"
                  :disabled="
                    !(
                      servicoAtual.solicitacaoTransporteFamiliar || ''
                    ).includes('SOLICITADO')
                  "
                ></v-select>
              </v-col>
              <v-col
                cols="6"
                md="6"
                class="py-0"
                v-if="
                  servicoAtual.solicitacaoTransporteFamiliar ===
                  'SOLICITADO PARCIALMENTE'
                "
              >
                <v-checkbox
                  v-model="servicoAtual.idaTransporteFamiliar"
                  label="Ida de Transporte Familiar"
                  outlined
                  dense
                ></v-checkbox>
              </v-col>
              <v-col
                cols="6"
                md="6"
                class="py-0"
                v-if="
                  servicoAtual.solicitacaoTransporteFamiliar ===
                  'SOLICITADO PARCIALMENTE'
                "
              >
                <v-checkbox
                  v-model="servicoAtual.voltaTransporteFamiliar"
                  label="Volta de Transporte Familiar"
                  outlined
                  dense
                ></v-checkbox>
              </v-col>

              <!-- Origem do Transporte Familiar -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.origemTransporteFamiliar"
                  label="Origem do Transporte Familiar"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <!-- Destino do Transporte Familiar -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.destinoTransporteFamiliar"
                  label="Destino do Transporte Familiar"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.linkidaTransporteFamiliar"
                  label="Link da ida"
                  outlined
                  dense
                  prepend-inner-icon="mdi-link-variant"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.linkvoltaTransporteFamiliar"
                  label="Link da volta"
                  outlined
                  dense
                  prepend-inner-icon="mdi-link-variant"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-textarea
                  rows="2"
                  v-model="servicoAtual.observacoesTransporteFamiliar"
                  label="Observações do Transporte Familiar"
                  outlined
                  dense
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row v-if="servicoAtual?.etapa?.nome === 'Velório'">
              <v-col cols="12" class="my-2 pb-0">
                <h3 class="mb-2 primary--text">Velório e Sepultamento</h3>
                <v-divider></v-divider>
                <p class="text-caption grey--text mb-2">
                  Informações sobre velório e sepultamento.
                </p>
              </v-col>

              <!-- Local do Velório -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.localVelorio"
                  label="Local do Velório"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <!-- Data do Velório -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.dataVelorio"
                  label="Data e Hora do Velório"
                  type="datetime-local"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <!-- Local do Sepultamento -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.localSepultamento"
                  label="Local do Sepultamento"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <!-- Data do Sepultamento -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.dataSepultamento"
                  label="Data e Hora do Sepultamento"
                  type="datetime-local"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-checkbox
                  v-model="servicoAtual.cortejo"
                  label="Necessidade de Cortejo"
                  outlined
                  dense
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey darken-1" text small @click="fecharDialogEtapa"
            >Cancelar</v-btn
          >
          <v-btn
            :color="etapaAcao === 'iniciar' ? 'primary' : 'success'"
            @click="salvarEtapaEspecifica"
            small
            :disabled="!hasPermissionEdit"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Confirmação de Exclusão -->
    <v-dialog v-model="dialogExcluirItem" max-width="400px">
      <v-card>
        <v-card-title class="error white--text">
          <v-icon left color="white">mdi-delete</v-icon>
          Confirmar Exclusão
        </v-card-title>
        <v-card-text class="pt-4">
          <p>
            Deseja realmente excluir o item
            <strong>{{ itemParaExcluir?.nomeItem }}</strong
            >?
          </p>
          <p class="text-caption grey--text mb-0">
            Esta ação não poderá ser desfeita.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogExcluirItem = false" small>Cancelar</v-btn>
          <v-btn
            color="error"
            @click="excluirItemConfirmado"
            small
            :loading="loadingExclusao"
          >
            <v-icon small left>mdi-delete</v-icon>
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Aviso - Troca de Urna Validada -->
    <v-dialog v-model="dialogAvisoTrocaUrnaValidada" max-width="450px" persistent>
      <v-card>
        <v-card-title class="warning white--text">
          <v-icon left color="white">mdi-alert</v-icon>
          Urna já validada
        </v-card-title>
        <v-card-text class="pt-4">
          <p class="mb-2">
            Esta urna já foi validada. Ao confirmar a troca, a validação será
            invalidada e será necessário validar a nova urna.
          </p>
          <v-checkbox
            v-model="cienteTrocaUrnaValidada"
            label="Estou ciente de que a validação atual será invalidada"
            color="warning"
            dense
            hide-details
          ></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="cancelarAvisoTrocaUrnaValidada">
            Cancelar
          </v-btn>
          <v-btn
            small
            color="warning"
            :disabled="!cienteTrocaUrnaValidada"
            @click="confirmarAvisoTrocaUrnaValidada"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Troca de Urna -->
    <v-dialog v-model="dialogTrocarUrna" max-width="600px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-swap-horizontal</v-icon>
          Trocar Urna
        </v-card-title>
        <v-card-text class="pt-4">
          <div class="mb-4 pb-2" style="border-bottom: 1px solid #e0e0e0">
            <div class="text-caption grey--text">Urna atual</div>
            <div class="text-body-2 font-weight-medium">
              {{ itemUrnaAtual ? itemUrnaAtual.nomeItem : "" }}
              <span
                v-if="itemUrnaAtual && itemUrnaAtual.nomeGradeItem"
                class="grey--text"
                >- {{ itemUrnaAtual.nomeGradeItem }}</span
              >
            </div>
            <div class="text-caption primary--text font-weight-medium">
              {{ formatarMoeda(itemUrnaAtual ? itemUrnaAtual.valorTotal : 0) }}
            </div>
          </div>

          <v-autocomplete
            v-model="novaUrnaSelecionada"
            :items="produtosUrna"
            label="Selecione a nova urna"
            outlined
            dense
            :loading="carregandoProdutosUrna"
            return-object
            :filter="
              (item, queryText) => {
                const nome = item.nomeProduto?.toLowerCase() || '';
                const grade = item.nomeGrade?.toLowerCase() || '';
                const search = queryText?.toLowerCase() || '';
                return nome.includes(search) || grade.includes(search);
              }
            "
          >
            <template v-slot:selection="{ item }">
              {{ item.nomeProduto }} - {{ item.nomeGrade }} ({{
                formatarMoeda(item.valorProduto)
              }})
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  {{ item.nomeProduto }}
                </v-list-item-title>
                <v-list-item-subtitle class="d-flex justify-space-between">
                  <span>Grade: {{ item.nomeGrade }}</span>
                  <span class="primary--text font-weight-bold">{{
                    formatarMoeda(item.valorProduto)
                  }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>

          <v-text-field
            v-if="novaUrnaSelecionada"
            v-model="descontoTrocaUrna"
            label="Desconto (R$)"
            type="number"
            prefix="R$"
            outlined
            dense
            hint="Opcional"
            persistent-hint
          ></v-text-field>

          <v-alert
            v-if="novaUrnaSelecionada"
            type="info"
            outlined
            dense
            class="mt-3"
          >
            <div class="d-flex justify-space-between">
              <span>Valor da nova urna:</span>
              <strong>{{
                formatarMoeda(
                  novaUrnaSelecionada?.valorProduto - descontoTrocaUrna || 0,
                )
              }}</strong>
            </div>
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogTrocarUrna = false" small>Cancelar</v-btn>
          <v-btn
            color="primary"
            @click="confirmarTrocaUrna"
            small
            :loading="loadingTrocaUrna"
            :disabled="!novaUrnaSelecionada"
          >
            <v-icon small left>mdi-check</v-icon>
            Confirmar Troca
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Validação de Urna -->
    <v-dialog v-model="dialogValidarUrna" max-width="620px" persistent>
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-qrcode-scan</v-icon>
          Validar Urna
        </v-card-title>
        <v-card-text class="pt-4">
          <div class="mb-4 pb-2" style="border-bottom: 1px solid #e0e0e0">
            <div class="text-caption grey--text">Urna do item</div>
            <div class="text-body-2 font-weight-medium">
              {{ itemUrnaValidacao ? itemUrnaValidacao.nomeItem : "" }}
              <span
                v-if="itemUrnaValidacao && itemUrnaValidacao.nomeGradeItem"
                class="grey--text"
                >- {{ itemUrnaValidacao.nomeGradeItem }}</span
              >
            </div>
          </div>

          <div
            v-show="!resultadoValidacaoUrna"
            id="urna-qrcode-reader"
            class="urna-qrcode-reader mb-3"
          ></div>

          <v-alert
            v-if="erroCameraUrna && !resultadoValidacaoUrna"
            type="warning"
            outlined
            dense
          >
            {{ erroCameraUrna }}
          </v-alert>

          <v-text-field
            v-if="erroCameraUrna && !resultadoValidacaoUrna"
            v-model="qrcodeUrnaManual"
            label="QR Code"
            outlined
            dense
            hide-details
            :disabled="validandoUrna"
            @keyup.enter="validarUrnaManual"
          ></v-text-field>

          <v-alert
            v-if="resultadoValidacaoUrna?.status === 'VALIDADA'"
            type="success"
            outlined
            dense
          >
            <div>
              {{ resultadoValidacaoUrna.mensagem || "Urna validada." }}
            </div>
            <div v-if="resultadoValidacaoUrna.urnaLida?.estoque">
              <strong>Estoque:</strong>
              {{ resultadoValidacaoUrna.urnaLida.estoque }}
            </div>
          </v-alert>

          <v-alert
            v-if="resultadoValidacaoUrna?.status === 'NAO_CADASTRADO'"
            type="warning"
            outlined
            dense
          >
            <div class="font-weight-medium mb-1">QR Code não encontrado</div>
            <div>
              O código {{ resultadoValidacaoUrna.qrcodeLido }} não está
              cadastrado no sistema.
            </div>
          </v-alert>

          <v-alert
            v-if="resultadoValidacaoUrna?.status === 'DIVERGENTE'"
            type="error"
            outlined
            dense
          >
            <div class="font-weight-medium mb-2">Urna incorreta</div>
            <div>QR Code lido: {{ resultadoValidacaoUrna.qrcodeLido }}</div>
            <div class="mt-2">
              <strong>Urna identificada:</strong>
              {{ resultadoValidacaoUrna.urnaLida?.nomeUrna }}
            </div>
            <div>
              <strong>Grade identificada:</strong>
              {{ resultadoValidacaoUrna.urnaLida?.nomeUrnaGrade }}
            </div>
            <div v-if="resultadoValidacaoUrna.urnaLida?.estoque">
              <strong>Estoque identificado:</strong>
              {{ resultadoValidacaoUrna.urnaLida.estoque }}
            </div>
            <div class="mt-2">
              <strong>Urna esperada:</strong>
              {{ resultadoValidacaoUrna.urnaEsperada?.nomeUrna }}
            </div>
            <div>
              <strong>Grade esperada:</strong>
              {{ resultadoValidacaoUrna.urnaEsperada?.nomeUrnaGrade }}
            </div>
            <div>
              <strong>QR Code esperado:</strong>
              {{ resultadoValidacaoUrna.urnaEsperada?.qrcodeUrna }}
            </div>
            <div class="mt-2">
              Ao trocar, a validação ficará pendente até uma nova leitura.
            </div>
          </v-alert>

          <v-alert
            v-if="resultadoValidacaoUrna?.status === 'TROCADA'"
            type="info"
            outlined
            dense
          >
            {{ resultadoValidacaoUrna.mensagem }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="
              !resultadoValidacaoUrna ||
              resultadoValidacaoUrna.status === 'NAO_CADASTRADO' ||
              resultadoValidacaoUrna.status === 'DIVERGENTE'
            "
            text
            small
            :disabled="validandoUrna || trocandoUrnaPorQrcode"
            @click="reiniciarLeituraUrna"
          >
            Ler novamente
          </v-btn>
          <v-btn
            text
            small
            :disabled="validandoUrna || trocandoUrnaPorQrcode"
            @click="fecharDialogValidarUrna"
          >
            {{ resultadoValidacaoUrna ? "Fechar" : "Cancelar" }}
          </v-btn>
          <v-btn
            v-if="erroCameraUrna && !resultadoValidacaoUrna"
            color="primary"
            small
            :loading="validandoUrna"
            :disabled="!qrcodeUrnaManual"
            @click="validarUrnaManual"
          >
            <v-icon small left>mdi-check</v-icon>
            Validar
          </v-btn>
          <v-btn
            v-if="resultadoValidacaoUrna?.status === 'DIVERGENTE'"
            color="primary"
            small
            :loading="trocandoUrnaPorQrcode"
            @click="trocarUrnaPorQrcode"
          >
            <v-icon small left>mdi-swap-horizontal</v-icon>
            Trocar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Desconto Individual -->
    <v-dialog v-model="dialogDescontoItem" max-width="450px">
      <v-card>
        <v-card-title class="warning white--text">
          <v-icon left color="white">mdi-percent</v-icon>
          Aplicar Desconto
        </v-card-title>
        <v-card-text class="pt-4">
          <div class="mb-4 pb-2" style="border-bottom: 1px solid #e0e0e0">
            <div class="text-body-2 font-weight-medium">
              {{ itemDesconto ? itemDesconto.nomeItem : "" }}
            </div>
            <div class="text-caption grey--text">
              Valor atual:
              {{ formatarMoeda(itemDesconto ? itemDesconto.valorTotal : 0) }}
            </div>
          </div>

          <v-text-field
            v-model="valorDescontoItem"
            label="Valor do Desconto (R$)"
            type="number"
            prefix="R$"
            outlined
            dense
            :rules="[
              (v) => v >= 0 || 'Valor deve ser positivo',
              (v) =>
                v <= (itemDesconto?.valorTotal || 0) ||
                'Desconto não pode ser maior que o valor do item',
            ]"
          ></v-text-field>

          <v-row>
            <v-col cols="12">
              <div class="text-caption grey--text">
                Valor final após desconto:
              </div>
              <div class="text-h6 success--text font-weight-bold">
                {{
                  formatarMoeda(
                    (itemDesconto?.valorTotal || 0) - (valorDescontoItem || 0),
                  )
                }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDescontoItem = false" small>
            Cancelar
          </v-btn>
          <v-btn
            color="warning"
            @click="aplicarDescontoItem"
            small
            :loading="loadingDescontoItem"
            :disabled="
              valorDescontoItem == null ||
              valorDescontoItem < 0 ||
              valorDescontoItem > (itemDesconto?.valorTotal || 0)
            "
          >
            <v-icon small left>mdi-check</v-icon>
            Aplicar Desconto
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEstoqueQrcodesUrnas" max-width="420">
      <v-card>
        <v-card-title class="primary white--text">
          QR Codes de urnas
        </v-card-title>
        <v-card-text class="pt-4">
          <v-select
            v-model="estoqueImpressaoQrcode"
            :items="estoquesUrna"
            item-text="text"
            item-value="value"
            label="Estoque de impressão"
            outlined
            dense
            autofocus
            hide-details
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="dialogEstoqueQrcodesUrnas = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            small
            :loading="gerandoPdfQrcodes"
            :disabled="!estoqueImpressaoQrcode"
            @click="gerarPdfQrcodesUrnas"
          >
            Gerar PDF
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Confirmação - Recarregar Cobertura -->
    <v-dialog v-model="dialogRecarregarCobertura" max-width="500px">
      <v-card>
        <v-card-title class="warning white--text">
          <v-icon left color="white">mdi-alert</v-icon>
          Atenção
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert type="warning" outlined dense class="mb-4">
            <strong>Esta ação irá:</strong>
            <ul class="mt-2">
              <li>Excluir todos os itens atuais do atendimento</li>
              <li>Adicionar uma nova cobertura baseada no contrato</li>
            </ul>
          </v-alert>
          <p class="mb-0">Deseja realmente recarregar a cobertura?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogRecarregarCobertura = false" small>
            Cancelar
          </v-btn>
          <v-btn
            color="warning"
            @click="recarregarCobertura"
            small
            :loading="loadingRecarregarCobertura"
          >
            <v-icon small left>mdi-refresh</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Edição de Item -->
    <v-dialog v-model="dialogEditarItem" max-width="450px">
      <v-card>
        <v-card-title class="info white--text">
          <v-icon left color="white">mdi-pencil</v-icon>
          Editar Item
        </v-card-title>
        <v-card-text class="pt-4">
          <div class="mb-4 pb-2" style="border-bottom: 1px solid #e0e0e0">
            <div class="text-caption grey--text">Item atual:</div>
            <div class="text-body-2 font-weight-medium">
              {{ itemEditando ? itemEditando.nomeItem : "" }}
            </div>
            <div class="text-caption grey--text">
              {{
                itemEditando && itemEditando.nomeGradeItem
                  ? itemEditando.nomeGradeItem
                  : ""
              }}
            </div>
          </div>

          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="quantidadeEditando"
                label="Quantidade"
                type="number"
                outlined
                dense
                :rules="[
                  (v) => v > 0 || 'Quantidade deve ser maior que 0',
                  (v) => v <= 1000 || 'Quantidade máxima é 1000',
                ]"
                min="1"
                max="1000"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                :value="itemEditando ? itemEditando.valorUnitario : 0"
                label="Valor Unitário (R$)"
                prefix="R$"
                outlined
                dense
                disabled
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                :value="itemEditando ? itemEditando.descontoAplicado : 0"
                label="Desconto (R$)"
                prefix="R$"
                outlined
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="text-caption grey--text">Valor Total:</div>
              <div class="text-h6 success--text font-weight-bold">
                {{
                  formatarMoeda(
                    (quantidadeEditando || 0) *
                      (itemEditando ? itemEditando.valorUnitario : 0) -
                      (itemEditando ? itemEditando.descontoAplicado : 0),
                  )
                }}
              </div>
            </v-col>
          </v-row>

          <v-text-field
            :value="itemEditando ? itemEditando.nomeItem : ''"
            label="Nome do Item"
            outlined
            dense
            disabled
            class="mt-2"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogEditarItem = false" small> Cancelar </v-btn>
          <v-btn
            color="info"
            @click="confirmarEdicaoItem"
            small
            :loading="loadingEditarItem"
            :disabled="
              quantidadeEditando <= 0 ||
              quantidadeEditando > 1000 ||
              (itemEditando && quantidadeEditando === itemEditando.quantidade)
            "
          >
            <v-icon small left>mdi-check</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Adicionar Item -->
    <v-dialog v-model="dialogAdicionarItem" max-width="800px">
      <v-card>
        <v-card-title class="success white--text">
          <v-icon left color="white">mdi-plus</v-icon>
          Adicionar Item
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert type="info" outlined dense class="mb-4" v-if="!isMobile">
            Selecione um item da cobertura para adicionar ao atendimento.
          </v-alert>

          <v-progress-linear
            v-if="loadingItensCobertura"
            indeterminate
            color="success"
            class="mb-4"
          ></v-progress-linear>

          <!-- Desktop: tabela normal -->
          <v-data-table
            v-else-if="!isMobile"
            :headers="[
              { text: 'Item', value: 'nomeItem' },
              { text: 'Grade', value: 'nomeGradeItem' },
              { text: 'Valor', value: 'valorTotal' },
            ]"
            :items="itensCoberturaFiltrados"
            :items-per-page="6"
            dense
            class="elevation-0"
            item-key="idItem"
            :single-select="true"
            v-model="itemSelecionadoParaAdicionar"
            show-select
          >
            <template v-slot:item.valorTotal="{ item }">
              {{ formatarMoeda(item.valorTotal) }}
            </template>
            <template v-slot:no-data>
              <v-alert type="warning" outlined dense class="ma-4">
                Nenhum item disponível para adicionar.
              </v-alert>
            </template>
          </v-data-table>

          <!-- Mobile: lista de cards paginada -->
          <div v-else>
            <v-alert
              v-if="itensCoberturaFiltrados.length === 0"
              type="warning"
              outlined
              dense
              class="ma-2"
            >
              Nenhum item disponível para adicionar.
            </v-alert>
            <template v-else>
              <v-card
                v-for="item in itensCoberturaFiltradosPaginados"
                :key="item.idItem"
                class="mb-2"
                outlined
                :color="
                  itemSelecionadoParaAdicionar &&
                  itemSelecionadoParaAdicionar[0] &&
                  itemSelecionadoParaAdicionar[0].idItem === item.idItem
                    ? 'success lighten-5'
                    : ''
                "
                @click="itemSelecionadoParaAdicionar = [item]"
                style="cursor: pointer"
              >
                <v-card-text class="py-2 px-3">
                  <div class="d-flex align-center">
                    <v-icon
                      :color="
                        itemSelecionadoParaAdicionar &&
                        itemSelecionadoParaAdicionar[0] &&
                        itemSelecionadoParaAdicionar[0].idItem === item.idItem
                          ? 'success'
                          : 'grey lighten-1'
                      "
                      class="mr-3"
                    >
                      {{
                        itemSelecionadoParaAdicionar &&
                        itemSelecionadoParaAdicionar[0] &&
                        itemSelecionadoParaAdicionar[0].idItem === item.idItem
                          ? "mdi-check-circle"
                          : "mdi-circle-outline"
                      }}
                    </v-icon>

                    <div class="flex-grow-1">
                      <div class="font-weight-medium text-body-2">
                        {{ item.nomeItem }}
                      </div>

                      <div
                        class="text-caption grey--text"
                        v-if="item.nomeGradeItem"
                      >
                        {{ item.nomeGradeItem }}
                      </div>

                      <div
                        class="text-body-2 font-weight-bold success--text mt-1"
                      >
                        {{ formatarMoeda(item.valorTotal) }}
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
              <div
                class="d-flex justify-center mt-2"
                v-if="itensCoberturaFiltrados.length > 8"
              >
                <v-pagination
                  v-model="paginaItensCobertura"
                  :length="Math.ceil(itensCoberturaFiltrados.length / 8)"
                  total-visible="4"
                  dense
                ></v-pagination>
              </div>
            </template>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogAdicionarItem = false" small>
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="adicionarItemSelecionado"
            small
            :loading="loadingAdicionarItem"
            :disabled="
              !itemSelecionadoParaAdicionar ||
              itemSelecionadoParaAdicionar.length === 0
            "
          >
            <v-icon small left>mdi-plus</v-icon>
            Adicionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <filtro-component
        :modos="modos"
        :modos-sem-data="['Em abertos']"
        :calendar="'dia'"
        @filtrar="filterData"
        ref="filtro"
        :alternarVisibilidade.sync="exibicaoFiltroPai"
    ></filtro-component>

    <div v-if="!isMobile" class="metricas-grid">
      <pulse-summary-card
        v-for="(card, index) in resumoCards"
        :key="card.chave"
        :title="tituloResumoCard(card)"
        :value="formatarNumeroCard(card.valor)"
        :description="montarSubTextoCard(card)"
        :icon="index === 0 ? 'pi pi-briefcase' : index === 1 ? 'pi pi-clock' : index === 2 ? 'pi pi-check-circle' : 'pi pi-users'"
        :tone="index === 0 ? 'blue' : index === 1 ? 'amber' : index === 2 ? 'green' : 'slate'"
        :loading="isLoadingResumoCards"
      />
    </div>

    <div
      class="fluxo-funerario-board"
      id="financeiro"
    >
      <pulse-card
        title="Serviços funerários"
        subtitle="Atendimentos organizados por etapa do fluxo funerário."
      >
        <div class="fluxo-toolbar pt-4">
          <!-- Linha 1: busca, selects, ações e visualização -->
          <div class="fluxo-toolbar-linha">
            <!-- Campo de busca para filtrar por nome do falecido, nome do cliente ou ID do atendimento -->
            <v-text-field
              v-model="buscaFunerarios"
              label="Buscar por nome ou ID"
              prepend-inner-icon="mdi-magnify"
              clearable
              outlined
              dense
              hide-details
              class="fluxo-toolbar-busca pulse-input"
            ></v-text-field>

            <template v-if="!isMobile">
              <!-- Tags (Kanban e Lista) -->
              <v-select
                v-model="tagsFiltroSelecionadas"
                :items="tagsFiltroOptions"
                label="Tags"
                item-text="nome"
                item-value="id"
                prepend-inner-icon="mdi-tag-outline"
                multiple
                clearable
                outlined
                dense
                hide-details
                no-data-text="Nenhuma tag nos tickets carregados"
                class="fluxo-toolbar-select pulse-input"
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="fluxo-select-resumo">
                    {{ item.nome }}
                  </span>
                  <span
                    v-if="index === 1"
                    class="grey--text text-caption ml-1"
                  >
                    (+{{ tagsFiltroSelecionadas.length - 1 }})
                  </span>
                </template>
              </v-select>

              <!-- Pendências (somente Lista) -->
              <v-select
                v-if="deveExibirTabela"
                v-model="pendenciasFiltroSelecionadas"
                :items="pendenciasFiltroOptions"
                label="Pendências"
                prepend-inner-icon="mdi-alert-outline"
                multiple
                clearable
                outlined
                dense
                hide-details
                no-data-text="Nenhuma pendência nos tickets carregados"
                class="fluxo-toolbar-select pulse-input"
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="fluxo-select-resumo">
                    {{ item }}
                  </span>
                  <span
                    v-if="index === 1"
                    class="grey--text text-caption ml-1"
                  >
                    (+{{ pendenciasFiltroSelecionadas.length - 1 }})
                  </span>
                </template>
              </v-select>

              <v-spacer></v-spacer>

              <div class="pulse-segmented">
                <pulse-button
                  label="Kanban"
                  icon="pi pi-table"
                  text
                  :severity="fluxoViewMode === 'kanban' ? 'primary' : 'secondary'"
                  @click="fluxoViewMode = 'kanban'"
                />
                <pulse-button
                  label="Lista"
                  icon="pi pi-list"
                  text
                  :severity="fluxoViewMode === 'table' ? 'primary' : 'secondary'"
                  @click="fluxoViewMode = 'table'"
                />
              </div>
            </template>
          </div>

          <div class="fluxo-sync-info">
            <span class="text-caption">
              Última sincronização:
              <strong>{{ ultimaSyncTexto }}</strong>
            </span>
            <button
              type="button"
              class="fluxo-sync-link"
              :disabled="syncLoading"
              @click="forcarSyncFunerario"
            >
              {{ syncLoading ? "sincronizando..." : "sincronizar agora" }}
            </button>
          </div>

          <!-- Linha 2: filtros rápidos -->
          <div class="fluxo-toolbar-rapidos">
            <!-- Meus Tickets -->
            <v-chip
              :color="meusTickets ? 'primary' : '#4A4A4A'"
              text-color="white"
              @click="
                meusTickets = !meusTickets;
                init();
              "
              link
              class="px-4"
            >
              <v-icon class="mr-2" color="white">mdi-account</v-icon>
              Meus Tickets
            </v-chip>

            <template v-if="!isMobile">
              <!-- Favoritos -->
              <v-chip
                :color="somenteFavoritos ? 'primary' : '#4A4A4A'"
                text-color="white"
                @click="
                  somenteFavoritos = !somenteFavoritos;
                  init();
                "
                link
                class="px-4"
              >
                <v-icon class="mr-2" color="white">
                  {{ somenteFavoritos ? "mdi-star" : "mdi-star-outline" }}
                </v-icon>
                Favoritos
              </v-chip>

              <template v-if="deveExibirTabela">
                <!-- Com pendências (somente Lista) -->
                <v-chip
                  :color="somenteComPendencia ? 'primary' : '#4A4A4A'"
                  text-color="white"
                  @click="somenteComPendencia = !somenteComPendencia"
                  link
                  class="px-4"
                >
                  <v-icon class="mr-2" color="white">mdi-alert</v-icon>
                  Com pendências
                </v-chip>

                <v-checkbox
                  v-if="podeExcluirAtendimento"
                  v-model="listarExcluidos"
                  label="Listar excluídos"
                  class="mt-0 pt-0 ml-2"
                  dense
                  hide-details
                  @change="init()"
                ></v-checkbox>
              </template>
            </template>

            <!-- Detalhes -->
            <v-chip
              v-else
              :color="detalhesCards ? 'primary' : '#4A4A4A'"
              text-color="white"
              @click="detalhesCards = !detalhesCards"
              link
              class="px-4"
            >
              <v-icon class="mr-2" color="white">mdi-text-box-search</v-icon>
              Detalhes
            </v-chip>
          </div>

          <!-- Linha 3: status das etapas -->
          <div class="fluxo-toolbar-status pb-2">
            <fluxo-tipo-etapa-chips
              v-model="tiposEtapaFiltroSelecionados"
              :items="tiposEtapaFiltroItems"
            />

            <div v-if="!isMobile" class="fluxo-toolbar-acoes">
              <v-tooltip v-if="hasPermissionEdit" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    class="fluxo-acao-icone"
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirDialogEstoqueQrcodesUrnas"
                  >
                    mdi-qrcode
                  </v-icon>
                </template>
                <span>QR Codes de urnas</span>
              </v-tooltip>

              <v-tooltip v-if="hasPermissionCreate" bottom>
                <template v-slot:activator="{ on, attrs }">
                   <v-progress-circular
                    v-if="verificandoConexaoIvertex"
                    indeterminate
                    size="20"
                    width="2"
                    color="primary"
                  ></v-progress-circular>
                  <v-icon
                    color="primary"
                    class="fluxo-acao-icone"
                    v-bind="attrs"
                    v-on="on"
                    @click="abrirCriacaoManualAtendimento"
                  >
                    mdi-plus-circle
                  </v-icon>
                </template>
                <span>Novo atendimento</span>
              </v-tooltip>
            </div>
          </div>
        </div>
        <template>
          <div v-if="deveExibirCards" class="px-0">
            <v-progress-linear
              v-if="isLoading"
              indeterminate
              color="green"
              class="mb-4"
            ></v-progress-linear>
            <!-- Título da coluna simulando Kanban com cards agrupados -->
            <v-card
              v-if="getEtapaFiltrada"
              :color="getEtapaFiltrada.cor"
              class="mb-4"
              style="border-radius: 4px 4px 0 0"
            >
              <v-card-title class="d-flex justify-space-evenly py-3">
                <div
                  class="indicador-coluna"
                  :style="{ backgroundColor: getEtapaFiltrada.cor }"
                ></div>
                <h3
                  class="text-subtitle-1 font-weight-bold"
                  :class="{
                    'text-white': isColorDark(getEtapaFiltrada.cor),
                    'text-black': !isColorDark(getEtapaFiltrada.cor),
                  }"
                >
                  {{ getEtapaFiltrada.nome }}
                </h3>
                <v-chip color="white" x-small class="text-black ml-2">
                  {{ servicosFunerariosComFiltro.length }}
                </v-chip>
              </v-card-title>
              <v-card-text
                class="cards-container px-2"
                style="
                  background-color: #f5f5f5;
                  padding-top: 10px;
                  padding-bottom: 16px;
                  border-radius: 0 0 4px 4px;
                  margin-top: -4px;
                "
              >
                <v-card
                  v-for="item in servicosFunerariosComFiltro"
                  :key="item.id"
                  class="mb-4 mx-2 mt-0"
                  :style="`border-left: 6px solid ${item.etapa.cor}`"
                  elevation="1"
                >
                  <v-card-text class="pa-3">
                    <!-- Cabeçalho do Card -->
                    <div class="d-flex justify-space-between align-center mb-0">
                      <div class="text-subtitle-1 font-weight-bold">
                        {{ formatarCodigoAtendimento(item) }}
                      </div>
                      <v-chip
                        small
                        :color="item.etapa.cor"
                        text-color="white"
                        class="ml-2"
                      >
                        {{ item.etapa.nome }}
                      </v-chip>
                      <v-chip
                        v-if="item.pendencia"
                        small
                        color="orange"
                        text-color="white"
                        class="ml-2"
                      >
                        {{ item.pendencia }}
                      </v-chip>
                    </div>

                    <!-- Informações principais -->
                    <div class="mb-2">
                      <div class="text-body-2">
                        <strong>Falecido:</strong> {{ item.nomeFalecido }}
                      </div>
                      <div class="text-body-2">
                        <strong>Atendimento:</strong> {{ item.dataAtendimento }}
                      </div>
                      <div class="text-body-2" v-if="item.contrato">
                        <strong>Contrato:</strong> {{ item.contrato }}
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-text
                    class="text-gray py-0"
                    v-if="item.etapa.tipo === 'Em andamento'"
                  >
                    <strong
                      >Responsável
                      {{ truncateString(item.etapa.nome, 18) }}</strong
                    ><br />
                    <div v-html="getResponsavel(item, item.etapa)"></div>
                    <strong
                      >Início {{ truncateString(item.etapa.nome, 22) }}</strong
                    ><br />
                    {{ getInicioAtividade(item, item.etapa) }}
                    <template v-if="getObservacaoEtapa(item, item.etapa)">
                      <br />
                      <strong>Observação</strong>
                      <p class="observacao-etapa-kanban my-0">
                        {{ getObservacaoEtapa(item, item.etapa) }}
                      </p>
                    </template>
                  </v-card-text>
                  <template v-if="detalhesCards">
                    <v-divider
                      class="my-2"
                      v-if="
                        deveExibirOrigemDestino(item.etapa) &&
                        item.etapa.id === 1
                      "
                    ></v-divider>
                    <v-card-text
                      class="my-2 mx-2 py-1 px-2"
                      v-if="
                        deveExibirOrigemDestino(item.etapa) &&
                        item.etapa.id === 1
                      "
                      :style="`border: 1px solid ${item.etapa.cor}; border-left: 6px solid ${item.etapa.cor}; background-color: ${item.etapa.cor}1A;`"
                      style="border-radius: 10px; width: 94%"
                    >
                      <strong class="text-purple-900">Locais</strong>
                      <p class="my-0">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker</v-icon
                        >
                        Origem:
                        {{ item.origem || "Não informado" }}
                      </p>
                      <p class="my-0">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker-outline</v-icon
                        >
                        Destino:
                        {{ item.destino || "Não informado" }}
                      </p>
                    </v-card-text>

                    <v-divider
                      class="my-2"
                      v-if="item.etapa.id === 2"
                    ></v-divider>
                    <v-card-text
                      class="my-2 mx-2 py-1 px-2"
                      v-if="item.etapa.id === 2"
                      :style="`border: 1px solid ${item.etapa.cor}; border-left: 6px solid ${item.etapa.cor}; background-color: ${item.etapa.cor}1A;`"
                      style="border-radius: 10px; width: 94%"
                    >
                      <strong class="text-purple-900">Locais</strong>
                      <p class="my-0">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker</v-icon
                        >
                        Origem:
                        {{ item.origem || "Não informado" }}
                      </p>
                      <p class="mt-0 mb-2">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker-outline</v-icon
                        >
                        Destino:
                        {{ item.destino || "Não informado" }}
                      </p>

                      <template
                        v-for="atividade in getAcolhimentoInfo(item, item.etapa)
                          .atividades"
                      >
                        <template
                          v-if="
                            atividade.nome.toLowerCase().includes('entrada')
                          "
                        >
                          <strong class="text-purple-900">Entrada SVO</strong>
                          <p class="my-0">
                            <v-icon small :color="item.etapa.cor"
                              >mdi-account</v-icon
                            >
                            {{ truncateString(atividade.agente, 18) }}
                          </p>
                          <p class="mt-0 mb-2">
                            <v-icon small :color="item.etapa.cor"
                              >mdi-clock-outline</v-icon
                            >
                            {{ atividade.inicio }}
                          </p>
                        </template>
                      </template>

                      <template
                        v-for="atividade in getAcolhimentoInfo(item, item.etapa)
                          .atividades"
                      >
                        <template
                          v-if="atividade.nome.toLowerCase().includes('saída')"
                        >
                          <strong class="text-purple-900">Saída SVO</strong>
                          <p class="my-0">
                            <v-icon small :color="item.etapa.cor"
                              >mdi-account</v-icon
                            >
                            {{ truncateString(atividade.agente, 18) }}
                          </p>
                          <p class="mt-0 mb-2">
                            <v-icon small :color="item.etapa.cor"
                              >mdi-clock-outline</v-icon
                            >
                            {{ atividade.inicio }}
                          </p>
                        </template>
                      </template>
                    </v-card-text>

                    <v-divider
                      class="my-2"
                      v-if="item.etapa.id === 3"
                    ></v-divider>
                    <v-card-text
                      class="my-2 mx-2 py-1 px-2"
                      v-if="item.etapa.id === 3"
                      :style="`border: 1px solid ${item.etapa.cor}; border-left: 6px solid ${item.etapa.cor}; background-color: ${item.etapa.cor}1A;`"
                      style="border-radius: 10px; width: 94%"
                    >
                      <strong class="text-purple-900">Locais</strong>
                      <p class="my-0">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker</v-icon
                        >
                        Origem:
                        {{ item.origem || "Não informado" }}
                      </p>
                      <p class="mt-0 mb-2">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker-outline</v-icon
                        >
                        Destino:
                        {{ item.destino || "Não informado" }}
                      </p>

                      <template v-if="getSomatoInfo(item, item.etapa).nome">
                        <!-- Informações da Somatoconservação -->
                        <strong class="text-purple-900">{{
                          getSomatoInfo(item, item.etapa).nome
                        }}</strong>

                        <!-- Colaborador -->
                        <p class="my-0">
                          <v-icon small :color="item.etapa.cor"
                            >mdi-account</v-icon
                          >
                          {{
                            truncateString(
                              getSomatoInfo(item, item.etapa).colaborador,
                              18,
                            )
                          }}
                        </p>

                        <!-- Data/Hora Início -->
                        <p class="my-0">
                          <v-icon small :color="item.etapa.cor"
                            >mdi-clock-outline</v-icon
                          >
                          {{ getSomatoInfo(item, item.etapa).inicio }}
                        </p>

                        <!-- Data/Hora Fim (se disponível) -->
                        <p
                          class="mt-0 mb-2"
                          v-if="getSomatoInfo(item, item.etapa).fim"
                        >
                          <v-icon small :color="item.etapa.cor"
                            >mdi-clock-outline</v-icon
                          >
                          {{ getSomatoInfo(item, item.etapa).fim }}
                        </p>
                      </template>
                    </v-card-text>

                    <v-divider
                      class="my-2"
                      v-if="
                        item.etapa.id === 4 &&
                        item.etapa.id === 4 &&
                        item.localVelorio
                      "
                    ></v-divider>
                    <v-card-text
                      class="my-2 mx-2 py-1 px-2"
                      v-if="
                        item.etapa.id === 4 &&
                        item.etapa.id === 4 &&
                        item.localVelorio
                      "
                      :style="`border: 1px solid ${item.etapa.cor}; border-left: 6px solid ${item.etapa.cor}; background-color: ${item.etapa.cor}1A;`"
                      style="border-radius: 10px; width: 94%"
                    >
                      <!-- Informações do velório e sepultamento -->
                      <strong class="text-purple-900" v-if="item.localVelorio"
                        >Velório</strong
                      >
                      <p class="my-0" v-if="item.localVelorio">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker</v-icon
                        >{{ item.localVelorio }}
                      </p>
                      <p class="mt-0 mb-2" v-if="item.dataVelorio">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-calendar</v-icon
                        >{{ item.dataVelorio }}
                      </p>
                    </v-card-text>

                    <v-divider
                      class="my-2"
                      v-if="
                        item.etapa.id === 5 &&
                        item.etapa.id === 5 &&
                        ((getVelorioInfo(item, item.etapa) &&
                          getVelorioInfo(item, item.etapa).atividades &&
                          getVelorioInfo(item, item.etapa).atividades.length >
                            0) ||
                          item.localVelorio !== null ||
                          item.localSepultamento !== null ||
                          item.dataVelorio !== null ||
                          item.dataSepultamento !== null)
                      "
                    ></v-divider>
                    <v-card-text
                      class="my-2 mx-2 py-1 px-2"
                      v-if="
                        item.etapa.id === 5 &&
                        item.etapa.id === 5 &&
                        ((getVelorioInfo(item, item.etapa) &&
                          getVelorioInfo(item, item.etapa).atividades &&
                          getVelorioInfo(item, item.etapa).atividades.length >
                            0) ||
                          item.localVelorio !== null ||
                          item.localSepultamento !== null ||
                          item.dataVelorio !== null ||
                          item.dataSepultamento !== null)
                      "
                      :style="`border: 1px solid ${item.etapa.cor}; border-left: 6px solid ${item.etapa.cor}; background-color: ${item.etapa.cor}1A;`"
                      style="border-radius: 10px; width: 94%"
                    >
                      <!-- Informações das atividades do velório -->
                      <template
                        v-if="
                          getVelorioInfo(item, item.etapa) &&
                          getVelorioInfo(item, item.etapa).atividades &&
                          getVelorioInfo(item, item.etapa).atividades.length > 0
                        "
                      >
                        <!-- Montagem -->
                        <template
                          v-for="atividade in getVelorioInfo(item, item.etapa)
                            .atividades"
                        >
                          <template
                            v-if="
                              atividade.nome
                                .toLowerCase()
                                .includes('montagem') &&
                              !atividade.nome.toLowerCase().includes('des')
                            "
                          >
                            <strong class="text-purple-900">Montagem</strong>
                            <p class="my-0">
                              <v-icon small :color="item.etapa.cor"
                                >mdi-account</v-icon
                              >
                              {{ truncateString(atividade.agente, 18) }}
                            </p>
                            <p class="mt-0 mb-2">
                              <v-icon small :color="item.etapa.cor"
                                >mdi-clock-outline</v-icon
                              >
                              {{ atividade.inicio }}
                            </p>
                          </template>
                        </template>

                        <!-- Desmontagem -->
                        <template
                          v-for="atividade in getVelorioInfo(item, item.etapa)
                            .atividades"
                        >
                          <template
                            v-if="
                              atividade.nome
                                .toLowerCase()
                                .includes('desmontagem')
                            "
                          >
                            <strong class="text-purple-900">Desmontagem</strong>
                            <p class="my-0">
                              <v-icon small :color="item.etapa.cor"
                                >mdi-account</v-icon
                              >
                              {{ truncateString(atividade.agente, 18) }}
                            </p>
                            <p class="mt-0 mb-2">
                              <v-icon small :color="item.etapa.cor"
                                >mdi-clock-outline</v-icon
                              >
                              {{ atividade.inicio }}
                            </p>
                          </template>
                        </template>

                        <!-- Cortejo -->
                        <template
                          v-for="atividade in getVelorioInfo(item, item.etapa)
                            .atividades"
                        >
                          <template
                            v-if="
                              atividade.nome.toLowerCase().includes('cortejo')
                            "
                          >
                            <strong class="text-purple-900">Cortejo</strong>
                            <p class="my-0">
                              <v-icon small :color="item.etapa.cor"
                                >mdi-account</v-icon
                              >
                              {{ truncateString(atividade.agente, 18) }}
                            </p>
                            <p class="mt-0 mb-2">
                              <v-icon small :color="item.etapa.cor"
                                >mdi-clock-outline</v-icon
                              >
                              {{ atividade.inicio }}
                            </p>
                          </template>
                        </template>
                      </template>

                      <!-- Informações do velório e sepultamento -->
                      <strong class="text-purple-900" v-if="item.localVelorio"
                        >Velório</strong
                      >
                      <p class="my-0" v-if="item.localVelorio">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker</v-icon
                        >{{ item.localVelorio }}
                      </p>
                      <p class="mt-0 mb-2" v-if="item.dataVelorio">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-calendar</v-icon
                        >{{ item.dataVelorio }}
                      </p>
                      <strong
                        class="text-purple-900"
                        v-if="item.localSepultamento"
                      >
                        Sepultamento</strong
                      >
                      <p class="my-0" v-if="item.localSepultamento">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker</v-icon
                        >{{ item.localSepultamento }}
                      </p>
                      <p class="my-0" v-if="item.dataSepultamento">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-calendar</v-icon
                        >{{ item.dataSepultamento }}
                      </p>
                    </v-card-text>

                    <v-divider
                      class="my-2"
                      v-if="item.etapa.id === 6"
                    ></v-divider>
                    <v-card-text
                      class="my-2 mx-2 py-1 px-2"
                      v-if="item.etapa.id === 6"
                      :style="`border: 1px solid ${item.etapa.cor}; border-left: 6px solid ${item.etapa.cor}; background-color: ${item.etapa.cor}1A;`"
                      style="border-radius: 10px; width: 94%"
                    >
                      <!-- Transporte Familiar -->
                      <strong class="text-purple-900"
                        >Transporte Familiar</strong
                      >
                      <p class="my-0">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-car</v-icon
                        >
                        {{ item.tipoTransporteFamiliar || "Não informado" }}
                      </p>
                      <p class="my-0">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker</v-icon
                        >
                        Origem:
                        {{ item.origemTransporteFamiliar || "Não informado" }}
                      </p>
                      <p class="my-0">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker</v-icon
                        >
                        Destino:
                        {{ item.destinoTransporteFamiliar || "Não informado" }}
                      </p>
                      <p class="my-0" v-if="item.linkidaTransporteFamiliar">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-link-variant</v-icon
                        >
                        <a
                          :href="normalizarLinkExterno(item.linkidaTransporteFamiliar)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Abrir link da ida
                        </a>
                      </p>
                      <p class="my-0" v-if="item.linkvoltaTransporteFamiliar">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-link-variant</v-icon
                        >
                        <a
                          :href="normalizarLinkExterno(item.linkvoltaTransporteFamiliar)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Abrir link da volta
                        </a>
                      </p>
                      <p class="my-0">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-text</v-icon
                        >
                        Obs:
                        {{
                          item.observacoesTransporteFamiliar ||
                          "Sem observações"
                        }}
                      </p>
                      <template
                        v-for="atividade in getTransporteFamiliarInfo(
                          item,
                          item.etapa,
                        ) &&
                        getTransporteFamiliarInfo(item, item.etapa).atividades
                          ? getTransporteFamiliarInfo(item, item.etapa)
                              .atividades
                          : []"
                      >
                        <template
                          v-if="atividade.nome.toLowerCase().includes('ida')"
                        >
                          <p class="my-0">
                            <v-icon small class="mr-1" :color="item.etapa.cor"
                              >mdi-arrow-right</v-icon
                            >
                            Ida:
                          </p>
                          <span class="ml-6">
                            {{
                              truncateString(atividade.agente, 18) ||
                              "Não informado"
                            }}
                          </span>
                          <span class="ml-6">
                            {{ atividade.inicio || "Não informado" }}
                          </span>
                        </template>
                        <template
                          v-if="atividade.nome.toLowerCase().includes('volta')"
                        >
                          <p class="my-0">
                            <v-icon small class="mr-1" :color="item.etapa.cor"
                              >mdi-arrow-left</v-icon
                            >
                            Volta:
                          </p>
                          <span class="ml-6">
                            {{
                              truncateString(atividade.agente, 18) ||
                              "Não informado"
                            }}
                          </span>
                          <span class="ml-6">
                            {{ atividade.inicio || "Não informado" }}
                          </span>
                        </template>
                      </template>
                    </v-card-text>
                  </template>

                  <v-card-actions class="justify-center">
                    <v-btn
                      :color="item.etapa.cor"
                      small
                      @click="abrirDialog(item)"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn
                      :color="item.etapa.cor"
                      small
                      :disabled="
                        item.etapa.tipo !== 'Em andamento' || !hasPermissionEdit
                      "
                      @click.stop="abrirDialogAtribuir(item, item.etapa)"
                    >
                      <v-icon>mdi-account-multiple-plus</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="playOrPause(item, item.etapa)"
                      small
                      :disabled="
                        item.etapa.tipo == 'Falha' ||
                        item.etapa.tipo == 'Finalizado' ||
                        !hasPermissionEdit
                      "
                      :color="item.etapa.cor"
                      @click.stop="handlePlayButton(item, item.etapa)"
                    >
                      <v-icon>mdi-play</v-icon>
                    </v-btn>
                    <v-btn
                      v-else
                      small
                      :disabled="
                        item.etapa.tipo !== 'Em andamento' ||
                        item.etapa.tipo == 'Falha' ||
                        item.etapa.tipo == 'Finalizado' ||
                        !hasPermissionEdit
                      "
                      :color="item.etapa.cor"
                      @click.stop="abrirDialogFinalizarEtapa(item, item.etapa)"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
                <v-card
                  v-for="item in getItensTransporteFamiliarComFiltro"
                  :key="item.id"
                  class="mb-4 mx-2 mt-0"
                  :style="`border-left: 6px solid #3F51B5`"
                  elevation="1"
                >
                  <v-card-text class="pa-3">
                    <!-- Cabeçalho do Card -->
                    <div class="d-flex justify-space-between align-center mb-0">
                      <div class="text-subtitle-1 font-weight-bold">
                        {{ formatarCodigoAtendimento(item) }}
                      </div>
                      <v-chip
                        small
                        color="#3F51B5"
                        text-color="white"
                        class="ml-2"
                      >
                        Transporte familiar
                      </v-chip>
                    </div>

                    <!-- Informações principais -->
                    <div class="mb-2">
                      <div class="text-body-2">
                        <strong>Falecido:</strong> {{ item.nomeFalecido }}
                      </div>
                      <div class="text-body-2">
                        <strong>Atendimento:</strong> {{ item.dataAtendimento }}
                      </div>
                      <div class="text-body-2" v-if="item.contrato">
                        <strong>Contrato:</strong> {{ item.contrato }}
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-text
                    class="text-gray py-0"
                    v-if="item.etapa.tipo === 'Agendado'"
                  >
                    <strong
                      >Responsável
                      {{ truncateString("Transporte familiar", 18) }}</strong
                    ><br />
                    <div
                      v-html="getResponsavel(item, etapaTransporteFamiliarFixa)"
                    ></div>
                    <strong
                      >Início
                      {{ truncateString("Transporte familiar", 22) }}</strong
                    ><br />
                    {{ getInicioAtividade(item, etapaTransporteFamiliarFixa) }}
                  </v-card-text>
                  <template v-if="detalhesCards">
                    <v-divider class="my-2"></v-divider>
                    <v-card-text
                      class="my-2 mx-2 py-1 px-2"
                      :style="`border: 1px solid #3F51B5; border-left: 6px solid #3F51B5; background-color: #3F51B51A;`"
                      style="border-radius: 10px; width: 94%"
                    >
                      <!-- Transporte Familiar -->
                      <strong class="text-purple-900"
                        >Transporte Familiar</strong
                      >
                      <p class="my-0">
                        <v-icon small class="mr-1" color="#3F51B5"
                          >mdi-car</v-icon
                        >
                        {{ item.tipoTransporteFamiliar || "Não informado" }}
                      </p>
                      <p class="my-0">
                        <v-icon small class="mr-1" color="#3F51B5"
                          >mdi-map-marker</v-icon
                        >
                        Origem:
                        {{ item.origemTransporteFamiliar || "Não informado" }}
                      </p>
                      <p class="my-0">
                        <v-icon small class="mr-1" color="#3F51B5"
                          >mdi-map-marker</v-icon
                        >
                        Destino:
                        {{ item.destinoTransporteFamiliar || "Não informado" }}
                      </p>
                      <p class="my-0" v-if="item.linkidaTransporteFamiliar">
                        <v-icon small class="mr-1" color="#3F51B5"
                          >mdi-link-variant</v-icon
                        >
                        <a
                          :href="normalizarLinkExterno(item.linkidaTransporteFamiliar)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Abrir link da ida
                        </a>
                      </p>
                      <p class="my-0" v-if="item.linkvoltaTransporteFamiliar">
                        <v-icon small class="mr-1" color="#3F51B5"
                          >mdi-link-variant</v-icon
                        >
                        <a
                          :href="normalizarLinkExterno(item.linkvoltaTransporteFamiliar)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Abrir link da volta
                        </a>
                      </p>
                      <p class="my-0">
                        <v-icon small class="mr-1" color="#3F51B5"
                          >mdi-text</v-icon
                        >
                        Obs:
                        {{
                          item.observacoesTransporteFamiliar ||
                          "Sem observações"
                        }}
                      </p>
                      <template
                        v-for="atividade in getTransporteFamiliarInfo(
                          item,
                          etapaTransporteFamiliarFixa,
                        ) &&
                        getTransporteFamiliarInfo(
                          item,
                          etapaTransporteFamiliarFixa,
                        ).atividades
                          ? getTransporteFamiliarInfo(
                              item,
                              etapaTransporteFamiliarFixa,
                            ).atividades
                          : []"
                      >
                        <template
                          v-if="atividade.nome.toLowerCase().includes('ida')"
                        >
                          <p class="my-0">
                            <v-icon small class="mr-1" color="#3F51B5"
                              >mdi-arrow-right</v-icon
                            >
                            Ida:
                          </p>
                          <span class="ml-6">
                            {{
                              truncateString(atividade.agente, 18) ||
                              "Não informado"
                            }}
                          </span>
                          <span class="ml-6">
                            {{ atividade.inicio || "Não informado" }}
                          </span>
                        </template>
                        <template
                          v-if="atividade.nome.toLowerCase().includes('volta')"
                        >
                          <p class="my-0">
                            <v-icon small class="mr-1" color="#3F51B5"
                              >mdi-arrow-left</v-icon
                            >
                            Volta:
                          </p>
                          <span class="ml-6">
                            {{
                              truncateString(atividade.agente, 18) ||
                              "Não informado"
                            }}
                          </span>
                          <span class="ml-6">
                            {{ atividade.inicio || "Não informado" }}
                          </span>
                        </template>
                      </template>
                    </v-card-text>
                  </template>
                  <v-card-actions class="justify-center">
                    <v-btn color="#3F51B5" small @click="abrirDialog(item)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn
                      color="#3F51B5"
                      small
                      @click.stop="
                        abrirDialogAtribuir(item, etapaTransporteFamiliarFixa)
                      "
                      v-if="hasPermissionEdit"
                    >
                      <v-icon>mdi-account-multiple-plus</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="
                        playOrPause(item, etapaTransporteFamiliarFixa) &&
                        hasPermissionEdit
                      "
                      small
                      color="#3F51B5"
                      @click.stop="
                        handlePlayButton(item, etapaTransporteFamiliarFixa)
                      "
                    >
                      <v-icon>mdi-play</v-icon>
                    </v-btn>
                    <v-btn
                      v-else-if="hasPermissionEdit"
                      small
                      color="#3F51B5"
                      @click.stop="abrirDialogFinalizarEtapa(item, item.etapa)"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-card-text>
            </v-card>
          </div>

          <div
            class="fixed-action-buttons-bottom"
            v-if="isMobile && deveExibirCards"
          >
            <v-card
              class="py-2 px-2"
              style="background-color: #eef2f6; border-radius: 8px"
            >
              <div class="d-flex justify-center align-center">
                <v-btn
                  color="primary"
                  text
                  small
                  class="mx-2"
                  @click="navegarEtapa('anterior')"
                  :disabled="!temEtapaAnterior"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>

                <span class="text-caption black--text">{{
                  getEtapaFiltrada ? getEtapaFiltrada.nome : "Todas"
                }}</span>

                <v-btn
                  color="primary"
                  text
                  small
                  class="mx-2"
                  @click="navegarEtapa('proxima')"
                  :disabled="!temEtapaProxima"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </v-card>
          </div>
        </template>
        <div v-if="deveExibirTabela" class="funerario-list-view mt-4">
          <v-data-table
            :headers="funerarioListHeaders"
            :items="servicosFunerariosTabela"
            :items-per-page="25"
            class="funerario-list-table pulse-table no-hover-effect"
            dense
          >
            <template v-slot:item="row">
              <tr
                :class="{ 'cor-row': row.index % 2 !== 0 }"
                class="pointer"
                @click="abrirDialog(row.item)"
              >
                <td class="linha">{{ formatarCodigoAtendimento(row.item) }}</td>
                <td class="linha">
                  {{ row.item.nomeFalecido || "-" }}
                  <div class="lista-subtexto">
                    {{ row.item.nomeCliente || row.item.cliente || "-" }}
                  </div>
                </td>
                <td class="linha">{{ row.item.contrato || "-" }}</td>
                <td class="linha">
                  <v-chip
                    x-small
                    :color="row.item.etapa && row.item.etapa.cor"
                    :text-color="
                      row.item.etapa && isColorDark(row.item.etapa.cor)
                        ? 'white'
                        : 'black'
                    "
                  >
                    {{ row.item.etapa ? row.item.etapa.nome : "-" }}
                  </v-chip>
                </td>
                <td class="linha">{{ row.item.dataAtendimento || "-" }}</td>
                <td class="linha">{{ row.item.dataVelorio || "-" }}</td>
                <td class="linha">{{ row.item.localVelorio || "-" }}</td>
                <td class="linha">{{ row.item.dataSepultamento || "-" }}</td>
                <td class="linha">{{ row.item.localSepultamento || "-" }}</td>
                <td class="linha">{{ row.item.pendencia || "-" }}</td>
                <td class="linha">
                  <div class="tags-funerario-lista">
                    <v-chip
                      v-for="tag in normalizarTags(row.item.tags)"
                      :key="`lista-tag-${row.item.id}-${tag.id}`"
                      x-small
                      :color="tag.cor"
                      :text-color="isColorDark(tag.cor) ? 'white' : 'black'"
                    >
                      {{ tag.nome }}
                    </v-chip>
                    <span v-if="!normalizarTags(row.item.tags).length">-</span>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>

          <div class="excel-export-row">
            <span
              class="excel-export-icon"
              :class="{ disabled: !servicosFunerariosTabela.length }"
              title="Exportar Excel"
              @click="exportarFunerarioXlsx"
            >
              <v-progress-circular
                v-if="exportandoFunerario"
                indeterminate
                color="green"
                size="34"
                width="3"
              />
              <i v-else class="fas fa-file-excel"></i>
            </span>
          </div>
        </div>
        <v-row
          align="end"
          justify="center"
          class="mb-4 mt-2"
          v-if="deveExibirKanban"
        >
          <div class="kanban-board pulse-kanban-board">
            <div class="kanban-colunas pulse-kanban-columns">
              <div
                v-for="(coluna, index) in getColunasFiltradas()"
                :key="index"
                class="kanban-coluna pulse-kanban-column"
              >
                <v-card class="kanban-card pulse-kanban-column__surface" elevation="1">
                  <div
                    class="kanban-cabecalho pulse-kanban-column__header"
                    :style="{ backgroundColor: coluna.cor, opacity: 0.9 }"
                  >
                    <div class="d-flex align-center ga-2">
                      <div
                        class="indicador-coluna"
                        :style="{ backgroundColor: coluna.cor }"
                      ></div>
                      <h3
                        class="text-subtitle-1 font-weight-bold"
                        :class="{
                          'text-white': isColorDark(coluna.cor),
                          'text-black': !isColorDark(coluna.cor),
                        }"
                      >
                        {{ coluna.nome }}
                      </h3>
                      <v-chip color="white" x-small class="text-black ml-2">
                        {{ getItensVisiveisPorColunaTotal(coluna.id).length }}
                      </v-chip>
                    </div>
                  </div>

                  <div class="tarefas-container pulse-kanban-column__body">
                    <VueDraggable
                      v-model="tarefasPorColuna[coluna.id]"
                      group="kanban"
                      item-key="id"
                      class="lista-tarefas"
                      :animation="200"
                      ghost-class="pulse-kanban-ghost"
                      @change="(event) => aoArrastar(event, coluna)"
                      @start="iniciarArrastar"
                      @end="finalizarArrastar"
                    >
                      <transition-group type="transition" name="fade">
                        <v-card
                          v-for="element in getItensVisiveisPorColuna(
                            coluna.id,
                          )"
                          :key="element.id"
                          class="tarefa-card pulse-kanban-ticket"
                          elevation="1"
                          rounded="lg"
                          :style="`border-left: 6px solid ${coluna.cor}`"
                        >
                          <v-card-text class="text-gray pb-0">
                            <div
                              class="d-flex align-center justify-space-between"
                            >
                              <strong>{{ formatarCodigoAtendimento(element) }}</strong>
                              <v-chip
                                color="warning"
                                x-small
                                v-if="
                                  coluna.tipo === 'Agendado' && isNew(element)
                                "
                              >
                                Novo
                              </v-chip>
                              <v-chip
                                :class="{
                                  'text-white': isColorDark(coluna.cor),
                                  'text-black': !isColorDark(coluna.cor),
                                }"
                                small
                                :color="
                                  diferencaTempo(element, coluna)?.statusSLA
                                    ? 'red'
                                    : coluna.cor
                                "
                                v-if="
                                  coluna.tipo === 'Em andamento' &&
                                  !diferencaTempo(element, coluna)?.statusSLA &&
                                  diferencaTempo(element, coluna)
                                "
                              >
                                {{ diferencaTempo(element, coluna)?.tempo }}
                              </v-chip>

                              <v-chip
                                class="text-white"
                                color="red"
                                small
                                v-if="
                                  coluna.tipo === 'Em andamento' &&
                                  diferencaTempo(element, coluna)?.statusSLA &&
                                  diferencaTempo(element, coluna)
                                "
                              >
                                SLA Expirado ({{
                                  diferencaTempo(element, coluna)?.tempo
                                }})
                              </v-chip>
                              <v-chip
                                v-if="
                                  element.pendencia &&
                                  coluna.tipo !== 'Em andamento'
                                "
                                small
                                color="orange"
                                text-color="white"
                                class="ml-2"
                              >
                                {{ element.pendencia }}
                              </v-chip>
                            </div>
                            <div
                              v-if="
                                element.etapa.id === 3 &&
                                element.usoSomatoConservacao
                              "
                              class="d-flex align-center justify-center mt-2"
                            >
                              <v-chip color="warning" x-small>
                                SOMATOCONSERVAÇÃO
                              </v-chip>
                            </div>
                            <p
                              class="mb-0 mt-2"
                              style="
                                font-size: 18px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                              "
                            >
                              <strong>
                                {{ element.nomeFalecido }}
                              </strong>
                            </p>
                            <p class="mb-0 mt-0" v-if="element?.contrato">
                              Contrato:
                              {{ element?.contrato }}
                            </p>
                            <p class="mb-0 mt-0" v-if="element?.tipoContrato">
                              Tipo:
                              {{ element?.tipoContrato }}
                            </p>
                            <p class="mb-0">
                              Atendimento: {{ element.dataAtendimento }}
                            </p>
                            <div
                              v-if="normalizarTags(element.tags).length"
                              class="kanban-tags mt-2"
                            >
                              <v-chip
                                v-for="tag in normalizarTags(element.tags).slice(0, 3)"
                                :key="`kanban-tag-${element.id}-${tag.id}`"
                                x-small
                                label
                                class="kanban-tag-chip"
                                :color="tag.cor"
                                :text-color="isColorDark(tag.cor) ? 'white' : 'black'"
                                :title="tag.nome"
                              >
                                {{ tag.nome }}
                              </v-chip>
                              <v-tooltip
                                v-if="normalizarTags(element.tags).length > 3"
                                bottom
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-chip
                                    x-small
                                    label
                                    outlined
                                    class="kanban-tag-chip"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    +{{ normalizarTags(element.tags).length - 3 }}
                                  </v-chip>
                                </template>
                                <span>
                                  {{
                                    normalizarTags(element.tags)
                                      .slice(3)
                                      .map((tag) => tag.nome)
                                      .join(", ")
                                  }}
                                </span>
                              </v-tooltip>
                            </div>
                          </v-card-text>
                          <v-divider class="my-2" v-if="coluna.id != 1"></v-divider>
                          <v-card-text
                            class="text-gray py-0"
                            v-if="element.etapa.tipo === 'Em andamento'"
                          >
                            <strong
                              >Responsável
                              {{ truncateString(coluna.nome, 18) }}</strong
                            >
                            <div
                              class="mb-2"
                              v-html="getResponsavel(element, coluna)"
                            ></div>

                            <strong
                              >Início
                              {{ truncateString(coluna.nome, 22) }}</strong
                            ><br />
                            {{ getInicioAtividade(element, coluna) }} <br />
                            <strong
                              >{{ coluna.id === 3 ? "Sala" : "VTR" }}
                              {{ truncateString(coluna.nome, 22) }}</strong
                            ><br />
                            {{ getVtrAtividade(element, coluna) }}
                            <template
                              v-if="getObservacaoEtapa(element, coluna)"
                            >
                              <br />
                              <strong>Observação</strong>
                              <p class="observacao-etapa-kanban my-0">
                                {{ getObservacaoEtapa(element, coluna) }}
                              </p>
                            </template>
                          </v-card-text>

                          <v-divider
                            class="my-2"
                            v-if="
                              deveExibirOrigemDestino(coluna) && coluna.id === 1
                            "
                          ></v-divider>
                          <v-card-text
                            class="my-2 mx-2 py-1 px-2"
                            v-if="
                              deveExibirOrigemDestino(coluna) && coluna.id === 1
                            "
                            :style="`border: 1px solid ${coluna.cor}; border-left: 6px solid ${coluna.cor}; background-color: ${coluna.cor}1A;`"
                            style="border-radius: 10px; width: 94%"
                          >
                            <strong class="text-purple-900">Locais</strong>
                            <p class="my-0">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker</v-icon
                              >
                              Origem:
                              {{ element.origem || "Não informado" }}
                            </p>
                            <p class="my-0">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker-outline</v-icon
                              >
                              Destino:
                              {{ element.destino || "Não informado" }}
                            </p>
                          </v-card-text>

                          <v-divider
                            class="my-2"
                            v-if="coluna.id === 2"
                          ></v-divider>
                          <v-card-text
                            class="my-2 mx-2 py-1 px-2"
                            v-if="coluna.id === 2"
                            :style="`border: 1px solid ${coluna.cor}; border-left: 6px solid ${coluna.cor}; background-color: ${coluna.cor}1A;`"
                            style="border-radius: 10px; width: 94%"
                          >
                            <strong class="text-purple-900">Locais</strong>
                            <p class="my-0">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker</v-icon
                              >
                              Origem:
                              {{ element.origem || "Não informado" }}
                            </p>
                            <p class="mt-0 mb-2">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker-outline</v-icon
                              >
                              Destino:
                              {{ element.destino || "Não informado" }}
                            </p>

                            <template
                              v-for="atividade in getAcolhimentoInfo(
                                element,
                                coluna,
                              ).atividades"
                            >
                              <template
                                v-if="
                                  atividade.nome
                                    .toLowerCase()
                                    .includes('entrada')
                                "
                              >
                                <strong class="text-purple-900"
                                  >Entrada SVO</strong
                                >
                                <p class="my-0">
                                  <v-icon small :color="coluna.cor"
                                    >mdi-account</v-icon
                                  >
                                  {{ truncateString(atividade.agente, 18) }}
                                </p>
                                <p class="mt-0 mb-2">
                                  <v-icon small :color="coluna.cor"
                                    >mdi-clock-outline</v-icon
                                  >
                                  {{ atividade.inicio }}
                                </p>
                              </template>
                            </template>

                            <template
                              v-for="atividade in getAcolhimentoInfo(
                                element,
                                coluna,
                              ).atividades"
                            >
                              <template
                                v-if="
                                  atividade.nome.toLowerCase().includes('saída')
                                "
                              >
                                <strong class="text-purple-900"
                                  >Saída SVO</strong
                                >
                                <p class="my-0">
                                  <v-icon small :color="coluna.cor"
                                    >mdi-account</v-icon
                                  >
                                  {{ truncateString(atividade.agente, 18) }}
                                </p>
                                <p class="mt-0 mb-2">
                                  <v-icon small :color="coluna.cor"
                                    >mdi-clock-outline</v-icon
                                  >
                                  {{ atividade.inicio }}
                                </p>
                              </template>
                            </template>
                          </v-card-text>

                          <v-divider
                            class="my-2"
                            v-if="coluna.id === 3"
                          ></v-divider>
                          <v-card-text
                            class="my-2 mx-2 py-1 px-2"
                            v-if="coluna.id === 3"
                            :style="`border: 1px solid ${coluna.cor}; border-left: 6px solid ${coluna.cor}; background-color: ${coluna.cor}1A;`"
                            style="border-radius: 10px; width: 94%"
                          >
                            <strong class="text-purple-900">Locais</strong>
                            <p class="my-0">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker</v-icon
                              >
                              Origem:
                              {{ element.origem || "Não informado" }}
                            </p>
                            <p class="mt-0 mb-2">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker-outline</v-icon
                              >
                              Destino:
                              {{ element.destino || "Não informado" }}
                            </p>

                            <template
                              v-if="getSomatoInfo(element, coluna).nome"
                            >
                              <!-- Informações da Somatoconservação -->
                              <strong class="text-purple-900">{{
                                getSomatoInfo(element, coluna).nome
                              }}</strong>

                              <!-- Colaborador -->
                              <p class="my-0">
                                <v-icon small :color="coluna.cor"
                                  >mdi-account</v-icon
                                >
                                {{
                                  truncateString(
                                    getSomatoInfo(element, coluna).colaborador,
                                    18,
                                  )
                                }}
                              </p>

                              <!-- Data/Hora Início -->
                              <p class="my-0">
                                <v-icon small :color="coluna.cor"
                                  >mdi-clock-outline</v-icon
                                >
                                {{ getSomatoInfo(element, coluna).inicio }}
                              </p>

                              <!-- Data/Hora Fim (se disponível) -->
                              <p
                                class="mt-0 mb-2"
                                v-if="getSomatoInfo(element, coluna).fim"
                              >
                                <v-icon small :color="coluna.cor"
                                  >mdi-clock-outline</v-icon
                                >
                                {{ getSomatoInfo(element, coluna).fim }}
                              </p>
                            </template>
                          </v-card-text>

                          <v-divider
                            class="my-2"
                            v-if="
                              element.etapa.id === 4 &&
                              coluna.id === 4 &&
                              element.localVelorio
                            "
                          ></v-divider>
                          <v-card-text
                            class="my-2 mx-2 py-1 px-2"
                            v-if="
                              element.etapa.id === 4 &&
                              coluna.id === 4 &&
                              element.localVelorio
                            "
                            :style="`border: 1px solid ${coluna.cor}; border-left: 6px solid ${coluna.cor}; background-color: ${coluna.cor}1A;`"
                            style="border-radius: 10px; width: 94%"
                          >
                            <!-- Informações do velório e sepultamento -->
                            <strong
                              class="text-purple-900"
                              v-if="element.localVelorio"
                              >Velório</strong
                            >
                            <p class="my-0" v-if="element.localVelorio">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker</v-icon
                              >{{ element.localVelorio }}
                            </p>
                            <p class="mt-0 mb-2" v-if="element.dataVelorio">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-calendar</v-icon
                              >{{ element.dataVelorio }}
                            </p>
                          </v-card-text>

                          <v-divider
                            class="my-2"
                            v-if="
                              element.etapa.id === 5 &&
                              coluna.id === 5 &&
                              ((getVelorioInfo(element, coluna) &&
                                getVelorioInfo(element, coluna).atividades &&
                                getVelorioInfo(element, coluna).atividades
                                  .length > 0) ||
                                element.localVelorio !== null ||
                                element.localSepultamento !== null ||
                                element.dataVelorio !== null ||
                                element.dataSepultamento !== null)
                            "
                          ></v-divider>
                          <v-card-text
                            class="my-2 mx-2 py-1 px-2"
                            v-if="
                              element.etapa.id === 5 &&
                              coluna.id === 5 &&
                              ((getVelorioInfo(element, coluna) &&
                                getVelorioInfo(element, coluna).atividades &&
                                getVelorioInfo(element, coluna).atividades
                                  .length > 0) ||
                                element.localVelorio !== null ||
                                element.localSepultamento !== null ||
                                element.dataVelorio !== null ||
                                element.dataSepultamento !== null)
                            "
                            :style="`border: 1px solid ${coluna.cor}; border-left: 6px solid ${coluna.cor}; background-color: ${coluna.cor}1A;`"
                            style="border-radius: 10px; width: 94%"
                          >
                            <!-- Informações das atividades do velório -->
                            <template
                              v-if="
                                getVelorioInfo(element, coluna) &&
                                getVelorioInfo(element, coluna).atividades &&
                                getVelorioInfo(element, coluna).atividades
                                  .length > 0
                              "
                            >
                              <!-- Montagem -->
                              <template
                                v-for="atividade in getVelorioInfo(
                                  element,
                                  coluna,
                                ).atividades"
                              >
                                <template
                                  v-if="
                                    atividade.nome
                                      .toLowerCase()
                                      .includes('montagem') &&
                                    !atividade.nome
                                      .toLowerCase()
                                      .includes('des')
                                  "
                                >
                                  <strong class="text-purple-900"
                                    >Montagem</strong
                                  >
                                  <p class="my-0">
                                    <v-icon small :color="coluna.cor"
                                      >mdi-account</v-icon
                                    >
                                    {{ truncateString(atividade.agente, 18) }}
                                  </p>
                                  <p class="mt-0 mb-2">
                                    <v-icon small :color="coluna.cor"
                                      >mdi-clock-outline</v-icon
                                    >
                                    {{ atividade.inicio }}
                                  </p>
                                </template>
                              </template>

                              <!-- Desmontagem -->
                              <template
                                v-for="atividade in getVelorioInfo(
                                  element,
                                  coluna,
                                ).atividades"
                              >
                                <template
                                  v-if="
                                    atividade.nome
                                      .toLowerCase()
                                      .includes('desmontagem')
                                  "
                                >
                                  <strong class="text-purple-900"
                                    >Desmontagem</strong
                                  >
                                  <p class="my-0">
                                    <v-icon small :color="coluna.cor"
                                      >mdi-account</v-icon
                                    >
                                    {{ truncateString(atividade.agente, 18) }}
                                  </p>
                                  <p class="mt-0 mb-2">
                                    <v-icon small :color="coluna.cor"
                                      >mdi-clock-outline</v-icon
                                    >
                                    {{ atividade.inicio }}
                                  </p>
                                </template>
                              </template>

                              <!-- Cortejo -->
                              <template
                                v-for="atividade in getVelorioInfo(
                                  element,
                                  coluna,
                                ).atividades"
                              >
                                <template
                                  v-if="
                                    atividade.nome
                                      .toLowerCase()
                                      .includes('cortejo')
                                  "
                                >
                                  <strong class="text-purple-900"
                                    >Cortejo</strong
                                  >
                                  <p class="my-0">
                                    <v-icon small :color="coluna.cor"
                                      >mdi-account</v-icon
                                    >
                                    {{ truncateString(atividade.agente, 18) }}
                                  </p>
                                  <p class="mt-0 mb-2">
                                    <v-icon small :color="coluna.cor"
                                      >mdi-clock-outline</v-icon
                                    >
                                    {{ atividade.inicio }}
                                  </p>
                                </template>
                              </template>
                            </template>

                            <!-- Informações do velório e sepultamento -->
                            <strong
                              class="text-purple-900"
                              v-if="element.localVelorio"
                              >Velório</strong
                            >
                            <p class="my-0" v-if="element.localVelorio">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker</v-icon
                              >{{ element.localVelorio }}
                            </p>
                            <p class="mt-0 mb-2" v-if="element.dataVelorio">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-calendar</v-icon
                              >{{ element.dataVelorio }}
                            </p>
                            <strong
                              class="text-purple-900"
                              v-if="element.localSepultamento"
                            >
                              Sepultamento</strong
                            >
                            <p class="my-0" v-if="element.localSepultamento">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker</v-icon
                              >{{ element.localSepultamento }}
                            </p>
                            <p class="my-0" v-if="element.dataSepultamento">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-calendar</v-icon
                              >{{ element.dataSepultamento }}
                            </p>
                          </v-card-text>

                          <v-divider
                            class="my-2"
                            v-if="coluna.id === 6"
                          ></v-divider>
                          <v-card-text
                            class="my-2 mx-2 py-1 px-2"
                            v-if="coluna.id === 6"
                            :style="`border: 1px solid ${coluna.cor}; border-left: 6px solid ${coluna.cor}; background-color: ${coluna.cor}1A;`"
                            style="border-radius: 10px; width: 94%"
                          >
                            <!-- Transporte Familiar -->
                            <strong class="text-purple-900"
                              >Transporte Familiar</strong
                            >
                            <p class="my-0">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-car</v-icon
                              >
                              {{
                                element.tipoTransporteFamiliar ||
                                "Não informado"
                              }}
                            </p>
                            <p class="my-0">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker</v-icon
                              >
                              Origem:
                              {{
                                element.origemTransporteFamiliar ||
                                "Não informado"
                              }}
                            </p>
                            <p class="my-0">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker</v-icon
                              >
                              Destino:
                              {{
                                element.destinoTransporteFamiliar ||
                                "Não informado"
                              }}
                            </p>
                            <p
                              class="my-0"
                              v-if="element.linkidaTransporteFamiliar"
                            >
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-link-variant</v-icon
                              >
                              <a
                                :href="
                                  normalizarLinkExterno(
                                    element.linkidaTransporteFamiliar,
                                  )
                                "
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Abrir link da ida
                              </a>
                            </p>
                            <p
                              class="my-0"
                              v-if="element.linkvoltaTransporteFamiliar"
                            >
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-link-variant</v-icon
                              >
                              <a
                                :href="
                                  normalizarLinkExterno(
                                    element.linkvoltaTransporteFamiliar,
                                  )
                                "
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Abrir link da volta
                              </a>
                            </p>
                            <p class="my-0">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-text</v-icon
                              >
                              Obs:
                              {{
                                element.observacoesTransporteFamiliar ||
                                "Sem observações"
                              }}
                            </p>
                            <template
                              v-for="atividade in getTransporteFamiliarInfo(
                                element,
                                coluna,
                              ) &&
                              getTransporteFamiliarInfo(element, coluna)
                                .atividades
                                ? getTransporteFamiliarInfo(element, coluna)
                                    .atividades
                                : []"
                            >
                              <template
                                v-if="
                                  atividade.nome.toLowerCase().includes('ida')
                                "
                              >
                                <p class="my-0">
                                  <v-icon small class="mr-1" :color="coluna.cor"
                                    >mdi-arrow-right</v-icon
                                  >
                                  Ida:
                                </p>
                                <span class="ml-6">
                                  {{
                                    truncateString(atividade.agente, 18) ||
                                    "Não informado"
                                  }}
                                </span>
                                <span class="ml-6">
                                  {{ atividade.inicio || "Não informado" }}
                                </span>
                              </template>
                              <template
                                v-if="
                                  atividade.nome.toLowerCase().includes('volta')
                                "
                              >
                                <p class="my-0">
                                  <v-icon small class="mr-1" :color="coluna.cor"
                                    >mdi-arrow-left</v-icon
                                  >
                                  Volta:
                                </p>
                                <span class="ml-6">
                                  {{
                                    truncateString(atividade.agente, 18) ||
                                    "Não informado"
                                  }}
                                </span>
                                <span class="ml-6">
                                  {{ atividade.inicio || "Não informado" }}
                                </span>
                              </template>
                            </template>
                          </v-card-text>

                          <v-card-actions class="justify-center">
                            <v-btn
                              :color="coluna.cor"
                              small
                              @click="abrirDialog(element)"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                            <v-btn
                              :color="coluna.cor"
                              small
                              :disabled="
                                element.etapa.tipo !== 'Em andamento' ||
                                !hasPermissionEdit
                              "
                              @click.stop="abrirDialogAtribuir(element, coluna)"
                            >
                              <v-icon>mdi-account-multiple-plus</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="playOrPause(element, coluna)"
                              small
                              :color="coluna.cor"
                              :disabled="
                                element.etapa.tipo == 'Falha' ||
                                element.etapa.tipo == 'Finalizado' ||
                                !hasPermissionEdit
                              "
                              @click.stop="handlePlayButton(element, coluna)"
                            >
                              <v-icon>mdi-play</v-icon>
                            </v-btn>
                            <v-btn
                              v-else
                              small
                              :color="coluna.cor"
                              :disabled="
                                element.etapa.tipo !== 'Em andamento' ||
                                element.etapa.tipo == 'Falha' ||
                                element.etapa.tipo == 'Finalizado' ||
                                !hasPermissionEdit
                              "
                              @click.stop="
                                abrirDialogFinalizarEtapa(element, coluna)
                              "
                            >
                              <v-icon>mdi-check</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card>

                        <!-- Botão Carregar Mais para kanban -->
                        <div
                          v-if="temMaisItensColuna(coluna.id)"
                          :key="`load-more-${coluna.id}`"
                          class="text-center my-2"
                        >
                          <v-btn
                            text
                            small
                            :color="coluna.cor"
                            @click="carregarMaisItensColuna(coluna.id)"
                          >
                            <v-icon small left>mdi-chevron-down</v-icon>
                            Carregar mais
                          </v-btn>
                        </div>

                        <v-card
                          v-if="
                            getItensVisiveisPorColuna(coluna.id).length === 0
                          "
                          key="empty"
                          class="text-center"
                          elevation="0"
                          style="background-color: #fafafa"
                        >
                          <v-card-text>Nenhum serviço encontrado</v-card-text>
                        </v-card>
                      </transition-group>
                    </VueDraggable>
                  </div>
                </v-card>
              </div>
            </div>
          </div>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-end align-center mt-4">
            <v-btn color="primary" small @click="init">
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </pulse-card>
    </div>
  </div>
</template>

<script>
import VueDraggable from "vuedraggable";
import { Html5Qrcode } from "html5-qrcode";
import QRCode from "qrcode";
import jsPDF from "jspdf";
import FiltroComponent from "./components/FiltroFuneraria.vue";
import FluxoTipoEtapaChips from "./components/FluxoTipoEtapaChips.vue";
import previdaLogo from "../../assets/previda_logo.png";
import authHeader from "../../services/auth-header";
import { http } from "../../services/config";
import funerariaService from "../../services/funeraria";
import conexaoIvertexService from "../../services/conexaoIvertex";

import rh from "../../services/rh";
export default {
  name: "Obitos",
  components: {
    FiltroComponent,
    VueDraggable,
    FluxoTipoEtapaChips,
  },
  watch: {
    panel: function (newVal) {
      // Se o painel foi aberto (newVal não é vazio)
      if (newVal && newVal.length > 0) {
        // Obter o ID da coluna correspondente ao índice do painel aberto
        const colunasFiltradas = this.colunas.filter(
          (c) => c.tipo === "Em andamento",
        );
        const panelIndex = newVal[0]; // Pega o primeiro painel aberto
        if (colunasFiltradas[panelIndex]) {
          const colunaId = colunasFiltradas[panelIndex].id;
          this.alterarExpansionPanel(colunaId);
        }
      }
    },
    fluxoViewMode(newVal) {
      if (newVal !== "table" && this.listarExcluidos) {
        this.listarExcluidos = false;
        this.init();
      }
    },
    filtroEtapaSelecionado() {
      this.agendarCarregamentoResumoCards();
    },
    buscaFunerarios() {
      this.agendarCarregamentoResumoCards();
    },
    pendenciasFiltroSelecionadas: {
      handler() {
        this.agendarCarregamentoResumoCards();
      },
      deep: true,
    },
    tagsFiltroSelecionadas: {
      handler() {
        this.agendarCarregamentoResumoCards();
      },
      deep: true,
    },
    tiposEtapaFiltroSelecionados: {
      handler() {
        this.agendarCarregamentoResumoCards();
      },
      deep: true,
    },
  },
  async mounted() {
    this.carregarUserLogado();
    this.selectedOpcao = "Falecimento";
    const fim = new Date();
    const inicio = new Date(fim);
    inicio.setDate(fim.getDate() - 7);
    this.selectedStartDate = this.formatDateBR(inicio);
    this.selectedEndDate = this.formatDateBR(fim);
    this.checkIfMobile();
    await this.init();
    await this.abrirAtendimentoDaRota();
    setTimeout(() => {
      this.verificarDialogos();
    }, 300000);
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
    const isMobile = window.innerWidth <= 768;

    if (isMobile && this.$refs.filtro?.alternarVisibilidade) {
      this.$refs.filtro.alternarVisibilidade(false);
    }
  },

  data() {
    return {
      isMobile: false,
      detalhesCards: false,
      buscaFunerarios: "",
      servicosFunerariosOriginal: [],
      itensTransporteFamiliarOriginal: [],
      etapaTransporteFamiliarFixa: {
        id: 6,
        nome: "Transporte familiar",
        cor: "#3F51B5",
        tipo: "Em andamento",
        sla: 60,
        etapaSuporte: false,
      },
      // Auto-scroll variables
      autoScrollInterval: null,
      scrollSpeed: 10,
      scrollThreshold: 100, // Distance from edge to trigger scrolling
      alertDialog: {
        show: false,
        title: "",
        message: "",
      },
      confirmDialog: {
        show: false,
        title: "",
        message: "",
        loading: false,
        onConfirm: null,
      },
      userLogado: null,
      hasPermissionEdit: true,
      hasPermissionDelete: false,
      hasPermissionCreate: false,
      modoCriacaoManual: false,
      verificandoConexaoIvertex: false,
      conexaoIvertexAtiva: null,
      falhaVerificacaoConexaoIvertex: false,
      consultaStatusIvertexEmAndamento: null,
      tab: 0,
      panel: [],
      // Controle de paginação para o kanban
      paginacaoKanban: {
        itensVisiveisPorColuna: 5, // Número inicial de itens visíveis por coluna
        incremento: 5, // Quantidade de itens a mais ao clicar em "Carregar mais"
      },
      // Controle de paginação para a lista de cards
      paginacaoLista: {
        itensVisiveis: 10, // Número inicial de itens visíveis na lista
        incremento: 10, // Quantidade de itens a mais ao clicar em "Carregar mais"
      },
      // Dados para o diálogo de etapa específica
      dialogEtapa: false,
      etapaAcao: "iniciar", // 'iniciar' ou 'finalizar'
      etapaAtual: null, // Coluna atual selecionada
      servicoAtual: null, // Serviço atual selecionado
      historico: null,
      atividades: null,
      atividadesDisponiveis: [],
      atividadesDisponiveisPorEtapa: {},
      etapaDadosTemp: {
        dataHoraInicio: null,
        dataHoraFim: null,
        colaboradores: [],
        supervisores: [],
        observacoes: null,
        ocorrenciaJustificativa: null,
        ocorrenciaOpcao: null,
        tempoOcorrencia: 0,
        tempoOcorrenciaFormatted: "00:00",
        vtr: null,
        salaPreparacao: null,
        etapaDispensada: false,
      },
      // Variável para controlar etapas com campos de ocorrência expandidos
      etapasComOcorrencia: [],
      opcoesOcorrencia: [
        "AGUARDANDO TRANSLADO",
        "AGUARDANDO IML",
        "AGUARDANDO SVO",
        "AGUARDANDO HOSPITAL",
        "OUTROS",
      ],
      etapasComAtividades: [],
      colaboradoresTempSomato: [],
      novaAtividadeEtapa: {},
      salvandoAtividadeEtapa: null,
      excluindoAtividade: null,
      atualizandoAtividade: null,
      // Controle do diálogo de atribuição
      dialogAtribuir: false,
      atribuirTicketId: null,
      atribuirEtapaId: null,
      atribuirNomeFalecido: "",
      atribuirNomeEtapa: "",
      headers: [
        { text: "Atend.", value: "idAtendimento" },
        { text: "Falecido", value: "nomeFalecido" },
        { text: "Data Atendimento", value: "dataAtendimento" },
        { text: "Etapa", value: "etapa.nome" },
        { text: "ações", value: "acoes" },
      ],
      funerarioListHeaders: [
        { text: "Atend.", value: "idAtendimento" },
        { text: "Falecido / Cliente", value: "nomeFalecido" },
        { text: "Contrato", value: "contrato" },
        { text: "Etapa", value: "etapa.nome" },
        { text: "Atendimento", value: "dataAtendimento" },
        { text: "Data Velório", value: "dataVelorio" },
        { text: "Local Velório", value: "localVelorio" },
        { text: "Data Sepult.", value: "dataSepultamento" },
        { text: "Local Sepult.", value: "localSepultamento" },
        { text: "Pendência", value: "pendencia" },
        { text: "Tags", value: "tags", sortable: false },
      ],
      historicoHeaders: [
        { text: "Campo Alterado", value: "campoAlterado" },
        { text: "Valor Anterior", value: "valorAntigo" },
        { text: "Valor Novo", value: "valorNovo" },
        { text: "Data da Alteração", value: "dataAlteracao" },
        { text: "Responsável", value: "usuarioResponsavel" },
      ],
      atividadesHeaders: [
        { text: "Atividade", value: "atividadeFunerariaDescricao" },
        { text: "Data Início", value: "dtInicio" },
        { text: "Data Fim", value: "dtFim" },
        { text: "Colaboradores", value: "colaboradores" },
        { text: "Ações", value: "acoes", sortable: false, width: "100px" },
      ],
      atividadesHeadersv2: [
        {
          text: "Detalhes",
          value: "detalhes",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ],
      headersSincronizacaoIvertex: [
        { text: "", value: "selecionado", sortable: false, width: "56px" },
        { text: "Campo", value: "rotulo" },
        { text: "Valor atual", value: "valorAtual" },
        { text: "Valor iVertex", value: "valorIvertex" },
      ],
      headersItens: [
        { text: "Item", value: "nomeItem", width: "300px" },
        { text: "Grade", value: "nomeGradeItem" },
        { text: "Valor Original", value: "valorOriginal" },
        { text: "Quantidade", value: "quantidade" },
        { text: "Valor Unitário", value: "valorUnitario" },
        { text: "Desconto Aplicado", value: "descontoAplicado" },
        { text: "Valor Total", value: "valorTotal" },
      ],
      servicosfunerarios: [],
      resumoCards: [
        {
          chave: "totalFiltrado",
          titulo: "Atendimentos",
          valor: 0,
          subtitulo: "Atendimentos solicitados hoje",
          subValor: 0,
          color: "green",
          icon: "mdi-cross",
          tooltip:
            "Tickets que correspondem aos filtros aplicados na listagem/ Tickets com data de atendimento no dia atual.",
        },
        {
          chave: "somato",
          titulo: "Somato no",
          sufixoPeriodo: true,
          valor: 0,
          subtitulo: "Solicitadas ou em andamento",
          subValor: 0,
          color: "indigo",
          icon: "mdi-flask-outline",
          tooltip:
            "Tickets do período com uso de somatoconservação/ Tickets com somatoconservação solicitada ou com a etapa iniciada e ainda não concluída.",
        },
        {
          chave: "transporte",
          titulo: "Transporte no",
          sufixoPeriodo: true,
          valor: 0,
          subtitulo: "Solicitados ou em andamento",
          subValor: 0,
          color: "blue",
          icon: "mdi-van-passenger",
          tooltip:
            "Tickets do período com transporte familiar solicitado/ Tickets com transporte solicitado ou com a etapa iniciada e ainda não concluída.",
        },
        {
          chave: "colaboradores",
          titulo: "Equipe escalada",
          valor: 0,
          subtitulo: "Em intervalo agora",
          subValor: 0,
          color: "teal",
          icon: "mdi-account-group-outline",
          tooltip:
            "Colaboradores em horário de escala agora, fora do intervalo e sem férias/ Colaboradores no intervalo entre os turnos da escala.",
        },
      ],
      isLoadingResumoCards: false,
      resumoCardsTimer: null,
      pendenciasFiltroSelecionadas: [],
      tagsFiltroSelecionadas: [],
      tagsDisponiveis: [],
      tagsServicoEditando: [],
      tagsServicoEditandoOriginal: [],
      salvandoTagsServico: false,
      listarExcluidos: false,
      syncStatus: null,
      syncLoading: false,
      selectedStartDate: "",
      selectedEndDate: "",
      isLoading: false,
      exibicaoFiltroPai: null,
      modos: ["Em abertos", "Abertura do Atendimento", "Conclusão do Atendimento"],
      tipoDataFiltro: "abertos",
      showFilter: false,
      showProgress: false,
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
        "Todas",
      ],
      exibicao: true,
      fluxoViewMode: "kanban",
      exportandoFunerario: false,
      meusTickets: false,
      somenteFavoritos: false,
      somenteComPendencia: false,
      filtroEtapaSelecionado: 0,
      colunas: [],
      tiposEtapaFiltroSelecionados: [],
      tiposEtapaFiltroInicializado: false,
      colunasFiltros: [],
      colunasSuporte: [],
      tarefasPorColuna: [],
      listaColaboradores: [],
      listaColaboradoresSAC: [],
      dialogEdicao: false,
      dialogSincronizacaoIvertex: false,
      dadosIvertexSincronizacao: null,
      diferencasIvertex: [],
      dialogExcluirAtendimento: false,
      confirmarExclusaoAtendimento: false,
      excluindoAtendimento: false,
      servicoEditando: {
        id: null,
        etapa: {
          id: null,
          nome: "",
          cor: "",
        },
        idAtendimento: null,
        dataAtendimento: "",
        origem: "",
        destino: "",
        obs: "",
        atendente: "",
        cpfAtendente: "",
        contrato: null,
        tipoContrato: null,
        idDeclarante: null,
        declarante: null,
        cpfDeclarante: null,
        parentescoDeclarante: "",
        idCliente: null,
        cliente: "",
        cpfCliente: "",
        idFalecido: null,
        nomeFalecido: "",
        cpfFalecido: "",
        alturaFalecido: 0,
        pesoFalecido: 0,
        item: "",
        dtFalecido: "",
        valorAtendimento: 0,
        nascimentoFalecido: "",
        etapas: [],
        tags: [],
        donoAtendimento: 0,
        pendencia: null,
      },
      dialogConcluir: false,
      // Controle do dialog de pendência na conclusão
      dialogPendencia: false,
      salvandoPendencia: false,
      statusConclusaoPendente: null,
      servicoConclusaoPendente: null,
      pendencia: null,
      // Controle da aba de procedimentos no dialog de edição
      procedimentosEdicao: [],
      salvandoRespostaRapida: null,
      filtroProcedimentosPendentes: false,
      opcoesRespostaSimNao: [
        { valor: "sim", texto: "Sim", cor: "success", icone: "mdi-check" },
        { valor: "nao", texto: "Não", cor: "error", icone: "mdi-close" },
      ],
      paginaProcedimentos: 1,
      carregandoProcedimentosEdicao: false,
      excluindoProcedimentoEdicao: null,
      procedimentoExcluindo: null,
      // Controle do dialog de resposta de procedimento
      dialogProcedimentoResposta: false,
      procedimentoRespondendo: null,
      modoRespostaProcedimento: null,
      salvandoProcedimentoResposta: false,
      pendencias: [
        "Entrega das Memórias",
        "Liberação Judicial ou Documental",
        "Erro de lançamento",
        "Duplicidade",
      ],
      novaAtividade: {
        atividadeFunerariaId: null,
        atividadeFunerariaDescricao: "",
        dtInicio: null,
        dtFim: null,
        tempoOcorrencia: null,
        colaboradores: [],
      },
      salvandoAtividade: false,
      excluindoAtividade: null,
      autorizacoesRetiradas: [],
      modoEdicaoAtividade: false,
      atividadeEditandoId: null,
      editandoAtividade: false,

      // Gerenciamento de Itens
      dialogExcluirItem: false,
      itemParaExcluir: null,
      loadingExclusao: false,

      dialogTrocarUrna: false,
      itemUrnaAtual: null,
      produtosUrna: [],
      carregandoProdutosUrna: false,
      novaUrnaSelecionada: null,
      descontoTrocaUrna: 0,
      loadingTrocaUrna: false,
      dialogValidarUrna: false,
      itemUrnaValidacao: null,
      qrcodeUrnaManual: "",
      resultadoValidacaoUrna: null,
      validandoUrna: false,
      trocandoUrnaPorQrcode: false,
      erroCameraUrna: null,
      urnaQrScanner: null,
      timeoutFecharValidacaoUrna: null,
      dialogAvisoTrocaUrnaValidada: false,
      cienteTrocaUrnaValidada: false,
      itemUrnaAvisoTroca: null,

      dialogDescontoItem: false,
      itemDesconto: null,
      valorDescontoItem: 0,
      loadingDescontoItem: false,

      dialogRecarregarCobertura: false,
      loadingRecarregarCobertura: false,

      gerandoPdfQrcodes: false,
      dialogEstoqueQrcodesUrnas: false,
      estoqueImpressaoQrcode: null,
      sincronizandoAtendimento: false,

      dialogEditarItem: false,
      itemEditando: null,
      quantidadeEditando: 0,
      loadingEditarItem: false,
      estoqueSalvandoItemId: null,
      estoquesUrna: [
        { text: "Empresa A - Sede", value: "Previda Sede" },
        { text: "Arapiraca", value: "Arapiraca" },
        { text: "Palmeira dos Índios", value: "Palmeira dos Índios" },
        { text: "Empresa D", value: "Memorial Parque Maceió" },
        { text: "Central de Velórios", value: "Central de Velórios" },
        { text: "Empresa E", value: "Parque das Flores" },
      ],

      dialogAdicionarItem: false,
      itensCoberturaDisponiveis: [],
      itemSelecionadoParaAdicionar: null,
      paginaItensCobertura: 1,
      loadingItensCobertura: false,
      loadingAdicionarItem: false,
      viaturasLista: [
        "SAVEIRO 01",
        "SAVEIRO 02",
        "SAVEIRO 02.2",
        "SAVEIRO 03",
        "SAVEIRO 03.2",
        "SAVEIRO 04",
        "SAVEIRO 04.2",
        "SAVEIRO 05",
        "SAVEIRO 06",
        "SAVEIRO 07",
        "SAVEIRO 07.2",
        "SAVEIRO 08",
        "SAVEIRO 08.2",
        "SAVEIRO 09",
        "SAVEIRO 10",
        "PEUGEOT 21",
        "S10 17",
        "S10 18",
        "S10 19",
        "TORO 22",
        "TORO 23",
        "MOTO SERVIÇO 02",
        "MOTO SERVIÇO 03",
        "VAN 12",
        "VAN 13",
        "VAN 14",
        "VAN 15",
        "VAN 16",
        "HB20 20",
        "SAVEIRO ABERTA",
        "LIMOUSINE",
      ],
    };
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkIfMobile);

    // Clean up auto-scroll event listeners
    document.removeEventListener("mousemove", this.checkAutoScroll);
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    }
    if (this.resumoCardsTimer) {
      clearTimeout(this.resumoCardsTimer);
      this.resumoCardsTimer = null;
    }
    this.pararLeitorUrna();
  },
  computed: {
    camposIvertexBloqueados() {
      return this.conexaoIvertexAtiva === true;
    },
    podeExcluirAtendimento() {
      return this.hasPermissionDelete === true;
    },
    totalServicosFunerariosUnicos() {
      const ids = new Set();

      this.servicosfunerarios.forEach((servico) => {
        const id = servico.id ?? servico.idAtendimento;
        if (id !== null && id !== undefined) {
          ids.add(id);
        }
      });

      return ids.size;
    },
    ultimaSyncTexto() {
      if (!this.syncStatus || !this.syncStatus.ultimaSyncEm) {
        return "não realizada";
      }
      return this.formatarDataHoraSync(this.syncStatus.ultimaSyncEm);
    },
    // Ordena itens: Urna > Produtos (tipo 1) > Servicos (tipo 2)
    itensOrdenados() {
      if (!this.servicoEditando?.itens) return [];
      return this.servicoEditando.itens
        .map((item, index) => ({ item, index }))
        .sort((a, b) => {
          const grupoA = this.getGrupoOrdenacaoItem(a.item);
          const grupoB = this.getGrupoOrdenacaoItem(b.item);

          if (grupoA !== grupoB) return grupoA - grupoB;

          if (grupoA === 2) {
            const destaqueA = this.getDestaqueServicoItem(a.item);
            const destaqueB = this.getDestaqueServicoItem(b.item);
            const prioridadeA = destaqueA ? destaqueA.prioridade : 99;
            const prioridadeB = destaqueB ? destaqueB.prioridade : 99;

            if (prioridadeA !== prioridadeB) {
              return prioridadeA - prioridadeB;
            }
          }

          return a.index - b.index;
        })
        .map(({ item }) => item);
    },
    // Filtra itens da cobertura que não existem na lista atual + itens fixos
    itensCoberturaFiltrados() {
      // Itens fixos de somatoconservação
      const itensFixos = [
        {
          idItem: 20,
          nomeItem: "FP - SOMATOCONSERVAÇÃO - 24H",
          nomeGradeItem: "",
          idGradeItem: 0,
          tipo: 2,
          isUrna: false,
          quantidade: 1,
          valorUnitario: 700.0,
          descontoAplicado: 0,
          valorTotal: 700.0,
          valorOriginal: 700.0,
        },
        {
          idItem: 22,
          nomeItem: "FP - SOMATOCONSERVAÇÃO - 36H",
          nomeGradeItem: "",
          idGradeItem: 0,
          tipo: 2,
          isUrna: false,
          quantidade: 1,
          valorUnitario: 950.0,
          descontoAplicado: 0,
          valorTotal: 950.0,
          valorOriginal: 950.0,
        },
        {
          idItem: 318,
          nomeItem: "FP - SOMATOCONSERVAÇÃO - 48H",
          nomeGradeItem: "",
          idGradeItem: 0,
          tipo: 2,
          isUrna: false,
          quantidade: 1,
          valorUnitario: 1100.0,
          descontoAplicado: 0,
          valorTotal: 1100.0,
          valorOriginal: 1100.0,
        },
        {
          idItem: 320,
          nomeItem: "FP - SOMATOCONSERVAÇÃO - 60H",
          nomeGradeItem: "",
          idGradeItem: 0,
          tipo: 2,
          isUrna: false,
          quantidade: 1,
          valorUnitario: 1350.0,
          descontoAplicado: 0,
          valorTotal: 1350.0,
          valorOriginal: 1350.0,
        },
        {
          idItem: 23,
          nomeItem: "FP - SOMATOCONSERVAÇÃO - 72H",
          nomeGradeItem: "",
          idGradeItem: 0,
          tipo: 2,
          isUrna: false,
          quantidade: 1,
          valorUnitario: 2200.0,
          descontoAplicado: 0,
          valorTotal: 2200.0,
          valorOriginal: 2200.0,
        },
        {
          idItem: 1001,
          nomeItem: "CV - ALUGUEL CAPELA CENTRAL DE VELÓRIOS - 01",
          nomeGradeItem: "",
          idGradeItem: 0,
          tipo: 2,
          isUrna: false,
          quantidade: 1,
          valorUnitario: 550.0,
          descontoAplicado: 0,
          valorTotal: 550.0,
          valorOriginal: 550.0,
        },
        {
          idItem: 1002,
          nomeItem: "CV - ALUGUEL CAPELA CENTRAL DE VELÓRIOS - 02",
          nomeGradeItem: "",
          idGradeItem: 0,
          tipo: 2,
          isUrna: false,
          quantidade: 1,
          valorUnitario: 550.0,
          descontoAplicado: 0,
          valorTotal: 550.0,
          valorOriginal: 550.0,
        },
        {
          idItem: 1003,
          nomeItem: "CV - ALUGUEL CAPELA CENTRAL DE VELÓRIOS - 03",
          nomeGradeItem: "",
          idGradeItem: 0,
          tipo: 2,
          isUrna: false,
          quantidade: 1,
          valorUnitario: 550.0,
          descontoAplicado: 0,
          valorTotal: 550.0,
          valorOriginal: 550.0,
        },
        {
          idItem: 1004,
          nomeItem: "CV - ALUGUEL CAPELA CENTRAL DE VELÓRIOS - 04",
          nomeGradeItem: "",
          idGradeItem: 0,
          tipo: 2,
          isUrna: false,
          quantidade: 1,
          valorUnitario: 550.0,
          descontoAplicado: 0,
          valorTotal: 550.0,
          valorOriginal: 550.0,
        },
        {
          idItem: 1005,
          nomeItem: "CV - ALUGUEL CAPELA CENTRAL DE VELÓRIOS - 05",
          nomeGradeItem: "",
          idGradeItem: 0,
          tipo: 2,
          isUrna: false,
          quantidade: 1,
          valorUnitario: 550.0,
          descontoAplicado: 0,
          valorTotal: 550.0,
          valorOriginal: 550.0,
        },
        {
          idItem: 938,
          nomeItem: "MANTO",
          nomeGradeItem: "PADRAO",
          idGradeItem: 267,
          tipo: 1,
          isUrna: false,
          quantidade: 1,
          valorUnitario: 0.0,
          descontoAplicado: 0,
          valorTotal: 0.0,
          valorOriginal: 0.0,
        },
      ];

      if (!this.itensCoberturaDisponiveis || !this.servicoEditando?.itens) {
        return itensFixos;
      }

      const nomesExistentes = new Set(
        this.servicoEditando.itens.map((item) => item.nomeItem),
      );

      // Filtra itens da API que não existem
      const itensApiFiltrados = this.itensCoberturaDisponiveis.filter(
        (item) => !nomesExistentes.has(item.nomeItem),
      );

      // Filtra itens fixos que não existem
      const itensFixosFiltrados = itensFixos.filter(
        (item) => !nomesExistentes.has(item.nomeItem),
      );

      // Combina: primeiro itens da API, depois itens fixos
      return [...itensApiFiltrados, ...itensFixosFiltrados];
    },
    itensCoberturaFiltradosPaginados() {
      const inicio = (this.paginaItensCobertura - 1) * 8;
      return this.itensCoberturaFiltrados.slice(inicio, inicio + 8);
    },
    getEtapaFiltrada() {
      if (!this.colunasFiltros || this.colunasFiltros.length === 0) return null;
      return (
        this.colunasFiltros.find(
          (coluna) => coluna.id === this.filtroEtapaSelecionado,
        ) || this.colunasFiltros[0]
      );
    },
    temEtapaAnterior() {
      if (!this.colunasFiltros || this.colunasFiltros.length === 0)
        return false;
      const indiceAtual = this.colunasFiltros.findIndex(
        (coluna) => coluna.id === this.filtroEtapaSelecionado,
      );
      return indiceAtual > 0;
    },
    temEtapaProxima() {
      if (!this.colunasFiltros || this.colunasFiltros.length === 0)
        return false;
      const indiceAtual = this.colunasFiltros.findIndex(
        (coluna) => coluna.id === this.filtroEtapaSelecionado,
      );
      return indiceAtual < this.colunasFiltros.length - 1 && indiceAtual !== -1;
    },
    // Filtra os serviços funerários com base na seleção do filtro
    pendenciasFiltroOptions() {
      const pendencias = new Set();
      this.servicosfunerarios.forEach((item) => {
        const pendencia = this.normalizarPendenciaFiltro(item.pendencia);
        if (pendencia) {
          pendencias.add(pendencia);
        }
      });
      return Array.from(pendencias).sort((a, b) => a.localeCompare(b));
    },
    tagsFiltroOptions() {
      const tagsPorId = new Map();
      this.servicosfunerarios.forEach((item) => {
        this.normalizarTags(item.tags).forEach((tag) => {
          if (tag && tag.id && !tagsPorId.has(tag.id)) {
            tagsPorId.set(tag.id, tag);
          }
        });
      });
      return Array.from(tagsPorId.values()).sort((a, b) =>
        String(a.nome || "").localeCompare(String(b.nome || "")),
      );
    },
    servicosFunerariosComFiltro() {
      // Primeiro, aplica o filtro de etapas
      let itens = [];

      // Exclui itens sem etapa definida
      const comEtapa = this.servicosfunerarios.filter((item) => item.etapa);

      // Se o filtro for 0 (todas) ou não houver filtro, usa todos os itens
      if (this.filtroEtapaSelecionado === 0 || !this.filtroEtapaSelecionado) {
        itens = comEtapa;
      } else {
        // Caso contrário, filtra pelos IDs de etapa selecionados
        itens = comEtapa.filter(
          (item) => this.filtroEtapaSelecionado === item.etapa.id,
        );
      }

      const tiposAtivos = this.getTiposEtapaFiltroAtivos();
      if (tiposAtivos.length) {
        itens = itens.filter((item) => tiposAtivos.includes(item.etapa?.tipo));
      }

      // Se não houver termo de busca, retorna os itens filtrados apenas por etapa
      if (
        this.fluxoViewMode === "table" &&
        this.pendenciasFiltroSelecionadas.length
      ) {
        const pendenciasSelecionadas = new Set(
          this.pendenciasFiltroSelecionadas,
        );
        itens = itens.filter((item) =>
          pendenciasSelecionadas.has(
            this.normalizarPendenciaFiltro(item.pendencia),
          ),
        );
      }

      itens = itens.filter(this.passaFiltrosRapidos);

      if (!this.buscaFunerarios || this.buscaFunerarios.trim() === "") {
        return itens;
      }

      // Aplica o filtro de busca por texto (case insensitive)
      const termoBusca = this.buscaFunerarios.toLowerCase().trim();
      return itens.filter((item) => {
        const idAtendimento = item.idAtendimento
          ? item.idAtendimento.toString().toLowerCase()
          : "";
        const nomeFalecido = item.nomeFalecido
          ? item.nomeFalecido.toLowerCase()
          : "";
        const nomeCliente = item.nomeCliente
          ? item.nomeCliente.toLowerCase()
          : "";

        return (
          idAtendimento.includes(termoBusca) ||
          nomeFalecido.includes(termoBusca) ||
          nomeCliente.includes(termoBusca)
        );
      });
    },

    // Filtra os itens de transporte familiar com base na seleção do filtro
    getItensTransporteFamiliarComFiltro() {
      // Primeiro verifica se deve exibir com base no filtro de etapas
      let itens = [];

      if (
        this.filtroEtapaSelecionado === 0 ||
        this.filtroEtapaSelecionado === 6
      ) {
        itens = this.getItensTransporteFamiliar.filter(this.passaFiltrosRapidos);
      } else {
        return [];
      }

      const tiposAtivos = this.getTiposEtapaFiltroAtivos();
      if (tiposAtivos.length && !tiposAtivos.includes("Em andamento")) {
        return [];
      }

      // Se nÃ£o houver termo de busca, retorna os itens filtrados apenas por etapa
      if (!this.buscaFunerarios || this.buscaFunerarios.trim() === "") {
        return itens;
      }

      // Aplica o filtro de busca por texto (case insensitive)
      const termoBusca = this.buscaFunerarios.toLowerCase().trim();
      return itens.filter((item) => {
        const idAtendimento = item.idAtendimento
          ? item.idAtendimento.toString().toLowerCase()
          : "";
        const nomeFalecido = item.nomeFalecido
          ? item.nomeFalecido.toLowerCase()
          : "";
        const nomeCliente = item.nomeCliente
          ? item.nomeCliente.toLowerCase()
          : "";

        return (
          idAtendimento.includes(termoBusca) ||
          nomeFalecido.includes(termoBusca) ||
          nomeCliente.includes(termoBusca)
        );
      });
    },

    deveExibirCards() {
      return this.isMobile || this.fluxoViewMode === "cards";
    },

    deveExibirKanban() {
      return !this.isMobile && this.fluxoViewMode === "kanban";
    },

    deveExibirTabela() {
      return !this.isMobile && this.fluxoViewMode === "table";
    },

    servicosFunerariosTabela() {
      let itens = [
        ...this.servicosFunerariosComFiltro,
        ...this.getItensTransporteFamiliarComFiltro,
      ];
      if (this.pendenciasFiltroSelecionadas.length) {
        const pendenciasSelecionadas = new Set(
          this.pendenciasFiltroSelecionadas,
        );
        const totalAntes = itens.length;
        itens = itens.filter((item) =>
          pendenciasSelecionadas.has(
            this.normalizarPendenciaFiltro(item.pendencia),
          ),
        );
      }
      return itens.filter(this.passaFiltrosRapidos);
    },

    tiposEtapaFiltroItems() {
      return this.getTiposEtapaDisponiveis().map((tipo) => ({
        value: tipo,
        label: tipo,
        color: this.getCorTipoEtapa(tipo),
        count: this.getQuantidadeColunasPorTipo(tipo),
      }));
    },

    handleEtapaSelection() {
      if (this.filtroEtapaSelecionado === 0) {
        this.filtroEtapaSelecionado = 0;
      }
    },

    getItensTransporteFamiliar() {
      // Filtrar serviços funerários que não estão na etapa 6 (transporte familiar)
      // e que têm solicitação de transporte familiar como "SOLICITADO" ou "A DEFINIR"
      return this.servicosfunerarios.filter((item) => {
        const etapaTransporte = item.etapas.find((e) => e.etapaId === 6);
        const transporteNaoConcluido =
          !etapaTransporte || !etapaTransporte.dtFim;

        return (
          item.solicitacaoTransporteFamiliar &&
          (item.solicitacaoTransporteFamiliar.includes("SOLICITADO") ||
            item.solicitacaoTransporteFamiliar.includes("A DEFINIR")) &&
          transporteNaoConcluido &&
          item.etapa.id !== 6 &&
          item.etapa.tipo === "Em andamento"
        );
      });
    },
    todosColaboradoresOrdenados() {
      // Combina as duas listas de colaboradores
      const todosColaboradores = [
        ...this.listaColaboradores,
        ...this.listaColaboradoresSAC,
      ];

      // Remove possíveis duplicatas (caso algum colaborador esteja nas duas listas)
      const colaboradoresUnicos = todosColaboradores.filter(
        (colaborador, index, self) =>
          index === self.findIndex((c) => c.id === colaborador.id),
      );

      // Ordena por nome em ordem alfabética
      return colaboradoresUnicos.sort((a, b) => {
        if (a.nome && b.nome) {
          return a.nome.localeCompare(b.nome);
        }
        return 0;
      });
    },
    duracaoSomatoConservacao() {
      if (
        !this.servicoEditando.dataInicioSomato ||
        !this.servicoEditando.dataFimSomato
      ) {
        return "";
      }

      const dataInicio = new Date(this.servicoEditando.dataInicioSomato);
      const dataFim = new Date(this.servicoEditando.dataFimSomato);
      const diferencaMs = dataFim.getTime() - dataInicio.getTime();

      const horasTotais = Math.floor(diferencaMs / (1000 * 60 * 60));

      return `${horasTotais} horas`;
    },
    procedimentosSemRespostaCount() {
      return this.procedimentosEdicao.filter((p) => !p.resposta).length;
    },
    procedimentosEdicaoFiltrados() {
      return this.filtroProcedimentosPendentes
        ? this.procedimentosEdicao.filter((p) => !p.resposta)
        : this.procedimentosEdicao;
    },
    procedimentosEdicaoPaginados() {
      const inicio = (this.paginaProcedimentos - 1) * 10;
      return this.procedimentosEdicaoFiltrados.slice(inicio, inicio + 10);
    },
    // Valida se o procedimento em edição possui resposta preenchida
    procedimentoRespostaValida() {
      if (!this.procedimentoRespondendo) return false;
      const p = this.procedimentoRespondendo;
      if (p.tipo === "sim_nao") {
        return p.resposta === "sim" || p.resposta === "nao";
      }
      return p.resposta && String(p.resposta).trim() !== "";
    },
  },
  methods: {
    async abrirAtendimentoDaRota() {
      const idAtendimento = this.$route.params.idAtendimento;
      if (!idAtendimento) return;

      const servico = this.servicosfunerarios.find(
        (item) => String(item.idAtendimento) === String(idAtendimento),
      );

      if (servico) {
        await this.abrirDialog(servico);
        return;
      }

      await this.$router.replace("/fluxo-servico-funerario");
      this.showAlert(
        "Atendimento não encontrado",
        `O atendimento #${idAtendimento} não foi encontrado na lista atual.`,
      );
    },
    formatarDataHoraSync(valor) {
      if (!valor) return "-";
      const data = new Date(valor);
      if (Number.isNaN(data.getTime())) {
        return String(valor).replace("T", " ");
      }
      return data.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    montarParametrosSyncFunerario() {
      if (this.tipoDataFiltro === "abertos") {
        return {};
      }
      return {
        dataInicio: converteDataParaFormatoISO(this.selectedStartDate),
        dataFim: converteDataParaFormatoISO(this.selectedEndDate),
      };
    },

    async carregarStatusSyncFunerario() {
      try {
        const response = await http.get("/servico-funerario/sync/status", {
          headers: authHeader(),
        });
        this.syncStatus = response.data || null;
      } catch (error) {
        console.error("Erro ao carregar status da sync funeraria:", error);
      }
    },

    async forcarSyncFunerario() {
      if (this.syncLoading) return;
      this.syncLoading = true;
      try {
        const response = await http.post("/servico-funerario/sync/forcar", null, {
          params: this.montarParametrosSyncFunerario(),
          headers: authHeader(),
        });
        this.syncStatus = response.data || this.syncStatus;
        setTimeout(() => {
          this.carregarStatusSyncFunerario();
          this.init(true);
        }, 1500);
      } catch (error) {
        console.error("Erro ao forcar sync funeraria:", error);
        if (error.response && error.response.status === 429) {
          this.showAlert(
            "Aviso",
            "Aguarde um minuto antes de tentar novamente.",
          );
          return;
        }
        this.showAlert(
          "Erro",
          this.getMensagemErroApi(error, "Não foi possível iniciar a sincronização."),
        );
      } finally {
        this.syncLoading = false;
      }
    },

    normalizarPendenciaFiltro(pendencia) {
      return String(pendencia || "").trim();
    },

    normalizarTags(tags) {
      return Array.isArray(tags) ? tags.filter((tag) => tag && tag.id) : [];
    },

    passaFiltrosRapidos(item) {
      if (
        this.somenteComPendencia &&
        this.deveExibirTabela &&
        !this.normalizarPendenciaFiltro(item.pendencia)
      ) {
        return false;
      }
      if (!this.tagsFiltroSelecionadas.length) return true;
      return this.normalizarTags(item.tags).some((tag) =>
        this.tagsFiltroSelecionadas.includes(tag.id),
      );
    },

    async carregarTagsDisponiveis() {
      try {
        const response = await funerariaService.listar_tags();
        this.tagsDisponiveis = response.data?.data || response.data || [];
      } catch (error) {
        console.error("Erro ao carregar tags do fluxo funerÃ¡rio:", error);
        this.tagsDisponiveis = [];
      }
    },

    async sincronizarTagsServicoEditando(novasTags) {
      if (!this.servicoEditando?.id || this.salvandoTagsServico) return;

      const selecionadas = Array.isArray(novasTags) ? novasTags : [];
      const anteriores = Array.isArray(this.tagsServicoEditandoOriginal)
        ? this.tagsServicoEditandoOriginal
        : [];
      const adicionadas = selecionadas.filter((id) => !anteriores.includes(id));
      const removidas = anteriores.filter((id) => !selecionadas.includes(id));

      if (!adicionadas.length && !removidas.length) return;

      this.salvandoTagsServico = true;
      try {
        let response = null;
        for (const tagId of adicionadas) {
          response = await funerariaService.adicionar_tag(
            this.servicoEditando.id,
            tagId,
          );
        }
        for (const tagId of removidas) {
          response = await funerariaService.remover_tag(
            this.servicoEditando.id,
            tagId,
          );
        }

        const atualizado = response?.data || {
          ...this.servicoEditando,
          tags: this.tagsDisponiveis.filter((tag) =>
            selecionadas.includes(tag.id),
          ),
        };
        this.servicoEditando.tags = this.normalizarTags(atualizado.tags);
        this.tagsServicoEditando = this.servicoEditando.tags.map((tag) => tag.id);
        this.tagsServicoEditandoOriginal = [...this.tagsServicoEditando];
        this.atualizarServicoNaListagem(atualizado);
      } catch (error) {
        console.error("Erro ao atualizar tags do atendimento:", error);
        this.tagsServicoEditando = [...this.tagsServicoEditandoOriginal];
        this.showAlert(
          "Erro",
          this.getMensagemErroApi(error, "Nao foi possivel atualizar as tags."),
        );
      } finally {
        this.salvandoTagsServico = false;
      }
    },

    carregarTagsSelecionadasServicoEditando() {
      this.tagsServicoEditando = this.normalizarTags(
        this.servicoEditando?.tags,
      ).map((tag) => tag.id);
      this.tagsServicoEditandoOriginal = [...this.tagsServicoEditando];
    },

    removerTagServicoEditando(tagId) {
      this.tagsServicoEditando = this.tagsServicoEditando.filter(
        (id) => id !== tagId,
      );
      this.sincronizarTagsServicoEditando(this.tagsServicoEditando);
    },

    normalizarLinkExterno(link) {
      if (!link || typeof link !== "string") return "";
      const valor = link.trim();
      if (!valor) return "";
      return /^https?:\/\//i.test(valor) ? valor : `https://${valor}`;
    },

    normalizarTextoItem(texto) {
      return String(texto || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase();
    },

    getGrupoOrdenacaoItem(item) {
      if (item.isUrna) return 0;
      if (item.tipo === 1) return 1;
      if (item.tipo === 2) return 2;
      return 3;
    },

    getDestaqueServicoItem(item) {
      if (!item || item.isUrna || item.tipo !== 2) return null;

      const nomeItem = this.normalizarTextoItem(item.nomeItem);
      const destaques = [
        {
          termo: "COROA DE FLORES",
          label: "FLORES",
          color: "pink darken-3",
          prioridade: 1,
        },
        {
          termo: "CHUVA DE PETALAS",
          label: "CHUVA DE PETALAS",
          color: "deep-purple darken-2",
          prioridade: 2,
        },
        {
          termo: "SOMATOCONSERVACAO",
          label: "SOMATO",
          color: "indigo darken-2",
          prioridade: 3,
        },
      ];

      return destaques.find((destaque) => nomeItem.includes(destaque.termo));
    },

    montarParametrosExportacaoFunerario() {
      return {
        dataInicio: converteDataParaFormatoISO(this.selectedStartDate),
        dataFim: converteDataParaFormatoISO(this.selectedEndDate),
        tipoData: this.tipoDataFiltro,
        search: this.buscaFunerarios || "",
        etapaId: this.filtroEtapaSelecionado || 0,
      };
    },

    montarParametrosResumoCards() {
      const params = {
        tipoData: this.tipoDataFiltro,
        excluidos: this.listarExcluidos,
      };

      if (this.tipoDataFiltro !== "abertos") {
        params.dataInicio = converteDataParaFormatoISO(this.selectedStartDate);
        params.dataFim = converteDataParaFormatoISO(this.selectedEndDate);
      }

      if (this.filtroEtapaSelecionado) {
        params.etapaId = this.filtroEtapaSelecionado;
      }

      const tiposAtivos = this.getTiposEtapaFiltroAtivos();
      if (tiposAtivos.length) {
        params.tiposEtapa = tiposAtivos;
      }

      if (this.pendenciasFiltroSelecionadas.length) {
        params.pendencias = this.pendenciasFiltroSelecionadas;
      }

      if (this.buscaFunerarios && this.buscaFunerarios.trim()) {
        params.busca = this.buscaFunerarios.trim();
      }

      return params;
    },

    aplicarValoresResumoCards(cardsApi) {
      const valoresPorChave = new Map(
        cardsApi.map((card) => [card.chave, card]),
      );

      return this.resumoCards.map((card) => {
        const cardApi = valoresPorChave.get(card.chave);
        return cardApi
          ? { ...card, valor: cardApi.valor, subValor: cardApi.subValor }
          : card;
      });
    },

    async carregarResumoCards(silencioso = false) {
      if (!silencioso) {
        this.isLoadingResumoCards = true;
      }
      try {
        const response = await funerariaService.resumo_cards_fluxo_funerario(
          this.montarParametrosResumoCards(),
        );
        const cards = response.data?.cards || [];
        this.resumoCards = this.aplicarValoresResumoCards(cards);
      } catch (error) {
        console.error("Erro ao carregar resumo do fluxo funerario:", error);
      } finally {
        if (!silencioso) {
          this.isLoadingResumoCards = false;
        }
      }
    },

    agendarCarregamentoResumoCards() {
      if (this.resumoCardsTimer) {
        clearTimeout(this.resumoCardsTimer);
      }
      this.resumoCardsTimer = setTimeout(() => {
        this.carregarResumoCards(true);
      }, 300);
    },

    formatarNumeroCard(valor) {
      return Number(valor || 0).toLocaleString("pt-BR");
    },

    tituloResumoCard(card) {
      if (!card.sufixoPeriodo) return card.titulo;
      return `${card.titulo} ${
        this.tipoDataFiltro === "abertos" ? "mês" : "período"
      }`;
    },

    montarSubTextoCard(card) {
      return `${card.subtitulo}: ${this.formatarNumeroCard(card.subValor)}`;
    },

    async exportarFunerarioXlsx() {
      if (this.exportandoFunerario || !this.servicosFunerariosTabela.length) {
        return;
      }

      this.exportandoFunerario = true;
      try {
        const response = await funerariaService.exportar_fluxo_funerario_xls(
          this.montarParametrosExportacaoFunerario(),
        );
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `fluxo_funerario_${Date.now()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Erro ao exportar fluxo funerario:", error);
        this.showAlert("Erro", "Erro ao exportar a lista do fluxo funerário.");
      } finally {
        this.exportandoFunerario = false;
      }
    },

    navegarEtapa(direcao) {
      if (!this.colunasFiltros || this.colunasFiltros.length === 0) return;

      const indiceAtual = this.filtroEtapaSelecionado;
      let novoIndice = indiceAtual;

      if (direcao === "anterior" && indiceAtual > 0) {
        novoIndice = indiceAtual - 1;
      } else if (
        direcao === "proxima" &&
        indiceAtual < this.colunasFiltros.length - 1
      ) {
        novoIndice = indiceAtual + 1;
      }

      if (novoIndice !== indiceAtual) {
        this.filtroEtapaSelecionado = novoIndice;
      }
    },
    getVtr(element, coluna) {
      return (
        element.etapas.find((e) => e.etapaId === coluna.id)?.vtr ||
        "Não informado"
      );
    },

    deveExibirOrigemDestino(etapa) {
      return [1, 2, 3].includes(etapa?.id);
    },

    getSomatoInfo(element, coluna) {
      // Verificar se é a etapa de Preparação
      if (coluna.nome !== "Preparação")
        return { nome: "", inicio: "", fim: null, colaborador: "" };
      if (!element.usoSomatoConservacao)
        return { nome: "", inicio: "", fim: null, colaborador: "" };

      // Encontrar a etapa de Somato nos dados do serviço
      const etapa = element.etapas?.find((e) => e.etapaId === 9);
      if (!etapa) return { nome: "", inicio: "", fim: null, colaborador: "" };

      // Verificar se existem colaboradores
      if (!etapa.colaboradores || etapa.colaboradores.length === 0) {
        return {
          nome: "Somatoconservação",
          inicio: element.dataInicioSomato,
          fim: null,
          colaborador: "Não informado",
        };
      }

      // Obter o nome do primeiro colaborador
      let nomeColaborador = "Não informado";
      const colaboradorId = etapa.colaboradores[0];
      if (colaboradorId) {
        const colaboradorObj = this.listaColaboradores.find(
          (c) => c.id === colaboradorId,
        );
        if (colaboradorObj) {
          nomeColaborador = colaboradorObj.nome;
        }
      }

      // Criar objeto simplificado com os dados da somatoconservação
      const result = {
        nome: "Somatoconservação",
        inicio: element.dataInicioSomato,
        fim: etapa.dataFimSomato ? element.dataFimSomato : null,
        colaborador: nomeColaborador,
      };

      return result;
    },

    getAcolhimentoInfo(element, coluna) {
      // Verificar se é a etapa de Acolhimento
      if (coluna.nome !== "Acolhimento de óbito") return { atividades: [] };

      // Encontrar a etapa de acolhimento nos dados do serviço
      const etapa = element.etapas?.find((e) => e.etapaId === coluna.id);
      if (!etapa) return { atividades: [] };

      // Informações básicas
      const result = {
        atividades: [],
        vtr: etapa.vtr || "Não informado",
      };

      // Se não tiver atividades, retorna objeto vazio
      if (!etapa.atividades || etapa.atividades.length === 0) {
        return result;
      }

      if (etapa.atividades.length === 0) return result;

      // Processar cada atividade
      etapa.atividades.forEach((atividade) => {
        if (!atividade.atividadeFunerariaDescricao) return;

        // Obter informações do colaborador
        let nomeColaborador = "Não informado";
        if (atividade.colaboradores && atividade.colaboradores.length > 0) {
          const colaboradorId = atividade.colaboradores[0].colaboradorId;
          if (colaboradorId) {
            const colaboradorObj = this.listaColaboradores.find(
              (c) => c.id === colaboradorId,
            );
            if (colaboradorObj) {
              nomeColaborador = colaboradorObj.nome;
            }
          }
        }

        // Adicionar atividade processada ao resultado
        result.atividades.push({
          nome: atividade.atividadeFunerariaDescricao,
          agente: nomeColaborador,
          inicio: this.formatarDataHora(atividade.dtInicio),
        });
      });

      return result;
    },

    getTransporteFamiliarInfo(element, coluna) {
      // Verificar se é a etapa de Transporte familiar
      if (coluna.nome !== "Transporte familiar") return { atividades: [] };

      // Encontrar a etapa de velório nos dados do serviço
      const etapa = element.etapas?.find((e) => e.etapaId === coluna.id);
      if (!etapa) return { atividades: [] };

      // Informações básicas
      const result = {
        atividades: [],
        vtr: etapa.vtr || "Não informado",
      };

      // Se não tiver atividades, retorna objeto vazio
      if (!etapa.atividades || etapa.atividades.length === 0) {
        return result;
      }

      // Processar cada atividade
      etapa.atividades.forEach((atividade) => {
        if (!atividade.atividadeFunerariaDescricao) return;

        // Obter informações do colaborador
        let nomeColaborador = "Não informado";
        if (atividade.colaboradores && atividade.colaboradores.length > 0) {
          const colaboradorId = atividade.colaboradores[0].colaboradorId;
          if (colaboradorId) {
            const colaboradorObj = this.listaColaboradores.find(
              (c) => c.id === colaboradorId,
            );
            if (colaboradorObj) {
              nomeColaborador = colaboradorObj.nome;
            }
          }
        }

        // Adicionar atividade processada ao resultado
        result.atividades.push({
          nome: atividade.atividadeFunerariaDescricao,
          agente: nomeColaborador,
          inicio: this.formatarDataHora(atividade.dtInicio),
        });
      });

      return result;
    },

    getVelorioInfo(element, coluna) {
      // Verificar se é a etapa de Velório
      if (coluna.nome !== "Velório") return { atividades: [] };

      // Encontrar a etapa de velório nos dados do serviço
      const etapa = element.etapas?.find((e) => e.etapaId === coluna.id);
      if (!etapa) return { atividades: [] };

      // Informações básicas
      const result = {
        atividades: [],
        vtr: etapa.vtr || "Não informado",
      };

      // Se não tiver atividades, retorna objeto vazio
      if (!etapa.atividades || etapa.atividades.length === 0) {
        return result;
      }

      // Processar cada atividade
      etapa.atividades.forEach((atividade) => {
        if (!atividade.atividadeFunerariaDescricao) return;

        // Obter informações do colaborador
        let nomeColaborador = "Não informado";
        if (atividade.colaboradores && atividade.colaboradores.length > 0) {
          const colaboradorId = atividade.colaboradores[0].colaboradorId;
          if (colaboradorId) {
            const colaboradorObj = this.listaColaboradores.find(
              (c) => c.id === colaboradorId,
            );
            if (colaboradorObj) {
              nomeColaborador = colaboradorObj.nome;
            }
          }
        }

        // Adicionar atividade processada ao resultado
        result.atividades.push({
          nome: atividade.atividadeFunerariaDescricao,
          agente: nomeColaborador,
          inicio: this.formatarDataHora(atividade.dtInicio),
        });
      });

      return result;
    },
    // Auto-scroll methods
    iniciarArrastar(event) {
      // Start monitoring mouse position for auto-scrolling
      document.addEventListener("mousemove", this.checkAutoScroll);
    },

    finalizarArrastar() {
      // Stop auto-scrolling when drag ends
      document.removeEventListener("mousemove", this.checkAutoScroll);
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
        this.autoScrollInterval = null;
      }
    },

    checkAutoScroll(event) {
      const kanbanBoard = document.querySelector(".kanban-board");
      if (!kanbanBoard) return;

      const rect = kanbanBoard.getBoundingClientRect();
      const mouseX = event.clientX;

      // Clear any existing interval
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
        this.autoScrollInterval = null;
      }

      // Check if mouse is near the left edge
      if (mouseX < rect.left + this.scrollThreshold) {
        this.autoScrollInterval = setInterval(() => {
          kanbanBoard.scrollLeft -= this.scrollSpeed;
        }, 16); // ~60fps
      }
      // Check if mouse is near the right edge
      else if (mouseX > rect.right - this.scrollThreshold) {
        this.autoScrollInterval = setInterval(() => {
          kanbanBoard.scrollLeft += this.scrollSpeed;
        }, 16); // ~60fps
      }
    },
    alterarExpansionPanel(colunaId) {
      this.consultarAtividadesDisponiveis(colunaId);
      this.novaAtividade = {
        atividadeFunerariaId: null,
        atividadeFunerariaDescricao: "",
        dtInicio: null,
        dtFim: null,
        tempoOcorrencia: null,
        colaboradores: [],
      };
    },

    // Método para carregar atividades disponíveis para uma etapa
    toggleAtividadesDisponiveis(etapaId) {
      if (!etapaId) return;

      // Carregar atividades disponíveis para esta etapa
      this.consultarAtividadesDisponiveis(etapaId);

      // Inicializar o objeto de nova atividade para esta etapa se necessário
      this.initNovaAtividadeEtapa(etapaId);
    },
    // Método para exibir o dialog de alerta
    showAlert(title, message) {
      this.alertDialog.title = title;
      this.alertDialog.message = message;
      this.alertDialog.show = true;
    },

    formatarCodigoAtendimento(servico) {
      const idAtendimento = servico?.idAtendimento || servico?.id;
      if (!idAtendimento) return "-";
      return `#${idAtendimento}${servico?.criadoManual ? "M" : ""}`;
    },

    formatarDataHoraExclusao(valor) {
      if (!valor) return "Não informado";
      if (String(valor).includes("/")) {
        return String(valor).slice(0, 16);
      }
      return this.formatarDataHora(valor);
    },

    getMensagemErroApi(error, mensagemPadrao) {
      const data = error?.response?.data;
      if (data?.mensagem) return data.mensagem;
      if (data?.message) return data.message;
      if (typeof data === "string" && data.trim()) return data;

      const headerMensagem =
        error?.response?.headers?.["x-error-message"] ||
        error?.response?.headers?.["X-Error-Message"];
      if (headerMensagem) return headerMensagem;

      return mensagemPadrao;
    },

    abrirDialogExcluirAtendimento() {
      if (!this.podeExcluirAtendimento || this.servicoEditando?.isExcluido) {
        return;
      }
      this.confirmarExclusaoAtendimento = false;
      this.dialogExcluirAtendimento = true;
    },

    fecharDialogExcluirAtendimento() {
      if (this.excluindoAtendimento) return;
      this.dialogExcluirAtendimento = false;
      this.confirmarExclusaoAtendimento = false;
    },

    async excluirAtendimentoConfirmado() {
      if (
        !this.podeExcluirAtendimento ||
        !this.confirmarExclusaoAtendimento ||
        !this.servicoEditando?.id
      ) {
        return;
      }

      this.excluindoAtendimento = true;
      try {
        await funerariaService.excluir_atendimento(this.servicoEditando.id);
        this.dialogExcluirAtendimento = false;
        this.dialogEdicao = false;
        this.confirmarExclusaoAtendimento = false;
        this.showAlert("Atendimento excluído", "O atendimento foi excluído com sucesso.");
        await this.init(true);
      } catch (error) {
        console.error(error);
        this.showAlert(
          "Erro ao excluir atendimento",
          "Não foi possível excluir o atendimento.",
        );
      } finally {
        this.excluindoAtendimento = false;
      }
    },

    async carregarUserLogado() {
      const userLogado = await http.get("/usuario/logado", {
        headers: authHeader(),
      });

      this.userLogado = userLogado.data;

      const userString = sessionStorage.getItem("user");
      this.hasPermissionDelete = false;

      // Base de apresentação: a edição permanece disponível para qualquer usuário autenticado.
      this.hasPermissionEdit = true;
      this.hasPermissionCreate = false;

      if (userString) {
        const user = JSON.parse(userString);
        const roles = user.roles || [];

        this.hasPermissionDelete =
          roles.includes("ROLE_SERVICO_FUNERARIO_EXCLUSAO") ||
          roles.includes("ROLE_ADMIN");
        this.hasPermissionCreate =
          roles.includes("ROLE_SERVICO_FUNERARIO_CRIAR") ||
          roles.includes("ROLE_ADMIN");
      }
    },
    async sincronizarItens(ticketId) {
      await http
        .post(`/servico-funerario/${ticketId}/itens`, null, {
          headers: authHeader(),
        })
        .then((response) => {
          this.servicoEditando = response.data;
        });
      this.consultarHistorico(ticketId);
    },
    parseBRDate(str) {
      if (!str || str === "") return null;
      // "17/08/2025 13:46:47"
      const [data, hora] = str.split(" ");
      const [dia, mes, ano] = data.split("/").map(Number);
      const [h, m, s] = hora.split(":").map(Number);
      return new Date(ano, mes - 1, dia, h, m, s);
    },

    markViewed(card) {
      const viewed = this.getViewedCards();

      const createdAt = this.parseBRDate(card.dataAtendimento);
      const now = Date.now();
      const diffHoras = (now - createdAt.getTime()) / (1000 * 60 * 60);

      // só marca se card tiver sido criado nas últimas 24h
      if (diffHoras <= 24) {
        if (!viewed.find((v) => v.cardId === card.id)) {
          viewed.push({
            cardId: card.id,
            createdAt: card.dataAtendimento, // ainda string BR
            viewedAt: now,
          });
          localStorage.setItem("viewedCards", JSON.stringify(viewed));
        }
      }

      this.$forceUpdate();
    },

    getViewedCards() {
      const viewed = JSON.parse(localStorage.getItem("viewedCards") || "[]");
      const now = Date.now();

      // mantém apenas os cards criados nas últimas 24h
      const filtered = viewed.filter((v) => {
        const createdAt = this.parseBRDate(v.createdAt).getTime();
        const diffHoras = (now - createdAt) / (1000 * 60 * 60);
        return diffHoras < 24;
      });

      if (filtered.length !== viewed.length) {
        localStorage.setItem("viewedCards", JSON.stringify(filtered));
      }

      return filtered;
    },

    isNew(card) {
      const agora = new Date();
      const dataAtendimento = this.parseBRDate(card.dataAtendimento);
      const diffHoras =
        (agora.getTime() - dataAtendimento.getTime()) / (1000 * 60 * 60);

      // não é novo se já foi visto
      const viewed = this.getViewedCards();
      const jaVisto = viewed.some((v) => v.cardId === card.id);

      // retorna true se estiver nas últimas 24h e ainda não tiver sido visto
      return diffHoras <= 24 && diffHoras >= 0 && !jaVisto;
    },

    async filtrarTickets() {
      if (this.meusTickets) {
        this.servicosfunerarios = this.servicosfunerarios.filter(
          (servico) =>
            servico.etapas.find(
              (etapa) =>
                etapa.colaboradores.find(
                  (colaborador) => colaborador == this.userLogado,
                ) && etapa.etapaId == servico.etapa.id,
            ) ||
            servico.etapas.find(
              (etapa) =>
                etapa.supervisores.find(
                  (supervisor) => supervisor == this.userLogado,
                ) && etapa.etapaId == servico.etapa.id,
            ) ||
            servico.donoAtendimento == this.userLogado,
        );
      } else {
        this.servicosfunerarios = this.servicosfunerarios;
      }
    },
    async concluirTicket(status, item) {
      try {
        if (status === "com-pedencia") {
          item.etapa.id = 7;
        } else {
          item.etapa.id = 8;
        }

        // Enviar para o servidor
        await http.put(`/servico-funerario/${item.id}`, item, {
          headers: authHeader(),
        });
        this.init();
        this.dialogConcluir = false;
        this.fecharDialogEtapa();
      } catch (error) {
        console.error("Erro ao concluir ticket:", error);
        this.showAlert(
          "Erro",
          this.getMensagemErroApi(
            error,
            "Nao foi possivel concluir o atendimento.",
          ),
        );
        throw error;
      }
    },

    // Abre o dialog de pendência para finalizar com pendência
    abrirDialogPendencia(item) {
      this.statusConclusaoPendente = "com-pedencia";
      this.servicoConclusaoPendente = item;
      this.pendencia = item.pendencia || null;
      this.dialogConcluir = false;
      this.dialogPendencia = true;
    },

    // Finaliza o atendimento com pendência
    async finalizarComPendencia() {
      if (!this.pendencia || !this.servicoConclusaoPendente) return;

      this.salvandoPendencia = true;
      try {
        this.servicoConclusaoPendente.pendencia = this.pendencia;
        this.dialogPendencia = false;
        await this.concluirTicket(
          "com-pedencia",
          this.servicoConclusaoPendente,
        );
      } catch (error) {
        console.error("Erro ao finalizar com pendência:", error);
      } finally {
        this.salvandoPendencia = false;
      }
    },

    // Carrega a lista de procedimentos e respostas salvas para a aba de edição
    async carregarProcedimentosEdicao(
      ticketId,
      { preservarPagina = false } = {},
    ) {
      this.carregandoProcedimentosEdicao = true;
      const paginaAtual = this.paginaProcedimentos;
      if (!preservarPagina) {
        this.paginaProcedimentos = 1;
      }
      try {
        const [procedimentosResponse, respostasResponse] = await Promise.all([
          funerariaService.listar_procedimentos(),
          funerariaService.consultar_procedimentos_ticket(ticketId),
        ]);

        const respostas =
          respostasResponse.status === 200 ? respostasResponse.data || [] : [];

        this.procedimentosEdicao = (procedimentosResponse.data || []).map(
          (p) => {
            const respostaSalva = respostas.find(
              (r) => r.procedimentoId === p.id,
            );
            return {
              id: respostaSalva ? respostaSalva.id : null,
              procedimentoId: p.id,
              descricao: p.descricao,
              tipo: p.tipo,
              resposta: respostaSalva ? respostaSalva.resposta : null,
              observacoes: respostaSalva ? respostaSalva.observacoes : null,
              valorPadrao: p.valorPadrao,
            };
          },
        );
        if (preservarPagina) {
          const totalPaginas = Math.max(
            1,
            Math.ceil(this.procedimentosEdicaoFiltrados.length / 10),
          );
          this.paginaProcedimentos = Math.min(paginaAtual, totalPaginas);
        }
      } catch (error) {
        console.error("Erro ao carregar procedimentos na edição:", error);
        this.showAlert("Erro", "Ocorreu um erro ao carregar os procedimentos.");
      } finally {
        this.carregandoProcedimentosEdicao = false;
      }
    },

    // Abre o dialog para responder ou editar um procedimento
    abrirDialogProcedimento(procedimento, modo) {
      this.modoRespostaProcedimento = modo;
      this.procedimentoRespondendo = {
        ...JSON.parse(JSON.stringify(procedimento)),
        respondido: !!procedimento.resposta,
      };
      if (modo !== "editar" && !this.procedimentoRespondendo.resposta) {
        this.procedimentoRespondendo.resposta =
          this.procedimentoRespondendo.valorPadrao;
      }
      this.dialogProcedimentoResposta = true;
    },

    ehRespostaPadraoProcedimento(procedimento, valor) {
      return String(procedimento.valorPadrao || "").toLowerCase() === valor;
    },

    async persistirRespostaProcedimento(procedimento, resposta, observacoes) {
      const ticketId = this.servicoEditando.id;
      const dto = {
        procedimentoId: procedimento.procedimentoId,
        resposta,
        observacoes: observacoes || null,
      };
      if (procedimento.id) {
        await funerariaService.atualizar_procedimento_ticket(
          ticketId,
          procedimento.id,
          dto,
        );
      } else {
        await funerariaService.salvar_procedimentos_ticket(ticketId, [dto]);
      }
    },

    // Responde um procedimento sim/não direto pelos botões da lista
    async responderProcedimentoRapido(procedimento, resposta) {
      if (this.salvandoRespostaRapida) return;
      this.salvandoRespostaRapida = `${procedimento.procedimentoId}:${resposta}`;
      try {
        await this.persistirRespostaProcedimento(
          procedimento,
          resposta,
          procedimento.observacoes,
        );
        await this.carregarProcedimentosEdicao(this.servicoEditando.id, {
          preservarPagina: true,
        });
      } catch (error) {
        console.error("Erro ao salvar resposta do procedimento:", error);
        this.showAlert(
          "Erro",
          "Ocorreu um erro ao salvar a resposta do procedimento.",
        );
      } finally {
        this.salvandoRespostaRapida = null;
      }
    },

    // Salva a resposta de um procedimento (cria ou atualiza)
    async salvarProcedimentoResposta() {
      if (!this.procedimentoRespondendo || !this.procedimentoRespostaValida) {
        return;
      }

      const ticketId = this.servicoEditando.id;

      this.salvandoProcedimentoResposta = true;
      try {
        await this.persistirRespostaProcedimento(
          this.procedimentoRespondendo,
          this.procedimentoRespondendo.resposta,
          this.procedimentoRespondendo.observacoes,
        );
        this.showAlert(
          "Sucesso",
          this.modoRespostaProcedimento === "observacao"
            ? "Observação salva com sucesso."
            : `Resposta ${
                this.procedimentoRespondendo.id ? "atualizada" : "salva"
              } com sucesso.`,
        );
        this.dialogProcedimentoResposta = false;
        this.procedimentoRespondendo = null;
        this.modoRespostaProcedimento = null;
        await this.carregarProcedimentosEdicao(ticketId, {
          preservarPagina: true,
        });
      } catch (error) {
        console.error("Erro ao salvar resposta do procedimento:", error);
        this.showAlert(
          "Erro",
          "Ocorreu um erro ao salvar a resposta do procedimento.",
        );
      } finally {
        this.salvandoProcedimentoResposta = false;
      }
    },

    // Abre confirmação para limpar a resposta de um procedimento
    confirmarResetProcedimento(procedimento) {
      this.procedimentoExcluindo = procedimento;
      this.confirmDialog = {
        show: true,
        title: "Limpar resposta",
        message: `Deseja realmente limpar a resposta do procedimento "${procedimento.descricao}"?`,
        loading: false,
        onConfirm: this.executarResetProcedimento,
      };
    },

    // Executa a limpeza da resposta do procedimento
    async executarResetProcedimento() {
      const procedimento = this.procedimentoExcluindo;
      if (!procedimento || !procedimento.id) {
        this.confirmDialog.show = false;
        return;
      }

      this.confirmDialog.loading = true;
      this.excluindoProcedimentoEdicao = procedimento.id;
      const ticketId = this.servicoEditando.id;

      try {
        await funerariaService.excluir_procedimento_ticket(
          ticketId,
          procedimento.id,
        );
        this.confirmDialog.show = false;
        this.showAlert("Sucesso", "Resposta limpa com sucesso.");
        await this.carregarProcedimentosEdicao(ticketId, {
          preservarPagina: true,
        });
      } catch (error) {
        console.error("Erro ao limpar resposta do procedimento:", error);
        this.showAlert(
          "Erro",
          "Ocorreu um erro ao limpar a resposta do procedimento.",
        );
      } finally {
        this.excluindoProcedimentoEdicao = null;
        this.confirmDialog.loading = false;
        this.procedimentoExcluindo = null;
      }
    },

    adicionarColaboradorInput() {
      if (
        this.etapaDadosTemp.colaboradores.find(
          (colaborador) => colaborador == this.userLogado,
        )
      ) {
        return;
      }
      this.etapaDadosTemp.colaboradores.push(this.userLogado);
    },
    validacoesProsseguirEtapa() {
      if (
        this.etapaDadosTemp.dataHoraInicio &&
        !this.etapaDadosTemp.dataHoraFim
      ) {
        // Iniciando somente
        if (
          !this.etapaAtual?.nome === "Preparação" &&
          (this.etapaDadosTemp?.colaboradores?.length == 0 ||
            this.etapaDadosTemp.colaboradores == undefined)
        ) {
          return {
            message:
              "É necessário atribuir pelo menos um colaborador para esta etapa antes de prosseguir.",
            valid: false,
          };
        }

        // Uma condição separada para preparação, pois podem estar querendo iniciar somente a somatoconservação.
        // Primeiro valida se foi preenchido o campo de colaboradores da etapa preparação
        if (
          this.etapaAtual?.nome === "Preparação" &&
          (this.etapaDadosTemp?.colaboradores?.length == 0 ||
            this.etapaDadosTemp.colaboradores == undefined) &&
          (this.colaboradoresTempSomato.length == 0 ||
            this.colaboradoresTempSomato == undefined)
        ) {
          return {
            message:
              "É necessário atribuir pelo menos um colaborador para esta etapa antes de prosseguir.",
            valid: false,
          };
        }
        // Se estiver iniciando somente a somatoconservação, limpa a data de inicio para não iniciar a etapa preparação
        if (
          this.etapaAtual?.nome === "Preparação" &&
          (this.etapaDadosTemp?.colaboradores?.length == 0 ||
            this.etapaDadosTemp.colaboradores == undefined) &&
          this.colaboradoresTempSomato.length > 0
        ) {
          this.etapaDadosTemp.dataHoraInicio = null;
        }
      }

      if (
        this.etapaDadosTemp.dataHoraInicio &&
        this.etapaDadosTemp.dataHoraFim
      ) {
        // Finalizando e iniciando
        if (
          this.etapaDadosTemp?.colaboradores?.length == 0 ||
          this.etapaDadosTemp?.colaboradores == undefined
        ) {
          return {
            message:
              "É necessário atribuir pelo menos um colaborador para esta etapa antes de prosseguir.",
            valid: false,
          };
        }
        if (
          this.etapaDadosTemp.dataHoraInicio > this.etapaDadosTemp.dataHoraFim
        ) {
          return {
            message:
              "A data de início não pode ser posterior à data de fim. Por favor, corrija as datas informadas.",
            valid: false,
          };
        }

        if (this.etapaAtual?.nome === "Acolhimento de óbito") {
          if (
            this.servicoAtual.solicitacaoTransporteFamiliar === null ||
            this.servicoAtual.solicitacaoTransporteFamiliar === undefined
          ) {
            return {
              message:
                "Pendente informação de solicitação de transporte familiar",
              valid: false,
            };
          }
        }

        if (this.etapaAtual?.nome === "Preparação") {
          if (this.servicoAtual.autorizacaoRetirada === null) {
            return {
              message: "Selecione uma opção para 'Autorização de Retirada'.",
              valid: false,
            };
          }
          if (
            this.servicoAtual.usoSomatoConservacao === undefined ||
            this.servicoAtual.usoSomatoConservacao === null
          ) {
            return {
              message: "Informe se houve 'Uso de Somatoconservação'.",
              valid: false,
            };
          }
          if (this.servicoAtual.usoSomatoConservacao) {
            if (
              this.servicoAtual.dataInicioSomato >
              this.servicoAtual.dataFimSomato
            ) {
              return {
                message:
                  "A data de início da Somatoconservação não pode ser posterior à data de fim. Por favor, corrija as datas informadas.",
                valid: false,
              };
            }
          }
        }
        if (this.etapaAtual?.nome === "Transporte familiar") {
          if (this.servicoAtual.solicitacaoTransporteFamiliar === null) {
            return {
              message:
                "Pendente informação de solicitação de transporte familiar",
              valid: false,
            };
          }

          if (this.servicoAtual.solicitacaoTransporteFamiliar === "A DEFINIR") {
            return {
              message:
                "Pendente selecionar uma opção válida para 'Solicitação de Transporte Familiar'.",
              valid: false,
            };
          }

          if (
            (this.servicoAtual.solicitacaoTransporteFamiliar || "").includes(
              "SOLICITADO",
            )
          ) {
            if (
              this.servicoAtual.tipoTransporteFamiliar === undefined ||
              this.servicoAtual.tipoTransporteFamiliar === null
            ) {
              return {
                message: "Pendente informação de tipo de transporte familiar",
                valid: false,
              };
            }

            if (
              this.servicoAtual.origemTransporteFamiliar === undefined ||
              this.servicoAtual.origemTransporteFamiliar === null
            ) {
              return {
                message: "Pendente informação de origem",
                valid: false,
              };
            }
            if (
              this.servicoAtual.destinoTransporteFamiliar === undefined ||
              this.servicoAtual.destinoTransporteFamiliar === null
            ) {
              return {
                message: "Pendente informação de destino",
                valid: false,
              };
            }
          }
        }
      }

      return { message: "", valid: true };
    },
    // Métodos de paginação
    carregarMaisItensColuna(colunaId) {
      this.paginacaoKanban.itensVisiveisPorColuna +=
        this.paginacaoKanban.incremento;
    },

    carregarMaisItensLista() {
      this.paginacaoLista.itensVisiveis += this.paginacaoLista.incremento;
    },

    // Computed para filtrar itens visíveis por coluna
    getItensVisiveisPorColuna(colunaId) {
      let itens = [];

      if (colunaId === 6) {
        // Para a coluna 6, buscar todos os itens que tenham solicitacaoTransporteFamiliar como "SOLICITADO" ou "A DEFINIR"
        // e verificar se a etapa de transporte familiar (ID 6) não está concluída
        const itensFiltrados = this.servicosfunerarios.filter((item) => {
          const etapaTransporte = item.etapas.find((e) => e.etapaId === 6);
          const transporteNaoConcluido =
            !etapaTransporte || !etapaTransporte.dtFim;

          return (
            (item.solicitacaoTransporteFamiliar &&
              (item.solicitacaoTransporteFamiliar.includes("SOLICITADO") ||
                item.solicitacaoTransporteFamiliar.includes("A DEFINIR")) &&
              transporteNaoConcluido &&
              item.etapa.id !== 6 &&
              item.etapa.tipo === "Em andamento") ||
            (item.solicitacaoTransporteFamiliar &&
              !item.solicitacaoTransporteFamiliar.includes("SOLICITADO") &&
              item.etapa.id == 6)
          );
        });

        // Combinar com itens da coluna, removendo duplicatas baseado no idAtendimento
        const todosItens = [
          ...itensFiltrados,
          ...(this.tarefasPorColuna[colunaId] || []),
        ];
        const idsUnicos = new Set();
        itens = todosItens.filter((item) => {
          if (idsUnicos.has(item.idAtendimento)) {
            return false;
          }
          idsUnicos.add(item.idAtendimento);
          return true;
        });
      } else {
        // Para outras colunas, usar os itens normalmente organizados por coluna
        itens = this.tarefasPorColuna[colunaId] || [];
      }

      const itensOrdenados = [...itens].sort(
        (a, b) => a.idAtendimento - b.idAtendimento,
      );

      // Aplica o filtro de busca ANTES de limitar a quantidade
      let itensFiltrados = itensOrdenados;

      if (this.buscaFunerarios && this.buscaFunerarios.trim() !== "") {
        const termoBusca = this.buscaFunerarios.toLowerCase().trim();
        itensFiltrados = itensOrdenados.filter((item) => {
          const idAtendimento = item.idAtendimento
            ? item.idAtendimento.toString().toLowerCase()
            : "";
          const nomeFalecido = item.nomeFalecido
            ? item.nomeFalecido.toLowerCase()
            : "";
          const nomeCliente = item.nomeCliente
            ? item.nomeCliente.toLowerCase()
            : "";

          return (
            idAtendimento.includes(termoBusca) ||
            nomeFalecido.includes(termoBusca) ||
            nomeCliente.includes(termoBusca)
          );
        });
      }

      // Aplica o limite de itens visíveis DEPOIS da busca
      const itensVisiveis = itensFiltrados
        .filter(this.passaFiltrosRapidos)
        .filter(
          (_, index) => index < this.paginacaoKanban.itensVisiveisPorColuna,
        );

      return itensVisiveis;
    },
    getItensVisiveisPorColunaTotal(colunaId) {
      let itens = [];

      if (colunaId === 6) {
        // Para a coluna 6, buscar todos os itens que tenham solicitacaoTransporteFamiliar como "SOLICITADO" ou "A DEFINIR"
        // e verificar se a etapa de transporte familiar (ID 6) não está concluída
        const itensFiltrados = this.servicosfunerarios.filter((item) => {
          const etapaTransporte = item.etapas.find((e) => e.etapaId === 6);
          const transporteNaoConcluido =
            !etapaTransporte || !etapaTransporte.dtFim;

          return (
            (item.solicitacaoTransporteFamiliar &&
              (item.solicitacaoTransporteFamiliar.includes("SOLICITADO") ||
                item.solicitacaoTransporteFamiliar.includes("A DEFINIR")) &&
              transporteNaoConcluido &&
              item.etapa.id !== 6 &&
              item.etapa.tipo === "Em andamento") ||
            (item.solicitacaoTransporteFamiliar &&
              !item.solicitacaoTransporteFamiliar.includes("SOLICITADO") &&
              item.etapa.id == 6)
          );
        });

        // Combinar com itens da coluna, removendo duplicatas baseado no idAtendimento
        const todosItens = [
          ...itensFiltrados,
          ...(this.tarefasPorColuna[colunaId] || []),
        ];
        const idsUnicos = new Set();
        itens = todosItens.filter((item) => {
          if (idsUnicos.has(item.idAtendimento)) {
            return false;
          }
          idsUnicos.add(item.idAtendimento);
          return true;
        });
      } else {
        // Para outras colunas, usar os itens normalmente organizados por coluna
        itens = this.tarefasPorColuna[colunaId] || [];
      }

      return itens.filter(this.passaFiltrosRapidos);
    },
    temMaisItensColuna(colunaId) {
      let total = 0;

      if (this.tagsFiltroSelecionadas.length) {
        total = this.getItensVisiveisPorColunaTotal(colunaId).length;
      } else if (colunaId === 6) {
        // Para a coluna 6, contar todos os itens que tenham solicitacaoTransporteFamiliar como "SOLICITADO"
        // independentemente da etapa atual, desde que não estejam na etapa 6
        total = this.servicosfunerarios.filter((item) => {
          return (
            item.solicitacaoTransporteFamiliar &&
            item.solicitacaoTransporteFamiliar.includes("SOLICITADO") &&
            item.etapa.id !== 6
          );
        }).length;
        total += (this.tarefasPorColuna[colunaId] || []).length;
      } else {
        // Para outras colunas, usar o total normalmente organizado por coluna
        total = (this.tarefasPorColuna[colunaId] || []).length;
      }

      return total > this.paginacaoKanban.itensVisiveisPorColuna;
    },

    temMaisItensLista() {
      return this.servicosfunerarios.length > this.paginacaoLista.itensVisiveis;
    },

    getInicioAtividade(element, coluna) {
      if (!element.etapas || !element.etapas.length) return "Não iniciado";

      const etapa = element.etapas.find((e) => e.etapaId === coluna.id);
      if (!etapa || !etapa.dtInicio) return "Não iniciado";

      // Se quiser formatar a data (supondo que está como string "dd/MM/yyyy hh:mm:ss" ou ISO)
      return etapa.dtInicio; // ou formate aqui conforme precisar
    },
    getVtrAtividade(element, coluna) {
      if (!element.etapas || !element.etapas.length) return "Não iniciado";

      const etapa = element.etapas.find((e) => e.etapaId === coluna.id);
      if (coluna.id === 3) {
        return !etapa || !etapa.salaPreparacao
          ? "Não iniciado"
          : etapa.salaPreparacao;
      } else {
        return !etapa || !etapa.vtr ? "Não iniciado" : etapa.vtr;
      }
    },
    getObservacaoEtapa(element, coluna) {
      if (!element.etapas || !element.etapas.length) return "";

      const etapa = element.etapas.find((e) => e.etapaId === coluna.id);
      return etapa?.observacoes || "";
    },
    getDataConclusaoServico(servico) {
      return servico?.dataConclusao || servico?.data_conclusao || "";
    },
    getResponsavel(element, coluna) {
      if (!this.listaColaboradores || !this.listaColaboradores.length)
        return "";

      const colaboradoresEtapaIds = [];

      element.etapas.forEach((etapa) => {
        if (etapa.etapaId === coluna.id) {
          colaboradoresEtapaIds.push(...etapa.colaboradores);
        }
      });

      const nomes = this.listaColaboradores
        .filter((colaborador) => colaboradoresEtapaIds.includes(colaborador.id))
        .map((colaborador) => colaborador.nome);

      if (nomes.length === 0) return "Nenhum responsável";

      const listaHtml =
        "<ol>" + nomes.map((nome) => `<li>${nome}</li>`).join("") + "</ol>";
      return listaHtml;
    },
    checkIfMobile() {
      const mobileQuery = window.matchMedia("(max-width: 599px)");
      this.isMobile = mobileQuery.matches;
      this.exibicao = !mobileQuery.matches;
      if (this.isMobile) {
        this.fluxoViewMode = "cards";
      } else if (this.fluxoViewMode === "cards") {
        this.fluxoViewMode = "kanban";
      }
    },
    // Abrir diálogo para iniciar uma etapa
    async abrirDialogIniciarEtapa(servico, coluna) {
      this.etapaAcao = "iniciar";
      this.etapaAtual = coluna;
      this.servicoAtual = JSON.parse(JSON.stringify(servico));

      if (this.etapaAtual.nome === "Preparação") {
        this.servicoAtual.usoSomatoConservacao = this.servicoAtual
          .usoSomatoConservacao
          ? this.servicoAtual.usoSomatoConservacao
          : false;
        this.servicoAtual.autorizacaoRetirada = this.servicoAtual
          .autorizacaoRetirada
          ? this.servicoAtual.autorizacaoRetirada
          : 0;
      }

      if (this.servicoAtual.dataInicioSomato != null) {
        this.servicoAtual.dataInicioSomato = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataInicioSomato,
        );
      }
      if (this.servicoAtual.dataFimSomato != null) {
        this.servicoAtual.dataFimSomato = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataFimSomato,
        );
      }
      if (this.servicoAtual.dataVelorio != null) {
        this.servicoAtual.dataVelorio = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataVelorio,
        );
      }
      if (this.servicoAtual.dataSepultamento != null) {
        this.servicoAtual.dataSepultamento = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataSepultamento,
        );
      }

      // Recuperar colaboradores existentes se houver
      const etapaExistente = servico.etapas?.find(
        (e) => e.etapaId === coluna.id,
      );
      this.etapaDadosTemp.colaboradores = etapaExistente?.colaboradores || [];
      this.etapaDadosTemp.supervisores = etapaExistente?.supervisores || [];
      this.etapaDadosTemp.observacoes = etapaExistente?.observacoes || null;

      const etapaExistenteSomato = servico.etapas?.find((e) => e.etapaId === 9);
      this.colaboradoresTempSomato = etapaExistenteSomato?.colaboradores || [];

      // Sempre converter datas do backend para ISO para os inputs
      const dtInicioISO = converteDataHoraBRParaInputISO(
        etapaExistente?.dtInicio,
      );

      const agora = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const dataHoraLocal = `${agora.getFullYear()}-${pad(
        agora.getMonth() + 1,
      )}-${pad(agora.getDate())}T${pad(agora.getHours())}:${pad(
        agora.getMinutes(),
      )}`;
      this.etapaDadosTemp.dataHoraInicio = dtInicioISO || dataHoraLocal;

      // Inicializar campos de ocorrência
      this.etapaDadosTemp.ocorrenciaJustificativa = null;
      this.etapaDadosTemp.ocorrenciaOpcao = null;
      this.etapaDadosTemp.tempoOcorrencia = 0;
      this.etapaDadosTemp.tempoOcorrenciaFormatted = "00:00";
      this.etapaDadosTemp.vtr = null;
      this.etapaDadosTemp.salaPreparacao = null;
      this.etapaDadosTemp.etapaDispensada = false;

      // Carregar atividades e inicializar formulário de nova atividade
      await this.consultarAtividadesDisponiveis(coluna.id);

      // Inicializar o objeto para nova atividade
      this.initNovaAtividadeEtapa(coluna.id);

      // Mostrar a seção de atividades por padrão
      if (!this.etapasComAtividades.includes(coluna.id)) {
        this.etapasComAtividades.push(coluna.id);
      }

      this.dialogEtapa = true;
    },

    // Abrir diálogo para finalizar uma etapa
    async abrirDialogFinalizarEtapa(servico, coluna) {
      this.servicoAtual = JSON.parse(JSON.stringify(servico));
      this.etapaAtual = coluna;
      this.etapaAcao = "finalizar";

      // Garantir que os painéis de atividades e ocorrências estejam fechados por padrão
      // Limpar os arrays que controlam quais etapas têm painéis abertos
      this.etapasComAtividades = [];
      this.etapasComOcorrencia = [];

      // Inicializar dados temporários da etapa
      this.etapaDadosTemp = {
        dataHoraInicio: null,
        dataHoraFim: null,
        colaboradores: [],
        supervisores: [],
        observacoes: null,
        ocorrenciaJustificativa: null,
        ocorrenciaOpcao: null,
        tempoOcorrencia: 0,
        tempoOcorrenciaFormatted: "00:00",
        vtr: null,
        salaPreparacao: null,
        etapaDispensada: false,
      };
      // Carregar dados existentes da etapa, se houver
      const etapaExistente = servico.etapas?.find(
        (e) => e.etapaId === coluna.id,
      );
      if (etapaExistente) {
        this.etapaDadosTemp.dataHoraInicio = converteDataHoraBRParaInputISO(
          etapaExistente.dtInicio,
        );
        this.etapaDadosTemp.dataHoraFim = converteDataHoraBRParaInputISO(
          etapaExistente.dtFim,
        );
        this.etapaDadosTemp.colaboradores = etapaExistente.colaboradores || [];
        this.etapaDadosTemp.supervisores = etapaExistente.supervisores || [];
        this.etapaDadosTemp.observacoes = etapaExistente.observacoes || null;
        this.etapaDadosTemp.ocorrenciaJustificativa =
          etapaExistente.ocorrenciaJustificativa || null;
        this.etapaDadosTemp.ocorrenciaOpcao = this.obterOpcaoOcorrencia(
          this.etapaDadosTemp,
        );
        this.etapaDadosTemp.tempoOcorrencia =
          etapaExistente.tempoOcorrencia || 0;
        this.etapaDadosTemp.tempoOcorrenciaFormatted = this.minutosParaTempo(
          etapaExistente.tempoOcorrencia,
        );
        this.etapaDadosTemp.vtr = etapaExistente.vtr || null;
        this.etapaDadosTemp.salaPreparacao =
          etapaExistente.salaPreparacao || null;
        this.etapaDadosTemp.etapaDispensada = !!etapaExistente.etapaDispensada;
      } else {
        // Se não existir, inicializar com valores padrão
        this.etapaDadosTemp.dataHoraInicio = converteDataHoraBRParaInputISO();
        this.etapaDadosTemp.dataHoraFim = converteDataHoraBRParaInputISO();
      }

      // Sempre converter datas do backend para ISO para os inputs
      const dtFimISO = converteDataHoraBRParaInputISO(etapaExistente?.dtFim);

      const agora = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const dataHoraLocal = `${agora.getFullYear()}-${pad(
        agora.getMonth() + 1,
      )}-${pad(agora.getDate())}T${pad(agora.getHours())}:${pad(
        agora.getMinutes(),
      )}`;
      this.etapaDadosTemp.dataHoraFim = dtFimISO || dataHoraLocal;

      if (this.servicoAtual.dataInicioSomato != null) {
        this.servicoAtual.dataInicioSomato = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataInicioSomato,
        );
      }
      if (this.servicoAtual.dataFimSomato != null) {
        this.servicoAtual.dataFimSomato = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataFimSomato,
        );
      }
      if (this.servicoAtual.dataVelorio != null) {
        this.servicoAtual.dataVelorio = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataVelorio,
        );
      }
      if (this.servicoAtual.dataSepultamento != null) {
        this.servicoAtual.dataSepultamento = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataSepultamento,
        );
      }

      const etapaExistenteSomato = servico.etapas?.find((e) => e.etapaId === 9);
      this.colaboradoresTempSomato = etapaExistenteSomato?.colaboradores || [];

      // Inicializar objeto para nova atividade
      this.novaAtividade = {
        atividadeFunerariaId: null,
        atividadeFunerariaDescricao: "",
        dtInicio: null,
        dtFim: null,
        tempoOcorrencia: null,
        colaboradores: [],
        vtr: null,
        salaPreparacao: null,
        etapaDispensada: false,
      };

      // Carregar atividades disponíveis
      await this.consultarAtividadesDisponiveis(coluna.id);

      this.dialogEtapa = true;
    },

    ajustarCamposTransporteFamiliar(servico) {
      if (!servico) return;
      const solicitacao = servico.solicitacaoTransporteFamiliar || "";

      if (solicitacao !== "SOLICITADO PARCIALMENTE") {
        this.$set(servico, "idaTransporteFamiliar", false);
        this.$set(servico, "voltaTransporteFamiliar", false);
      }

      if (!solicitacao.includes("SOLICITADO")) {
        [
          "tipoTransporteFamiliar",
          "origemTransporteFamiliar",
          "destinoTransporteFamiliar",
          "linkidaTransporteFamiliar",
          "linkvoltaTransporteFamiliar",
        ].forEach((campo) => this.$set(servico, campo, null));
      }
    },

    // Fechar diálogo de etapa
    async fecharDialogEtapa() {
      this.dialogEtapa = false;
      this.servicoAtual = null;
      this.etapaAtual = null;
      this.etapaDadosTemp.dataHoraInicio = null;
      this.etapaDadosTemp.dataHoraFim = null;
      this.etapaDadosTemp.usoSomatoConservacao = null;
      this.etapaDadosTemp.dataInicioSomato = null;
      this.etapaDadosTemp.dataFimSomato = null;
      this.etapaDadosTemp.solicitacaoTransporteFamiliar = null;
      this.etapaDadosTemp.tipoTransporteFamiliar = null;
      this.etapaDadosTemp.origemTransporteFamiliar = null;
      this.etapaDadosTemp.destinoTransporteFamiliar = null;
      this.etapaDadosTemp.linkidaTransporteFamiliar = null;
      this.etapaDadosTemp.linkvoltaTransporteFamiliar = null;
      this.etapaDadosTemp.autorizacaoRetirada = null;
      this.etapaDadosTemp.vtr = null;
      this.etapaDadosTemp.salaPreparacao = null;
      this.etapaDadosTemp.etapaDispensada = false;
      this.etapaDadosTemp.colaboradores = [];
      this.etapaDadosTemp.supervisores = [];
      this.etapaDadosTemp.observacoes = null;
      this.etapaDadosTemp.ocorrenciaJustificativa = null;
      this.etapaDadosTemp.ocorrenciaOpcao = null;
      this.etapaDadosTemp.tempoOcorrencia = 0;
      this.etapaDadosTemp.tempoOcorrenciaFormatted = "00:00";
      this.colaboradoresTempSomato = [];

      // Limpar etapas com ocorrência
      this.etapasComOcorrencia = [];
      this.etapasComAtividades = [];

      await this.init();
    },
    parseDataBR(dataStr) {
      if (!dataStr) return null;

      // ✅ Se já for Date
      if (dataStr instanceof Date) return dataStr;

      // ✅ Se for formato ISO (YYYY-MM-DDTHH:mm)
      if (dataStr.includes("T")) {
        return new Date(dataStr);
      }

      // ✅ Se for formato BR (dd/MM/yyyy HH:mm:ss)
      if (dataStr.includes("/")) {
        const [data, hora] = dataStr.split(" ");
        const [dia, mes, ano] = data.split("/");

        return new Date(`${ano}-${mes}-${dia}T${hora || "00:00:00"}`);
      }

      // fallback
      return new Date(dataStr);
    },
    // Salvar etapa específica
    async salvarEtapaEspecifica() {
      if (!this.servicoAtual) return;

      const validacoes = this.validacoesProsseguirEtapa();
      if (!validacoes.valid) {
        this.showAlert("Aviso", validacoes.message);
        return;
      }

      // Validar data de sepultamento vs data de atendimento
      if (
        this.servicoAtual.dataAtendimento &&
        this.servicoAtual.dataSepultamento
      ) {
        const dataAtendimento = this.parseDataBR(
          this.servicoAtual.dataAtendimento,
        );
        const dataSepultamento = this.parseDataBR(
          this.servicoAtual.dataSepultamento,
        );

        if (dataSepultamento < dataAtendimento) {
          this.showAlert(
            "Aviso",
            `A data do sepultamento não pode ser menor que a data do atendimento. Atendimento: ${this.servicoAtual.dataAtendimento}`,
          );
          return;
        }
      }

      try {
        // Criar cópia do serviço para edição
        const servicoParaEnvio = JSON.parse(JSON.stringify(this.servicoAtual));

        // Garantir que etapas existe
        if (!servicoParaEnvio.etapas) {
          servicoParaEnvio.etapas = [];
        }

        // Remover duplicatas de etapaId antes de continuar
        servicoParaEnvio.etapas = servicoParaEnvio.etapas.filter(
          (etapa, idx, arr) =>
            arr.findIndex((e) => e.etapaId === etapa.etapaId) === idx,
        );
        // Encontrar ou criar a etapa
        let etapa = servicoParaEnvio.etapas.find(
          (e) => e.etapaId === this.etapaAtual.id,
        );
        if (!etapa) {
          etapa = {
            ticketId: servicoParaEnvio.id,
            etapaId: this.etapaAtual.id,
            dtInicio: null,
            dtFim: null,
            colaboradores: [],
            supervisores: [],
            observacoes: null,
            ocorrenciaJustificativa: null,
            tempoOcorrencia: 0,
            vtr: null,
            salaPreparacao: null,
            etapaDispensada: false,
          };
          servicoParaEnvio.etapas.push(etapa);
          servicoParaEnvio.etapa = this.etapaAtual;
        }
        // Encontrar ou criar a etapa
        let etapaSomato = servicoParaEnvio.etapas.find((e) => e.etapaId === 9);
        if (!etapaSomato) {
          etapaSomato = {
            ticketId: servicoParaEnvio.id,
            etapaId: 9,
            dtInicio: await converteDataHoraInputISOParaBR(
              this.etapaDadosTemp.dataInicioSomato,
            ),
            dtFim: await converteDataHoraInputISOParaBR(
              this.etapaDadosTemp.dataFimSomato,
            ),
            colaboradores: this.colaboradoresTempSomato,
            supervisores: [],
            observacoes: null,
            ocorrenciaJustificativa: null,
            tempoOcorrencia: 0,
            vtr: null,
            salaPreparacao: null,
            etapaDispensada: false,
          };
          servicoParaEnvio.etapas.push(etapaSomato);
        } else {
          // se já existe, atualiza campos
          etapaSomato.dtInicio = await converteDataHoraInputISOParaBR(
            this.etapaDadosTemp.dataInicioSomato,
          );
          etapaSomato.dtFim = await converteDataHoraInputISOParaBR(
            this.etapaDadosTemp.dataFimSomato,
          );
          etapaSomato.colaboradores = [...this.colaboradoresTempSomato];
          etapaSomato.supervisores = [];
          etapaSomato.observacoes = null;
          etapaSomato.ocorrenciaJustificativa = null;
          etapaSomato.tempoOcorrencia = 0;
          etapaSomato.vtr = null;
          etapaSomato.salaPreparacao = null;
          servicoParaEnvio.etapas.push(etapaSomato);
        }

        if (this.etapaDadosTemp.dataHoraFim != null) {
          etapa.dtFim = converteDataHoraInputISOParaBR(
            this.etapaDadosTemp.dataHoraFim,
          );
        }
        if (this.etapaDadosTemp.dataHoraInicio != null) {
          etapa.dtInicio = converteDataHoraInputISOParaBR(
            this.etapaDadosTemp.dataHoraInicio,
          );
        }

        if (servicoParaEnvio.dataInicioSomato != null) {
          servicoParaEnvio.dataInicioSomato = converteDataHoraInputISOParaBR(
            servicoParaEnvio.dataInicioSomato,
          );
        }
        if (servicoParaEnvio.dataFimSomato != null) {
          servicoParaEnvio.dataFimSomato = converteDataHoraInputISOParaBR(
            servicoParaEnvio.dataFimSomato,
          );
        }
        if (servicoParaEnvio.dataVelorio != null) {
          servicoParaEnvio.dataVelorio = converteDataHoraInputISOParaBR(
            servicoParaEnvio.dataVelorio,
          );
        }
        if (servicoParaEnvio.dataSepultamento != null) {
          servicoParaEnvio.dataSepultamento = converteDataHoraInputISOParaBR(
            servicoParaEnvio.dataSepultamento,
          );
        }

        // Verificar se a etapa atual está sendo finalizada
        if (
          this.etapaDadosTemp.dataHoraFim &&
          !isNaN(new Date(this.etapaDadosTemp.dataHoraFim))
        ) {
          // Verificar se deve avançar para a próxima etapa
          if (this.deveAvancarEtapa(servicoParaEnvio)) {
            servicoParaEnvio.etapa.id++;
          }
        }

        // Atualizar colaboradores, supervisores e observações
        etapa.colaboradores = this.etapaDadosTemp.colaboradores;
        etapa.supervisores = this.etapaDadosTemp.supervisores;
        etapa.observacoes = this.etapaDadosTemp.observacoes;
        etapa.vtr = this.etapaDadosTemp.vtr;
        etapa.salaPreparacao = this.etapaDadosTemp.salaPreparacao;
        etapa.etapaDispensada = !!this.etapaDadosTemp.etapaDispensada;

        // Atualizar campos de ocorrência
        if (etapa) {
          etapa.ocorrenciaJustificativa =
            this.etapaDadosTemp.ocorrenciaJustificativa;
          etapa.tempoOcorrencia = this.etapaDadosTemp.tempoOcorrencia;
        }
        // Formatar etapas para envio ao servidor
        servicoParaEnvio.etapas = servicoParaEnvio.etapas
          .filter(
            (e) =>
              e.ticketId &&
              e.etapaId &&
              (e.dtInicio ||
                e.dtFim ||
                e.colaboradores.length > 0 ||
                e.supervisores.length > 0 ||
                e.observacoes ||
                e.ocorrenciaJustificativa ||
                e.tempoOcorrencia > 0 ||
                e.etapaDispensada),
          )
          .map((e) => {
            const etapaDispensada = !!e.etapaDispensada;

            return {
              id: e.id,
              ticketId: e.ticketId,
              etapaId: e.etapaId,
              dtInicio: etapaDispensada ? null : e.dtInicio || null,
              dtFim: etapaDispensada ? null : e.dtFim || null,
              colaboradores: etapaDispensada ? [] : e.colaboradores || [],
              supervisores: etapaDispensada ? [] : e.supervisores || [],
              observacoes: etapaDispensada ? null : e.observacoes || null,
              ocorrenciaJustificativa: etapaDispensada
                ? null
                : e.ocorrenciaJustificativa || null,
              tempoOcorrencia: etapaDispensada ? 0 : e.tempoOcorrencia || 0,
              vtr: etapaDispensada ? null : e.vtr || null,
              salaPreparacao: etapaDispensada ? null : e.salaPreparacao || null,
              etapaDispensada,
            };
          });
        if (
          this.etapaDadosTemp.dataHoraFim != null &&
          !isNaN(new Date(this.etapaDadosTemp.dataHoraFim))
        ) {
          // Verificar se deve mostrar o diálogo de conclusão
          if (this.deveExibirDialogConclusao(servicoParaEnvio)) {
            this.servicoAtual = JSON.parse(JSON.stringify(servicoParaEnvio));
            this.dialogConcluir = true;
            console.log("abrir dialogo");
            return;
          }
        }

        // Enviar para o servidor
        await http.put(
          `/servico-funerario/${servicoParaEnvio.id}`,
          servicoParaEnvio,
          { headers: authHeader() },
        );

        // Fechar diálogo e atualizar dados
        this.init();
        this.fecharDialogEtapa();
      } catch (error) {
        console.error("Erro ao salvar etapa:", error);
        this.showAlert(
          "Erro",
          this.getMensagemErroApi(
            error,
            "Nao foi possivel salvar a etapa do servico.",
          ),
        );
      }
    },

    playOrPause(element, coluna) {
      const etapa = element.etapas?.find(
        (etapa) => etapa.etapaId === coluna.id,
      );

      if (etapa && etapa.dtInicio) {
        return false;
      }
      return true;
    },

    // Abrir diálogo de atribuição
    abrirDialogAtribuir(element, coluna) {
      this.dialogAtribuir = true;
      this.atribuirTicketId = element.id;
      this.atribuirEtapaId = coluna.id;
      this.atribuirNomeFalecido = element.nomeFalecido;
      this.atribuirNomeEtapa = coluna.nome;
    },

    // Fechar diálogo de atribuição
    fecharDialogAtribuir() {
      this.dialogAtribuir = false;
      this.atribuirTicketId = null;
      this.atribuirEtapaId = null;
      this.atribuirNomeFalecido = "";
      this.atribuirNomeEtapa = "";
    },

    // Confirmar atribuição
    async confirmarAtribuicao() {
      try {
        await http.post(`/servico-funerario/atribuir`, null, {
          params: {
            ticketId: this.atribuirTicketId,
            etapaId: this.atribuirEtapaId,
          },
          headers: authHeader(),
        });

        this.fecharDialogAtribuir();
        this.init();
      } catch (error) {
        console.error("Erro ao atribuir responsável:", error);
      }
    },
    async handlePlayButton(element, coluna) {
      // Se for do tipo "Agendado", incrementar para a próxima etapa
      if (element.etapa.tipo === "Agendado") {
        await this.alterarEtapa(element, 2);
        await this.init();
      } else {
        // Se for "Em andamento", abrir o diálogo para iniciar a etapa
        this.abrirDialogIniciarEtapa(element, coluna);
      }
    },

    // Método para incrementar a etapa (para etapas do tipo "Agendado")
    async alterarEtapa(servico, etapaNova) {
      try {
        // Criar cópia do serviço para edição (deep clone)
        let servicoParaEnvio = JSON.parse(JSON.stringify(servico));

        servicoParaEnvio.etapa.id = etapaNova;

        // Enviar para o servidor
        await http.put(
          `/servico-funerario/${servicoParaEnvio.id}`,
          servicoParaEnvio,
          { headers: authHeader() },
        );

        // Atualizar dados
        this.init();
      } catch (error) {
        console.error("Erro ao alterar etapa:", error);
        this.showAlert(
          "Erro",
          this.getMensagemErroApi(
            error,
            "Nao foi possivel alterar a etapa do servico.",
          ),
        );
        this.init();
      }
    },
    updateEtapa(etapaId, novaListaColaboradores = null) {
      // Atualiza apenas a lista de colaboradores se fornecido
      if (novaListaColaboradores !== null) {
        const etapa = this.getEtapaRef(this.servicoEditando, etapaId);
        etapa.colaboradores = novaListaColaboradores;
      }
    },

    updateEtapaSupervisores(etapaId, novaListaSupervisores = null) {
      // Atualiza apenas a lista de supervisores se fornecido
      if (novaListaSupervisores !== null) {
        const etapa = this.getEtapaRef(this.servicoEditando, etapaId);
        etapa.supervisores = novaListaSupervisores;
      }
    },

    updateEtapaObservacoes(etapaId, novasObservacoes = null) {
      // Atualiza apenas as observações se fornecido
      if (novasObservacoes !== null) {
        const etapa = this.getEtapaRef(this.servicoEditando, etapaId);
        etapa.observacoes = novasObservacoes;
      }
    },

    dispensarEtapaOperacional(etapaId, dispensada) {
      const etapa = this.getEtapaRef(this.servicoEditando, etapaId);
      const etapaDispensada = !!dispensada;

      this.$set(etapa, "etapaDispensada", etapaDispensada);
      if (!etapaDispensada) return;

      etapa.dtInicio = null;
      etapa.dtFim = null;
      etapa.colaboradores = [];
      etapa.supervisores = [];
      etapa.observacoes = null;
      etapa.ocorrenciaJustificativa = null;
      etapa.ocorrenciaOpcao = null;
      etapa.tempoOcorrencia = 0;
      etapa.tempoOcorrenciaFormatted = "00:00";
      etapa.vtr = null;
      etapa.salaPreparacao = null;

      const coluna = this.colunas.find((item) => item.id === etapaId);
      const nomeEtapa = String(coluna?.nome || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

      if (nomeEtapa.includes("preparacao")) {
        this.servicoEditando.usoSomatoConservacao = false;
        this.servicoEditando.dataInicioSomato = null;
        this.servicoEditando.dataFimSomato = null;
        this.servicoEditando.colaboradoresSomato = [];
        this.servicoEditando.autorizacaoRetirada = null;
      }

      this.etapasComOcorrencia = this.etapasComOcorrencia.filter(
        (id) => id !== etapaId,
      );
      this.etapasComAtividades = this.etapasComAtividades.filter(
        (id) => id !== etapaId,
      );
      this.initNovaAtividadeEtapa(etapaId);
    },

    // Converte tempo de hh:mm para minutos
    tempoParaMinutos(tempoString) {
      if (!tempoString) return 0;
      const [horas, minutos] = tempoString.split(":").map(Number);
      return horas * 60 + minutos;
    },

    // Converte minutos para formato hh:mm
    minutosParaTempo(minutos) {
      if (!minutos || minutos === 0) return "00:00";
      const horas = Math.floor(minutos / 60);
      const mins = minutos % 60;
      return `${horas.toString().padStart(2, "0")}:${mins
        .toString()
        .padStart(2, "0")}`;
    },

    // Atualiza o tempo da ocorrência convertendo de hh:mm para minutos
    updateTempoOcorrencia(etapaId, tempoString) {
      const etapa = this.getEtapaRef(this.servicoEditando, etapaId);
      etapa.tempoOcorrencia = this.tempoParaMinutos(tempoString);
    },

    ocorrenciaEhOpcaoFixa(valor) {
      return this.opcoesOcorrencia
        .filter((opcao) => opcao !== "OUTROS")
        .includes(valor);
    },

    obterOpcaoOcorrencia(etapa) {
      if (!etapa) return null;
      if (etapa.ocorrenciaOpcao) return etapa.ocorrenciaOpcao;
      if (!etapa.ocorrenciaJustificativa) return null;
      return this.ocorrenciaEhOpcaoFixa(etapa.ocorrenciaJustificativa)
        ? etapa.ocorrenciaJustificativa
        : "OUTROS";
    },

    selecionarOcorrencia(etapa, opcao) {
      if (!etapa) return;
      this.$set(etapa, "ocorrenciaOpcao", opcao || null);

      if (!opcao) {
        etapa.ocorrenciaJustificativa = null;
        return;
      }

      if (opcao === "OUTROS") {
        if (this.ocorrenciaEhOpcaoFixa(etapa.ocorrenciaJustificativa)) {
          etapa.ocorrenciaJustificativa = "";
        }
        return;
      }

      etapa.ocorrenciaJustificativa = opcao;
    },

    deveExibirDescricaoOcorrencia(etapa) {
      return this.obterOpcaoOcorrencia(etapa) === "OUTROS";
    },

    temOcorrenciaLancada(etapa) {
      return !!(
        etapa &&
        (etapa.ocorrenciaJustificativa || Number(etapa.tempoOcorrencia || 0) > 0)
      );
    },

    // Toggle para mostrar/ocultar campos de ocorrência no dialogEtapa
    toggleOcorrenciaEtapa() {
      const etapaId = this.etapaAtual?.id;
      if (!etapaId) return;

      if (this.etapasComOcorrencia.includes(etapaId)) {
        this.etapasComOcorrencia = this.etapasComOcorrencia.filter(
          (id) => id !== etapaId,
        );
      } else {
        this.etapasComOcorrencia.push(etapaId);
      }
    },

    // Toggle para mostrar/ocultar campos de ocorrência no dialogEdicao
    toggleOcorrenciaEdicao(etapaId) {
      if (!etapaId) return;

      const index = this.etapasComOcorrencia.indexOf(etapaId);
      if (index > -1) {
        this.etapasComOcorrencia.splice(index, 1);
      } else {
        this.etapasComOcorrencia.push(etapaId);
      }
    },

    // Toggle para mostrar/ocultar campos de atividades no dialogEdicao
    toggleAtividades(etapaId) {
      if (!etapaId) return;

      const index = this.etapasComAtividades.indexOf(etapaId);
      if (index > -1) {
        this.etapasComAtividades.splice(index, 1);
      } else {
        this.etapasComAtividades.push(etapaId);
        // Inicializar o objeto de nova atividade para esta etapa
        this.initNovaAtividadeEtapa(etapaId);
        // Carregar atividades disponíveis para esta etapa
        this.consultarAtividadesDisponiveis(etapaId);
      }
    },

    // Inicializar o objeto de nova atividade para uma etapa
    initNovaAtividadeEtapa(etapaId) {
      if (!etapaId) return;

      this.$set(this.novaAtividadeEtapa, etapaId, {
        atividadeFunerariaId: null,
        atividadeFunerariaDescricao: null,
        dtInicio: null,
        dtFim: null,
        colaboradores: [],
        editando: false,
        id: null,
      });
    },

    // Obter o valor de um campo do objeto novaAtividadeEtapa
    getNovaAtividadeEtapaField(etapaId, field) {
      if (!this.novaAtividadeEtapa[etapaId]) {
        this.initNovaAtividadeEtapa(etapaId);
      }
      return this.novaAtividadeEtapa[etapaId][field];
    },

    // Obter os colaboradores de uma atividade de etapa
    getNovaAtividadeEtapaColaboradores(etapaId) {
      if (
        !this.novaAtividadeEtapa[etapaId] ||
        !this.novaAtividadeEtapa[etapaId].colaboradores
      ) {
        return [];
      }
      return this.novaAtividadeEtapa[etapaId].colaboradores;
    },

    // Obter atividades de uma etapa específica
    getAtividadesDaEtapa(servico, etapaId) {
      if (!servico || !etapaId || !servico.etapas) return [];

      // Encontrar a etapa específica
      const etapa = servico.etapas.find((e) => e.etapaId === etapaId);
      if (!etapa) return [];

      // Retornar as atividades dessa etapa (ou array vazio)
      return etapa.atividades || [];
    },

    // Obter atividades disponíveis que ainda não foram usadas em uma etapa
    getAtividadesDisponiveisDaEtapa(servico, etapaId) {
      if (!servico || !etapaId || !servico.etapas) return [];

      // Verificar se já temos atividades carregadas para esta etapa
      if (!this.atividadesDisponiveisPorEtapa[etapaId]) {
        // Se não temos, forçar a consulta de atividades disponíveis para esta etapa
        this.consultarAtividadesDisponiveis(etapaId);
        return []; // Retornar array vazio enquanto carrega
      }

      // Encontrar a etapa específica
      const etapa = servico.etapas.find((e) => e.etapaId === etapaId);
      if (!etapa) return this.atividadesDisponiveisPorEtapa[etapaId] || []; // Se não encontrar a etapa, retorna todas as atividades disponíveis

      // Obter IDs das atividades já usadas nesta etapa
      const atividadesUsadas = etapa.atividades
        ? etapa.atividades.map((a) => a.atividadeFunerariaId)
        : [];

      // Filtrar apenas as atividades que não estão sendo usadas nesta etapa
      return (this.atividadesDisponiveisPorEtapa[etapaId] || []).filter(
        (atividade) => !atividadesUsadas.includes(atividade.id),
      );
    },

    // Obter todas as atividades disponíveis para uma etapa (incluindo as já cadastradas)
    getTodasAtividadesDisponiveis(etapaId) {
      if (!etapaId) return [];

      // Verificar se já temos atividades carregadas para esta etapa
      if (!this.atividadesDisponiveisPorEtapa[etapaId]) {
        // Se não temos, forçar a consulta de atividades disponíveis para esta etapa
        this.consultarAtividadesDisponiveis(etapaId);
        return []; // Retornar array vazio enquanto carrega
      }

      // Retornar as atividades específicas para esta etapa
      return this.atividadesDisponiveisPorEtapa[etapaId] || [];
    },

    // Atualiza o tempo da ocorrência no dialogEtapa
    updateTempoOcorrenciaEtapa(tempoString) {
      this.etapaDadosTemp.tempoOcorrencia = this.tempoParaMinutos(tempoString);
    },

    getEtapaRef(servico, etapaId) {
      // Garante que a lista de etapas existe
      if (!servico) return {};
      if (!servico.etapas) {
        this.$set(servico, "etapas", []);
      }

      // Procura a etapa existente
      let etapa = servico.etapas.find((e) => e.etapaId === etapaId);

      // Se não existir, cria uma nova etapa com valores padrão
      if (!etapa) {
        etapa = {
          id: null,
          ticketId: servico.id,
          etapaId: etapaId,
          dtInicio: null,
          dtFim: null,
          colaboradores: [],
          supervisores: [],
          observacoes: null,
          ocorrenciaJustificativa: null,
          ocorrenciaOpcao: null,
          tempoOcorrencia: 0,
          vtr: null,
          salaPreparacao: null,
          etapaDispensada: false,
          atividades: [],
        };
        servico.etapas.push(etapa);
      }

      return etapa;
    },

    getEtapaAtividadeId(servico, etapaId) {
      const etapa = this.getEtapaRef(servico, etapaId);
      // Verificar se a etapa tem atividades
      if (etapa && etapa.atividades && etapa.atividades.length > 0) {
        // Retornar o ID da primeira atividade (ou você pode implementar uma lógica diferente aqui)
        return etapa.atividades[0].atividadeFunerariaId;
      }
      // Se não houver atividades, retornar null ou um valor padrão
      return null;
    },

    truncateString(str, maxLength) {
      if (str.length > maxLength) {
        return str.substring(0, maxLength) + "...";
      }
      return str;
    },
    diferencaTempo(element, coluna) {
      const etapaAtual = element.etapas.find(
        (etapa) => etapa.etapaId === coluna.id,
      );
      if (!etapaAtual || etapaAtual.dtInicio === null) {
        return null;
      }

      const dtInicio = this.parseBRDate(etapaAtual.dtInicio);
      const agora = new Date();
      const diferencaMs = agora - dtInicio;

      // converter tudo em minutos
      const minutosPassados = Math.floor(diferencaMs / (1000 * 60));

      // Não mostrar se a data for futura
      if (minutosPassados < 0) {
        return null;
      }

      const tempoOcorrencia = Number(etapaAtual.tempoOcorrencia || 0);
      const temOcorrenciaSemTempo = !!etapaAtual.ocorrenciaJustificativa && tempoOcorrencia <= 0;
      const minutosConsiderados = tempoOcorrencia > 0
        ? Math.max(minutosPassados - tempoOcorrencia, 0)
        : minutosPassados;

      // SLA já está em minutos
      const SLAmin = coluna.sla;
      const statusSLA = temOcorrenciaSemTempo ? false : minutosConsiderados > SLAmin;

      // formatar em h/m só para exibir
      const horas = Math.floor(minutosConsiderados / 60);
      const minutos = minutosConsiderados % 60;
      const tempo = `${horas}h ${minutos}m`;

      return {
        tempo,
        statusSLA,
      };
    },
    async abrirDialog(servico) {
      this.modoCriacaoManual = false;
      this.markViewed(servico);
      await this.atualizarStatusConexaoIvertex();

      const servicoOri = await this.consultarId(servico.id);

      // Criar uma cópia do serviço para edição
      this.servicoEditando = JSON.parse(JSON.stringify(servicoOri));
      this.$set(
        this.servicoEditando,
        "numeroDeclaracaoObito",
        this.servicoEditando.numeroDeclaracaoObito ||
          this.servicoEditando.numero_declaracao_obito ||
          null,
      );
      this.servicoEditando.dataAtendimento = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataAtendimento,
      );

      // Garantir que etapas existe antes de tentar iterar
      if (!this.servicoEditando.etapas) {
        this.servicoEditando.etapas = [];
      }
      // Converter datas das etapas existentes do formato BR para ISO (para inputs datetime-local)
      this.servicoEditando.etapas.forEach((etapa) => {
        etapa.dtInicio = converteDataHoraBRParaInputISO(etapa.dtInicio);
        etapa.dtFim = converteDataHoraBRParaInputISO(etapa.dtFim);

        // Garantir que colaboradores existe como array
        if (!etapa.colaboradores) {
          etapa.colaboradores = [];
        }

        // Garantir que supervisores existe como array
        if (!etapa.supervisores) {
          etapa.supervisores = [];
        }

        // Garantir que observacoes existe
        if (!etapa.observacoes) {
          etapa.observacoes = null;
        }

        // Garantir que ocorrenciaJustificativa existe
        if (!etapa.ocorrenciaJustificativa) {
          etapa.ocorrenciaJustificativa = null;
        }
        this.$set(etapa, "ocorrenciaOpcao", this.obterOpcaoOcorrencia(etapa));

        // Garantir que tempoOcorrencia existe e converter para formato hh:mm
        if (!etapa.tempoOcorrencia) {
          etapa.tempoOcorrencia = 0;
        }
        etapa.tempoOcorrenciaFormatted = this.minutosParaTempo(
          etapa.tempoOcorrencia,
        );
        this.$set(etapa, "etapaDispensada", !!etapa.etapaDispensada);
        if (etapa.etapaDispensada) {
          this.dispensarEtapaOperacional(etapa.etapaId, true);
        }

        // Garantir que ticketId e etapaId existem
        if (!etapa.ticketId) {
          etapa.ticketId = servicoOri.id;
        }
      });

      const etapaExistenteSomato = servicoOri.etapas?.find(
        (e) => e.etapaId === 9,
      );
      this.servicoEditando.colaboradoresSomato =
        etapaExistenteSomato?.colaboradores || [];

      // Limpar o objeto novaAtividadeEtapa
      this.novaAtividadeEtapa = {};

      // Inicializar novaAtividadeEtapa para etapas que estão com atividades expandidas
      this.etapasComAtividades.forEach((etapaId) => {
        this.initNovaAtividadeEtapa(etapaId);
        this.consultarAtividadesDisponiveis(etapaId);
      });

      this.servicoEditando.nascimentoFalecido = converteDataParaFormatoISO(
        this.servicoEditando.nascimentoFalecido,
      );
      this.servicoEditando.dtFalecido = converteDataHoraBRParaInputISO(
        this.servicoEditando.dtFalecido,
      );

      this.servicoEditando.dataInicioSomato = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataInicioSomato,
      );
      this.servicoEditando.dataFimSomato = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataFimSomato,
      );
      this.servicoEditando.dataVelorio = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataVelorio,
      );

      this.servicoEditando.dataSepultamento = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataSepultamento,
      );
      this.carregarTagsSelecionadasServicoEditando();
      this.consultarHistorico(this.servicoEditando.id);
      this.carregarProcedimentosEdicao(this.servicoEditando.id);

      this.panel = [this.servicoEditando.etapa.id - 2];
      this.dialogEdicao = true;
    },
    criarServicoEditandoVazio() {
      const etapaInicial = this.colunas.find(
        (coluna) => !coluna.etapaSuporte && coluna.ordem,
      ) || this.colunas[0] || { id: null, nome: "", cor: "" };

      return {
        id: null,
        etapa: {
          id: etapaInicial.id,
          nome: etapaInicial.nome || "",
          cor: etapaInicial.cor || "",
        },
        idAtendimento: null,
        dataAtendimento: "",
        origem: "",
        destino: "",
        obs: "",
        atendente: "",
        cpfAtendente: "",
        contrato: "",
        tipoContrato: "",
        idDeclarante: null,
        declarante: "",
        cpfDeclarante: "",
        parentescoDeclarante: "",
        contatoDeclarante: "",
        idCliente: null,
        cliente: "",
        cpfCliente: "",
        idFalecido: null,
        nomeFalecido: "",
        cpfFalecido: "",
        alturaFalecido: 0,
        pesoFalecido: 0,
        dtFalecido: "",
        valorAtendimento: 0,
        nascimentoFalecido: "",
        causaMorte: null,
        causaPrincipal: null,
        numeroDeclaracaoObito: null,
        localVelorio: null,
        dataVelorio: null,
        localSepultamento: null,
        dataSepultamento: null,
        autorizacaoRetirada: null,
        solicitacaoTransporteFamiliar: null,
        tipoTransporteFamiliar: null,
        origemTransporteFamiliar: null,
        destinoTransporteFamiliar: null,
        linkidaTransporteFamiliar: null,
        linkvoltaTransporteFamiliar: null,
        usoSomatoConservacao: null,
        dataInicioSomato: null,
        dataFimSomato: null,
        etapas: [],
        itens: [],
        tags: [],
        pendencia: null,
        criadoManual: true,
      };
    },
    async atualizarStatusConexaoIvertex() {
      if (this.consultaStatusIvertexEmAndamento) {
        return this.consultaStatusIvertexEmAndamento;
      }

      this.verificandoConexaoIvertex = true;
      this.falhaVerificacaoConexaoIvertex = false;
      this.consultaStatusIvertexEmAndamento = (async () => {
        try {
          const response = await conexaoIvertexService.verificar_status();
          this.conexaoIvertexAtiva = response.data?.conectado === true;
          return this.conexaoIvertexAtiva;
        } catch (error) {
          console.error("Erro ao verificar conexão com o iVertex:", error);
          this.conexaoIvertexAtiva = false;
          this.falhaVerificacaoConexaoIvertex = true;
          return false;
        }
      })();

      try {
        return await this.consultaStatusIvertexEmAndamento;
      } finally {
        this.consultaStatusIvertexEmAndamento = null;
        this.verificandoConexaoIvertex = false;
      }
    },
    async abrirCriacaoManualAtendimento() {
      const conexaoAtiva = await this.atualizarStatusConexaoIvertex();
      if (conexaoAtiva) {
        this.showAlert(
          "Criação manual bloqueada",
          "O iVertex está disponível. A criação manual só é permitida quando o sistema estiver indisponível.",
        );
        return;
      }

      this.prepararCriacaoManualAtendimento();
    },
    prepararCriacaoManualAtendimento() {
      this.modoCriacaoManual = true;
      this.tab = 0;
      this.panel = [];
      this.historico = [];
      this.procedimentosEdicao = [];
      this.tagsServicoEditando = [];
      this.tagsServicoEditandoOriginal = [];
      this.servicoEditando = this.criarServicoEditandoVazio();
      this.dialogEdicao = true;
    },
    fecharDialog() {
      this.servicoEditando = this.criarServicoEditandoVazio();
      this.historico = [];
      this.etapasComOcorrencia = [];
      this.etapasComAtividades = [];
      this.novaAtividadeEtapa = {};
      this.procedimentosEdicao = [];
      this.procedimentoExcluindo = null;
      this.dialogProcedimentoResposta = false;
      this.procedimentoRespondendo = null;
      this.modoRespostaProcedimento = null;
      this.dialogPendencia = false;
      this.pendencia = null;
      this.dialogSincronizacaoIvertex = false;
      this.dadosIvertexSincronizacao = null;
      this.diferencasIvertex = [];
      this.confirmDialog.show = false;
      this.dialogEdicao = false;
      this.modoCriacaoManual = false;
    },

    inicializarFiltroEtapasPadrao() {
      const tiposValidos = this.getTiposEtapaDisponiveis();

      this.tiposEtapaFiltroSelecionados =
        this.tiposEtapaFiltroSelecionados.filter((tipo) =>
          tiposValidos.includes(tipo),
        );

      if (this.tiposEtapaFiltroInicializado) return;

      this.tiposEtapaFiltroSelecionados = tiposValidos.filter((tipo) =>
        ["Agendado", "Em andamento"].includes(tipo),
      );
      this.tiposEtapaFiltroInicializado = true;
    },

    getTiposEtapaDisponiveis() {
      return [
        ...new Set(this.colunas.map((coluna) => coluna.tipo).filter(Boolean)),
      ];
    },

    getTiposEtapaFiltroAtivos() {
      return Array.isArray(this.tiposEtapaFiltroSelecionados)
        ? this.tiposEtapaFiltroSelecionados
        : [];
    },

    getQuantidadeColunasPorTipo(tipo) {
      return this.colunas.filter((coluna) => coluna.tipo === tipo).length;
    },

    getCorTipoEtapa(tipo) {
      const coluna = this.colunas.find((item) => item.tipo === tipo);
      return coluna?.cor || "#607d8b";
    },

    getColunasFiltradas() {
      const tiposAtivos = this.getTiposEtapaFiltroAtivos();
      if (!tiposAtivos.length) return this.colunas;

      return this.colunas.filter((coluna) => tiposAtivos.includes(coluna.tipo));
    },

    async salvarEdicao() {
      if (!this.servicoEditando) return;

      try {
        // Validar data de sepultamento vs data de atendimento
        if (
          this.servicoEditando.dataAtendimento &&
          this.servicoEditando.dataSepultamento
        ) {
          const dataAtendimento = new Date(
            this.servicoEditando.dataAtendimento,
          );
          const dataSepultamento = new Date(
            this.servicoEditando.dataSepultamento,
          );

          if (dataSepultamento < dataAtendimento) {
            this.showAlert(
              "Aviso",
              "A data do sepultamento não pode ser menor que a data do atendimento.",
            );
            return;
          }
        }

        if (this.modoCriacaoManual) {
          await this.criarAtendimentoManual();
          return;
        }

        const servicoParaEnvio = JSON.parse(
          JSON.stringify(this.servicoEditando),
        );

        // Garantir que etapas existe no payload sem alterar o formulario
        if (!servicoParaEnvio.etapas) {
          servicoParaEnvio.etapas = [];
        }

        // Formatar etapas para envio ao servidor
        servicoParaEnvio.etapas = servicoParaEnvio.etapas
          .filter(
            (etapa) =>
              etapa.ticketId &&
              etapa.etapaId &&
              (etapa.dtInicio ||
                etapa.dtFim ||
                (etapa.colaboradores || []).length > 0 ||
                (etapa.supervisores || []).length > 0 ||
                etapa.observacoes ||
                etapa.ocorrenciaJustificativa ||
                etapa.tempoOcorrencia > 0 ||
                etapa.etapaDispensada) &&
              etapa.etapaId !== 9,
          ) // Filtrar apenas etapas válidas
          .map((etapa) => {
            const etapaDispensada = !!etapa.etapaDispensada;

            return {
              id: etapa.id,
              ticketId: etapa.ticketId,
              etapaId: etapa.etapaId,
              dtInicio: etapaDispensada
                ? null
                : etapa.dtInicio
                ? converteDataHoraInputISOParaBR(etapa.dtInicio)
                : null,
              dtFim: etapaDispensada
                ? null
                : etapa.dtFim
                ? converteDataHoraInputISOParaBR(etapa.dtFim)
                : null,
              colaboradores: etapaDispensada ? [] : etapa.colaboradores || [],
              supervisores: etapaDispensada ? [] : etapa.supervisores || [],
              observacoes: etapaDispensada ? null : etapa.observacoes || null,
              ocorrenciaJustificativa: etapaDispensada
                ? null
                : etapa.ocorrenciaJustificativa || null,
              tempoOcorrencia: etapaDispensada ? 0 : etapa.tempoOcorrencia || 0,
              vtr: etapaDispensada ? null : etapa.vtr || null,
              salaPreparacao: etapaDispensada ? null : etapa.salaPreparacao || null,
              etapaDispensada,
            };
          });
        // Encontrar ou criar a etapa
        let etapaSomato = servicoParaEnvio.etapas.find(
          (e) => e.etapaId === 9,
        );
        if (!etapaSomato) {
          etapaSomato = {
            ticketId: servicoParaEnvio.id,
            etapaId: 9,
            dtInicio: converteDataHoraInputISOParaBR(
              servicoParaEnvio.dataInicioSomato,
            ),
            dtFim: converteDataHoraInputISOParaBR(
              servicoParaEnvio.dataFimSomato,
            ),
            colaboradores: servicoParaEnvio.colaboradoresSomato,
            supervisores: [],
            observacoes: null,
            ocorrenciaJustificativa: null,
            ocorrenciaOpcao: null,
            tempoOcorrencia: 0,
            etapaDispensada: false,
          };
          servicoParaEnvio.etapas.push(etapaSomato);
        }

        servicoParaEnvio.dataAtendimento = converteDataHoraInputISOParaBR(
          servicoParaEnvio.dataAtendimento,
        );
        servicoParaEnvio.dtFalecido = converteDataHoraInputISOParaBR(
          servicoParaEnvio.dtFalecido,
        );

        servicoParaEnvio.nascimentoFalecido = converteDataParaFormatoBR(
          servicoParaEnvio.nascimentoFalecido,
        );
        servicoParaEnvio.dataSepultamento = converteDataHoraInputISOParaBR(
          servicoParaEnvio.dataSepultamento,
        );
        servicoParaEnvio.dataVelorio = converteDataHoraInputISOParaBR(
          servicoParaEnvio.dataVelorio,
        );

        servicoParaEnvio.dataInicioSomato = converteDataHoraInputISOParaBR(
          servicoParaEnvio.dataInicioSomato,
        );

        servicoParaEnvio.dataFimSomato = converteDataHoraInputISOParaBR(
          servicoParaEnvio.dataFimSomato,
        );

        servicoParaEnvio.etapas.forEach((etapa) => {
          if (etapa) {
            etapa.ocorrenciaJustificativa =
              etapa.ocorrenciaJustificativa || null;
            etapa.tempoOcorrencia = etapa.tempoOcorrencia || 0;
          }
        });

        await http.put(
          `/servico-funerario/${servicoParaEnvio.id}`,
          servicoParaEnvio,
          {
            headers: authHeader(),
          },
        );
        this.fecharDialog();
        await this.init(true);
      } catch (error) {
        console.error("Erro ao salvar edição:", error);
        this.showAlert(
          "Erro",
          this.getMensagemErroApi(
            error,
            "Nao foi possivel salvar a edicao.",
          ),
        );
      }
    },
    async criarAtendimentoManual() {
      const idAtendimento = Number(this.servicoEditando.idAtendimento);
      const nomeFalecido = (this.servicoEditando.nomeFalecido || "").trim();
      if (!idAtendimento || !nomeFalecido) {
        this.showAlert(
          "Aviso",
          "Informe o ID do atendimento e o nome do falecido.",
        );
        return;
      }

      const payload = JSON.parse(JSON.stringify(this.servicoEditando));
      delete payload.etapas;
      delete payload.itens;
      delete payload.tags;
      payload.id = null;
      payload.idAtendimento = idAtendimento;
      payload.nomeFalecido = nomeFalecido;
      payload.dataAtendimento = converteDataHoraInputISOParaBR(
        payload.dataAtendimento,
      ) || null;
      payload.dtFalecido = converteDataHoraInputISOParaBR(payload.dtFalecido) || null;
      payload.nascimentoFalecido = payload.nascimentoFalecido
        ? converteDataParaFormatoBR(payload.nascimentoFalecido)
        : null;
      payload.dataVelorio = converteDataHoraInputISOParaBR(payload.dataVelorio) || null;
      payload.dataSepultamento =
        converteDataHoraInputISOParaBR(payload.dataSepultamento) || null;

      try {
        await funerariaService.criar_atendimento_manual(payload);
        this.fecharDialog();
        await this.init(true);
        this.showAlert("Sucesso", "Atendimento criado com sucesso.");
      } catch (error) {
        console.error("Erro ao criar atendimento manual:", error);
        this.showAlert(
          "Erro",
          this.getMensagemErroApi(error, "Nao foi possivel criar o atendimento."),
        );
      }
    },

    camposSincronizacaoIvertex() {
      return [
        { campo: "dataAtendimento", rotulo: "Data do Atendimento", tipo: "datetime" },
        { campo: "origem", rotulo: "Local de Origem", tipo: "text" },
        { campo: "destino", rotulo: "Local de Destino", tipo: "text" },
        { campo: "obs", rotulo: "Observações", tipo: "text" },
        { campo: "atendente", rotulo: "Atendente", tipo: "text" },
        { campo: "cpfAtendente", rotulo: "CPF do Atendente", tipo: "cpf" },
        { campo: "contrato", rotulo: "Contrato", tipo: "text" },
        { campo: "tipoContrato", rotulo: "Tipo do Contrato", tipo: "text" },
        { campo: "cliente", rotulo: "Cliente", tipo: "text" },
        { campo: "cpfCliente", rotulo: "CPF do Cliente", tipo: "cpf" },
        { campo: "declarante", rotulo: "Declarante", tipo: "text" },
        { campo: "cpfDeclarante", rotulo: "CPF do Declarante", tipo: "cpf" },
        { campo: "parentescoDeclarante", rotulo: "Parentesco do Declarante", tipo: "text" },
        { campo: "contatoDeclarante", rotulo: "Contato do Declarante", tipo: "text" },
        { campo: "nomeFalecido", rotulo: "Nome do Falecido", tipo: "text" },
        { campo: "cpfFalecido", rotulo: "CPF do Falecido", tipo: "cpf" },
        { campo: "religiao", rotulo: "Religião", tipo: "text" },
        { campo: "dtFalecido", rotulo: "Data do Falecimento", tipo: "datetime" },
        { campo: "nascimentoFalecido", rotulo: "Nascimento do Falecido", tipo: "date" },
        { campo: "causaMorte", rotulo: "Causa da Morte", tipo: "text" },
        { campo: "causaPrincipal", rotulo: "Causa Principal", tipo: "text" },
        { campo: "dataVelorio", rotulo: "Data e Hora do Velório", tipo: "datetime" },
        { campo: "localVelorio", rotulo: "Local do Velório", tipo: "text" },
        { campo: "dataSepultamento", rotulo: "Data e Hora do Sepultamento", tipo: "datetime" },
        { campo: "localSepultamento", rotulo: "Local do Sepultamento", tipo: "text" },
      ];
    },

    normalizarValorSincronizacao(valor, tipo) {
      if (tipo === "datetime") {
        return converteDataHoraBRParaInputISO(valor) || valor || "";
      }
      if (tipo === "date") {
        return converteDataParaFormatoISO(valor) || valor || "";
      }
      if (tipo === "cpf") {
        return String(valor || "").replace(/\D/g, "");
      }
      return valor == null ? "" : String(valor).trim();
    },

    formatarValorSincronizacao(valor, tipo) {
      if (!valor) return "";
      if (tipo === "datetime") {
        return converteDataHoraInputISOParaBR(valor) || valor;
      }
      if (tipo === "date") {
        return converteDataParaFormatoBR(valor) || valor;
      }
      return String(valor);
    },

    compararDadosIvertex(dadosIvertex) {
      return this.camposSincronizacaoIvertex()
        .map((campoConfig) => {
          const valorAtual = this.normalizarValorSincronizacao(
            this.servicoEditando[campoConfig.campo],
            campoConfig.tipo,
          );
          const valorIvertex = this.normalizarValorSincronizacao(
            dadosIvertex[campoConfig.campo],
            campoConfig.tipo,
          );

          if (!valorIvertex || valorAtual === valorIvertex) return null;

          return {
            ...campoConfig,
            selecionado: false,
            valorOriginal: valorAtual,
            valorIvertex,
            valorAtualExibicao: this.formatarValorSincronizacao(
              valorAtual,
              campoConfig.tipo,
            ),
            valorIvertexExibicao: this.formatarValorSincronizacao(
              valorIvertex,
              campoConfig.tipo,
            ),
          };
        })
        .filter(Boolean);
    },

    aplicarDiferencasIvertex() {
      this.diferencasIvertex
        .filter((diferenca) => diferenca.selecionado)
        .forEach((diferenca) => {
          this.$set(this.servicoEditando, diferenca.campo, diferenca.valorIvertex);
        });
      this.dialogSincronizacaoIvertex = false;
      this.diferencasIvertex = [];
      this.showAlert(
        "Aviso",
        "Valores do iVertex aplicados no formulário. Revise e clique em Salvar Alterações para gravar.",
      );
    },

    async sincronizarAtendimento() {
      if (!this.servicoEditando?.id) return;

      this.sincronizandoAtendimento = true;
      try {
        const response = await funerariaService.sincronizar_atendimento(
          this.servicoEditando.id,
        );

        if (response.status === 200) {
          this.dadosIvertexSincronizacao = response.data;
          this.diferencasIvertex = this.compararDadosIvertex(response.data);
          if (!this.diferencasIvertex.length) {
            this.showAlert(
              "Aviso",
              "Os dados do atendimento já estão iguais aos dados do iVertex.",
            );
            return;
          }
          this.dialogSincronizacaoIvertex = true;
        }
      } catch (error) {
        console.error("Erro ao sincronizar ticket com iVertex:", error);
        this.showAlert(
          "Erro",
          this.getMensagemErroApi(
            error,
            "Erro ao sincronizar dados do iVertex. Tente novamente.",
          ),
        );
      } finally {
        this.sincronizandoAtendimento = false;
      }
    },
    atualizarServicoNaListagem(servicoAtualizado) {
      if (!servicoAtualizado?.id) return;
      const index = this.servicosfunerarios.findIndex(
        (servico) => servico.id === servicoAtualizado.id,
      );
      if (index === -1) return;
      this.servicosfunerarios.splice(index, 1, {
        ...this.servicosfunerarios[index],
        ...servicoAtualizado,
      });
      this.carregarTarefas(this.servicosfunerarios);
    },
    async consultar_colaboradores() {
      try {
        const response = await rh.lista_colaboradores_por_departamento(
          "SERVICOS FUNERARIOS",
        );
        this.listaColaboradores = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async consultar_colaboradores_sac() {
      try {
        const response = await rh.lista_colaboradores_por_departamento(
          "SAC - SERVICO DE ATENDIMENTO AO CONSUMIDOR",
        );
        this.listaColaboradoresSAC = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async carregarColunas() {
      try {
        const response = await http.get("/servico-funerario/etapas", {
          headers: authHeader(),
        });
        if (response.status === 200) {
          this.colunas = response.data.filter(
            (coluna) => coluna.etapaSuporte === false,
          );
          this.colunasSuporte = response.data.filter(
            (coluna) => coluna.etapaSuporte === true,
          );
          this.colunasFiltros = [
            {
              id: 0,
              nome: "Todas",
              cor: "#4782b4",
              tipo: "Finalizado",
              etapaSuporte: false,
              sla: 60,
            },
            ...this.colunas.filter((col) => col.etapaSuporte === false),
          ].sort((a, b) => a.id - b.id);
          this.inicializarFiltroEtapasPadrao();
        }
      } catch (e) {
        console.error(e);
      }
    },
    async carregarTarefas(servicosFunerarios) {
      this.tarefasPorColuna = [];

      const mapa = {};
      this.colunas.forEach((coluna) => {
        mapa[coluna.id] = [];
      });

      servicosFunerarios.forEach((item) => {
        if (mapa[item.etapa?.id]) {
          mapa[item.etapa.id].push(item);
        }
      });

      this.tarefasPorColuna = mapa;
    },
    isColorDark(hexColor) {
      if (!hexColor) {
        return false;
      }
      if (!hexColor.startsWith("#")) {
        hexColor = "#" + hexColor;
      }
      const hex = hexColor.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      const yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq < 128;
    },
    async aoArrastar(event, novaEtapa) {
      if (!this.hasPermissionEdit) {
        this.init();
        return;
      }

      const servicoArrastado = event.added?.element;
      const etapaAtual = event.added?.element.etapa;

      if (
        servicoArrastado &&
        servicoArrastado.solicitacaoTransporteFamiliar &&
        !servicoArrastado.solicitacaoTransporteFamiliar.includes(
          "SOLICITADO",
        ) &&
        novaEtapa.id === 6
      ) {
        this.showAlert(
          "Erro",
          "Serviço não pode ser arrastado para a etapa de transporte familiar, pois não foi solicitado.",
        );
        this.init();
        return;
      }

      if (!servicoArrastado) {
        return;
      }
      if (etapaAtual.id > novaEtapa.id) {
        await this.alterarEtapa(servicoArrastado, novaEtapa.id);
        return;
      }
      if (etapaAtual.tipo === "Agendado" || etapaAtual.tipo === "Falha") {
        await this.alterarEtapa(servicoArrastado, novaEtapa.id);
        return;
      }

      const etapaEncontrada = servicoArrastado.etapas.find(
        (etapa) => etapa.etapaId === etapaAtual.id,
      );
      if (
        !etapaEncontrada ||
        etapaEncontrada.dtInicio === null ||
        etapaEncontrada.dtFim === null ||
        etapaEncontrada.colaboradores.length === 0
      ) {
        if (etapaAtual.nome === "Preparação") {
          servicoArrastado.usoSomatoConservacao =
            servicoArrastado.usoSomatoConservacao
              ? servicoArrastado.usoSomatoConservacao
              : false;
          servicoArrastado.autorizacaoRetirada =
            servicoArrastado.autorizacaoRetirada
              ? servicoArrastado.autorizacaoRetirada
              : 0;
        }
        this.abrirDialogFinalizarEtapa(servicoArrastado, etapaAtual);
        return;
      }

      await this.alterarEtapa(servicoArrastado, novaEtapa.id);
    },
    obterAgendaPorColuna(colunaId) {
      return this.servicosfunerarios.filter(
        (servico) => servico.etapa.id === colunaId.id,
      );
    },
    isDateValid(dateString) {
      const date = new Date(dateString);
      return !isNaN(date.getTime());
    },

    filterData(valores) {
      this.selectedStartDate = valores.selectedStartDate;
      this.selectedEndDate = valores.selectedEndDate;
      if (valores.selectMode === "Em abertos") {
        this.tipoDataFiltro = "abertos";
        this.init();
        return;
      }

      this.tipoDataFiltro =
        valores.selectMode === "Conclusão do Atendimento"
          ? "conclusao"
          : "atendimento";

      if (
        this.calcularDiferencaEntreDatas(
          this.selectedStartDate,
          this.selectedEndDate,
        ) > 30
      ) {
        this.showFilter = true;
        return;
      }
      this.init();
    },

    getFirstDayOfMonth() {
      const dataAtual = new Date();
      const primeiroDiaDoMes = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1,
      );
      return this.formatDateBR(primeiroDiaDoMes);
    },

    formatDateBR(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0");
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },

    async dashboard(silencioso = false) {
      if (!silencioso) {
        this.isLoading = true;
        this.servicosfunerarios = [];
      }
      if (this.somenteFavoritos) {
        try {
          const params = { tipoData: this.tipoDataFiltro };
          if (this.tipoDataFiltro !== "abertos") {
            params.dataInicio = converteDataParaFormatoISO(this.selectedStartDate);
            params.dataFim = converteDataParaFormatoISO(this.selectedEndDate);
          }
          const response = await funerariaService.listar_favoritos(params);
          this.servicosfunerarios = response.data || [];
        } catch (e) {
          console.error(e);
          this.showAlert(
            "Erro",
            this.getMensagemErroApi(e, "Nao foi possivel carregar os favoritos."),
          );
        } finally {
          if (!silencioso) {
            this.isLoading = false;
          }
        }
        return;
      }
      if (this.tipoDataFiltro === "abertos") {
        try {
          const response = await funerariaService.listar_tickets_abertos(
            this.listarExcluidos,
          );
          if (response.status === 200) {
            this.servicosfunerarios = response.data;
          }
        } catch (e) {
          console.error(e);
        } finally {
          if (!silencioso) {
            this.isLoading = false;
          }
        }
        return;
      }

      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate,
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);

      try {
        const response = await http.get("/servico-funerario", {
          params: {
            dataInicio: formattedStartDate,
            dataFim: formattedEndDate,
            tipoData: this.tipoDataFiltro,
            excluidos: this.listarExcluidos,
          },
          headers: authHeader(),
        });
        if (response.status === 200) {
          this.servicosfunerarios = response.data;
        }
      } catch (e) {
        console.error(e);
      } finally {
        console.log("finalizado");
        if (!silencioso) {
          this.isLoading = false;
        }
        console.log(this.isLoading);
      }
    },
    verificarDialogos() {
      if (
        !this.dialogEtapa &&
        !this.dialogAtribuir &&
        !this.dialogConcluir &&
        !this.dialogEdicao &&
        !this.isMobile
      ) {
        this.init(true);
      }

      setTimeout(() => {
        this.verificarDialogos(); // vai rodar SEMPRE de novo
      }, 300000);
    },
    async init(silencioso = false) {
      await this.carregarTagsDisponiveis();
      await this.carregarColunas();
      await this.dashboard(silencioso);
      this.carregarStatusSyncFunerario();
      await this.carregarResumoCards(silencioso);
      await this.filtrarTickets();
      await this.consultar_colaboradores();
      await this.consultar_colaboradores_sac();

      await this.carregarTarefas(this.servicosfunerarios);
      await this.consultarAutorizacoesRetiradas();
    },

    async consultarAutorizacoesRetiradas() {
      try {
        const response = await http.get("/servico-funerario/autorizacoes", {
          headers: authHeader(),
        });
        if (response.status === 200) {
          this.autorizacoesRetiradas = response.data;
        }
      } catch (e) {
        console.error(e);
      }
    },

    async consultarId(ticketId) {
      try {
        const response = await http.get(`/servico-funerario/${ticketId}`, {
          headers: authHeader(),
        });
        if (response.status === 200) {
          return response.data;
        }
      } catch (e) {
        console.error(e);
      }
    },

    async consultarHistorico(ticketId) {
      try {
        const response = await http.get(
          `/servico-funerario/${ticketId}/historico`,
          {
            headers: authHeader(),
          },
        );
        if (response.status === 200) {
          this.historico = response.data;
        }
      } catch (e) {
        console.error(e);
      }
    },

    async consultarAtividadesDisponiveis(etapaId) {
      try {
        const response = await funerariaService.atividades_etapa(etapaId);
        if (response.status === 200) {
          // Armazenar as atividades no objeto por etapa
          this.$set(this.atividadesDisponiveisPorEtapa, etapaId, response.data);

          // Manter a compatibilidade com o código existente
          this.atividadesDisponiveis = response.data;
        }
      } catch (e) {
        console.error(
          "Erro ao consultar atividades disponíveis para etapa " +
            etapaId +
            ":",
          e,
        );
        this.$set(this.atividadesDisponiveisPorEtapa, etapaId, []);
        this.atividadesDisponiveis = [];
      }
    },
    formatarMoeda(valor) {
      if (isNaN(valor)) {
        return "Valor inválido";
      }
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    convertToBR(dateString) {
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },
    getStatus(status) {
      switch (status) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";

        default:
          "success";
      }
    },

    calcularDiferencaEntreDatas(dataInicial, dataFinal) {
      const [dia1, mes1, ano1] = dataInicial.split("/");
      const [dia2, mes2, ano2] = dataFinal.split("/");

      const data1 = new Date(`${ano1}-${mes1}-${dia1}`);
      const data2 = new Date(`${ano2}-${mes2}-${dia2}`);

      if (isNaN(data1) || isNaN(data2)) {
        return NaN;
      }

      const diferencaEmMilissegundos = data2 - data1;
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);

      return diferencaEmDias;
    },

    clear() {
      this.$refs.form.reset();
    },

    formatarDataHora(dataHoraISO) {
      if (!dataHoraISO) return "-";
      // Converte "2025-08-28T20:06:00" para "28/08/2025 20:06"
      const data = new Date(dataHoraISO);
      const dia = data.getDate().toString().padStart(2, "0");
      const mes = (data.getMonth() + 1).toString().padStart(2, "0");
      const ano = data.getFullYear();
      const hora = data.getHours().toString().padStart(2, "0");
      const minuto = data.getMinutes().toString().padStart(2, "0");
      return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
    },

    async excluirAtividade(id) {
      if (!confirm("Tem certeza que deseja excluir esta atividade?")) {
        return;
      }

      this.excluindoAtividade = id;
      try {
        const response = await funerariaService.excluir_atividade(id);
        if (response.status === 200) {
          // Recarregar as atividades
          await this.init();
          this.showAlert("Sucesso", "Atividade excluída com sucesso!");
        }
      } catch (error) {
        console.error("Erro ao excluir atividade:", error);
        this.showAlert("Erro", "Ocorreu um erro ao excluir a atividade.");
      } finally {
        this.excluindoAtividade = null;
        this.fecharDialog();
        this.fecharDialogEtapa();
      }
    },
    parseDateEtapa(dateStr) {
      if (!dateStr) return null;
      // Formato esperado: "dd/MM/yyyy HH:mm:ss"
      const [datePart, timePart] = dateStr.split(" ");
      const [day, month, year] = datePart.split("/");
      return new Date(`${year}-${month}-${day}T${timePart}`);
    },
    atividadeCompleta(atividade) {
      return (
        atividade.atividadeFunerariaId &&
        atividade.colaboradores &&
        atividade.colaboradores.length > 0 &&
        atividade.dtInicio
      );
    },
    async salvarAtividade(idEtapa, idServico) {
      this.salvandoAtividade = true;
      try {
        const servico = this.servicosfunerarios.find((s) => s.id === idServico);

        // Encontrar a etapa específica do ticket
        if (!idEtapa) {
          this.showAlert(
            "Erro",
            "Não foi possível identificar a etapa do ticket.",
          );
          return;
        }
        const etapaTicket = servico.etapas.find((e) => e.etapaId === idEtapa);

        if (!etapaTicket) {
          this.showAlert(
            "Erro",
            "Não foi possível identificar a etapa do ticket. Inicie a etapa primeiro.",
          );
          return;
        }
        const inicioAtividade = new Date(this.novaAtividade.dtInicio); // já está em ISO
        const fimAtividade = new Date(this.novaAtividade.dtFim);

        const inicioEtapa = this.parseDateEtapa(etapaTicket.dtInicio);
        const fimEtapa = this.parseDateEtapa(etapaTicket.dtFim);

        // atividade de transporte pode iniciar antes da etapa
        if (idEtapa !== 6 && idEtapa !== 5 && inicioAtividade < inicioEtapa) {
          this.showAlert(
            "Erro",
            "A data de início da atividade deve ser maior que a data de início da etapa.",
          );
          return;
        }

        // atividade de velorio pode terminar depois da etapa
        if (idEtapa !== 5 && fimEtapa && fimAtividade > fimEtapa) {
          this.showAlert(
            "Erro",
            "A data de fim da atividade deve ser menor que a data de fim da etapa.",
          );
          return;
        }

        const dto = {
          ticketFunerarioEtapaId: etapaTicket.id,
          atividadeFunerariaId: this.novaAtividade.atividadeFunerariaId,
          atividadeFunerariaDescricao:
            this.novaAtividade.atividadeFunerariaDescricao,
          dtInicio: this.novaAtividade.dtInicio,
          dtFim: this.novaAtividade.dtFim,
          tempoOcorrencia: this.novaAtividade.tempoOcorrencia,
          colaboradores: this.novaAtividade.colaboradores.map(
            (colaboradorId) => ({
              colaboradorId: colaboradorId,
            }),
          ),
        };

        const response = await funerariaService.adicionar_atividade(dto);
        if (response.status === 200) {
          // Limpar o formulário
          this.novaAtividade = {
            atividadeFunerariaId: null,
            atividadeFunerariaDescricao: "",
            dtInicio: null,
            dtFim: null,
            tempoOcorrencia: null,
            colaboradores: [],
          };

          // this.showAlert("Sucesso", "Atividade adicionada com sucesso!");
        }
        this.fecharDialog();
        this.fecharDialogEtapa();
        this.init();
      } catch (error) {
        console.error("Erro ao salvar atividade:", error);
        this.showAlert("Erro", "Ocorreu um erro ao salvar a atividade.");
      } finally {
        this.salvandoAtividade = false;
      }
    },

    getNomeColaborador(colaboradorId) {
      const colaborador = this.listaColaboradores.find(
        (c) => c.id === colaboradorId,
      );
      return colaborador ? colaborador.nome : "-";
    },

    // Método para verificar se deve avançar para a próxima etapa
    deveAvancarEtapa(servico) {
      // Obter referências às etapas relevantes usando IDs
      const etapaVelorio = servico.etapas.find((e) => e.etapaId === 5); // ID 5 = Velório
      const etapaTransporteFamiliar = servico.etapas.find(
        (e) => e.etapaId === 6,
      ); // ID 6 = Transporte familiar
      const isVelorioFinalizado = etapaVelorio && etapaVelorio.dtFim;

      // Caso 5: Na etapa de Transporte familiar (ID 6), se Velório não estiver concluído, não avança
      if (this.etapaAtual.id === 6 && !isVelorioFinalizado) {
        // Não avança a etapa e não abre dialog
        return false;
      }

      // Em todos os outros casos, avança para a próxima etapa
      return true;
    },

    // Método para verificar se deve exibir o diálogo de conclusão
    deveExibirDialogConclusao(servico) {
      // Obter referências às etapas relevantes usando IDs
      const etapaVelorio = this.servicoAtual.etapas.find(
        (e) => e.etapaId === 5,
      ); // ID 5 = Velório
      const etapaTransporteFamiliar = this.servicoAtual.etapas.find(
        (e) => e.etapaId === 6,
      ); // ID 6 = Transporte familiar
      const isVelorioFinalizado = etapaVelorio && etapaVelorio.dtFim;
      const isTransporteFinalizado =
        etapaTransporteFamiliar && etapaTransporteFamiliar.dtFim;

      // Caso 1: SOMENTE VELÓRIO - Na etapa de Velório (ID 5), abre dialog para concluir caso não tenha transporte familiar
      if (
        this.servicoAtual.etapa.id === 5 &&
        this.etapaAtual.id === 5 &&
        this.servicoAtual.solicitacaoTransporteFamiliar &&
        (this.servicoAtual.solicitacaoTransporteFamiliar.includes(
          "DISPENSADO",
        ) ||
          this.servicoAtual.solicitacaoTransporteFamiliar.includes(
            "NÃO DISPONIBILIZADO",
          ))
      ) {
        return true;
      }
      // Caso 2: VELÓRIO E TRANSPORTE FAMILIAR - Na etapa de Velório (ID 5), caso Transporte familiar já esteja concluído
      if (
        this.servicoAtual.etapa.id === 5 &&
        this.etapaAtual.id === 5 &&
        isTransporteFinalizado
      ) {
        return true;
      }

      // Caso 4: VELÓRIO E TRANSPORTE FAMILIAR - Na etapa de Transporte familiar (ID 6), caso Velório já esteja concluído
      if (
        this.servicoAtual.etapa.id === 6 &&
        this.etapaAtual.id === 6 &&
        isVelorioFinalizado
      ) {
        return true;
      }

      // Caso 3: AMBOS FINALIZADOS - Quando ambas as etapas estão finalizadas
      if (isVelorioFinalizado && isTransporteFinalizado) {
        return true;
      }

      // Nos demais casos, não exibe o diálogo
      return false;
    },

    // Método para editar uma atividade existente
    editarAtividade(atividade) {
      this.modoEdicaoAtividade = true;
      this.atividadeEditandoId = atividade.id;
      this.editandoAtividade = true;

      // Preencher o formulário com os dados da atividade selecionada
      this.novaAtividade = {
        atividadeFunerariaId: atividade.atividadeFunerariaId,
        atividadeFunerariaDescricao: atividade.atividadeFunerariaDescricao,
        dtInicio: atividade.dtInicio,
        dtFim: atividade.dtFim,
        tempoOcorrencia: atividade.tempoOcorrencia,
        colaboradores: atividade.colaboradores.map((c) => c.colaboradorId),
        ticketFunerarioEtapaId: atividade.ticketFunerarioEtapaId,
      };

      // Rolar até o formulário de edição
      const formElement = document.getElementById(
        `atividade-form-${atividade.ticketFunerarioEtapa.etapaId}`,
      );
      if (formElement) {
        formElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },

    // Método para cancelar a edição de uma atividade
    cancelarEdicaoAtividade() {
      // Limpar o formulário
      this.novaAtividade = {
        atividadeFunerariaId: null,
        atividadeFunerariaDescricao: "",
        dtInicio: null,
        dtFim: null,
        tempoOcorrencia: null,
        colaboradores: [],
      };

      // Resetar o estado de edição
      this.modoEdicaoAtividade = false;
      this.atividadeEditandoId = null;
      this.editandoAtividade = false;
    },

    // Método para atualizar uma atividade existente
    async atualizarAtividade(idEtapa) {
      this.salvandoAtividadeEtapa = idEtapa;
      try {
        // Verificar se está em modo de edição e se tem um ID de atividade válido
        if (!this.modoEdicaoAtividade || !this.atividadeEditandoId) {
          this.showAlert("Erro", "Nenhuma atividade selecionada para edição.");
          return;
        }

        // Validar datas da atividade em relação à etapa
        const servicoRef = this.servicoAtual || this.servicoEditando;
        const etapaTicket = servicoRef?.etapas?.find(
          (e) => e.etapaId === idEtapa,
        );

        if (!etapaTicket) {
          this.showAlert(
            "Erro",
            "Não foi possível identificar a etapa do ticket. Inicie a etapa primeiro.",
          );
          return;
        }

        const inicioAtividade = new Date(this.novaAtividade.dtInicio); // já está em ISO
        const fimAtividade = new Date(this.novaAtividade.dtFim);

        const inicioEtapa = this.parseDateEtapa(etapaTicket.dtInicio);
        const fimEtapa = this.parseDateEtapa(etapaTicket.dtFim);

        // atividade de transporte pode iniciar antes da etapa
        if (idEtapa !== 6 && idEtapa !== 5 && inicioAtividade < inicioEtapa) {
          this.showAlert(
            "Erro",
            "A data de início da atividade deve ser maior que a data de início da etapa.",
          );
          return;
        }

        // atividade de velorio pode terminar depois da etapa
        if (idEtapa !== 5 && fimEtapa && fimAtividade > fimEtapa) {
          this.showAlert(
            "Erro",
            "A data de fim da atividade deve ser menor que a data de fim da etapa.",
          );
          return;
        }

        // Preparar o DTO para atualização
        const dto = {
          atividadeFunerariaId: this.novaAtividade.atividadeFunerariaId,
          atividadeFunerariaDescricao:
            this.novaAtividade.atividadeFunerariaDescricao,
          dtInicio: this.novaAtividade.dtInicio,
          dtFim: this.novaAtividade.dtFim,
          tempoOcorrencia: this.novaAtividade.tempoOcorrencia,
          colaboradores: this.novaAtividade.colaboradores.map(
            (colaboradorId) => ({
              colaboradorId: colaboradorId,
            }),
          ),
          ticketFunerarioEtapaId: this.novaAtividade.ticketFunerarioEtapaId,
        };

        // Chamar a API para atualizar a atividade
        const response = await funerariaService.editar_atividade(
          dto,
          this.atividadeEditandoId,
        );

        if (response.status === 200) {
          // Limpar o formulário e resetar o estado
          this.cancelarEdicaoAtividade();
          // this.showAlert("Sucesso", "Atividade adicionada com sucesso!");
        }

        this.fecharDialog();
        this.fecharDialogEtapa();
        this.init();
      } catch (error) {
        console.error("Erro ao atualizar atividade:", error);
        this.showAlert("Erro", "Ocorreu um erro ao atualizar a atividade.");
      } finally {
        this.salvandoAtividadeEtapa = null;
      }
    },

    isAtividadeCadastrada(atividadeId, etapaId) {
      // Verificar se a atividade está na lista de atividades da etapa especificada
      if (!this.servicoEditando || !this.servicoEditando.etapas) return false;

      // Obter a etapa especificada
      const etapa = this.servicoEditando.etapas.find(
        (e) => e.etapaId === etapaId,
      );
      if (!etapa || !etapa.atividades || !etapa.atividades.length) return false;

      // Verificar se a atividade já está cadastrada nesta etapa
      return etapa.atividades.some(
        (atividade) => atividade.atividadeFunerariaId === atividadeId,
      );
    },

    // === GERENCIAMENTO DE ITENS ===

    formatarMoeda(valor) {
      if (valor == null) return "R$ 0,00";
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    // Excluir Item
    confirmarExcluirItem(item) {
      this.itemParaExcluir = item;
      this.dialogExcluirItem = true;
    },

    async excluirItemConfirmado() {
      if (!this.itemParaExcluir) return;

      this.loadingExclusao = true;
      try {
        await funerariaService.excluir_item_atendimento(
          this.itemParaExcluir.id,
        );

        // Remove o item da lista local
        const idx = this.servicoEditando.itens.findIndex(
          (i) => i.id === this.itemParaExcluir.id,
        );
        if (idx > -1) {
          this.servicoEditando.itens.splice(idx, 1);
        }

        this.showAlert("Sucesso", "Item excluído com sucesso!");
        this.dialogExcluirItem = false;
        this.itemParaExcluir = null;
      } catch (error) {
        console.error("Erro ao excluir item:", error);
        this.showAlert("Erro", "Erro ao excluir item. Tente novamente.");
      } finally {
        this.loadingExclusao = false;
      }
    },

    async abrirDialogValidarUrna(item) {
      this.itemUrnaValidacao = item;
      this.qrcodeUrnaManual = "";
      this.resultadoValidacaoUrna = null;
      this.erroCameraUrna = null;
      this.dialogValidarUrna = true;
      this.$nextTick(() => {
        this.iniciarLeitorUrna();
      });
    },

    async iniciarLeitorUrna() {
      await this.pararLeitorUrna();
      this.erroCameraUrna = null;

      const readerId = "urna-qrcode-reader";
      const readerElement = document.getElementById(readerId);
      if (!readerElement) {
        this.erroCameraUrna =
          "Não foi possível acessar a câmera. Informe o QR Code manualmente.";
        return;
      }

      try {
        this.urnaQrScanner = new Html5Qrcode(readerId);
        await this.urnaQrScanner.start(
          { facingMode: "environment" },
          {
            fps: 10,
            qrbox: { width: 240, height: 240 },
          },
          (decodedText) => {
            if (!this.validandoUrna && !this.resultadoValidacaoUrna) {
              this.validarUrnaPorQrcode(decodedText);
            }
          },
        );
      } catch (error) {
        console.error("Erro ao iniciar leitor de QR Code:", error);
        this.erroCameraUrna =
          "Não foi possível acessar a câmera. Informe o QR Code manualmente.";
      }
    },

    async pararLeitorUrna() {
      if (!this.urnaQrScanner) {
        return;
      }

      const scanner = this.urnaQrScanner;
      this.urnaQrScanner = null;
      try {
        if (scanner.isScanning) {
          await scanner.stop();
        }
        await scanner.clear();
      } catch (error) {
        console.warn("Erro ao parar leitor de QR Code:", error);
      }
    },

    async validarUrnaManual() {
      if (!this.qrcodeUrnaManual) return;
      await this.validarUrnaPorQrcode(this.qrcodeUrnaManual);
    },

    async validarUrnaPorQrcode(qrcode) {
      if (!this.itemUrnaValidacao || !qrcode) return;

      this.validandoUrna = true;
      this.qrcodeUrnaManual = String(qrcode).trim();
      try {
        await this.pararLeitorUrna();
        const response = await funerariaService.validar_urna_item(
          this.itemUrnaValidacao.id,
          this.qrcodeUrnaManual,
        );
        this.resultadoValidacaoUrna = response.data;
        this.atualizarItemUrnaValidacao(response.data?.item);
        this.agendarFechamentoValidacaoUrna();
      } catch (error) {
        console.error("Erro ao validar urna:", error);
        this.showAlert(
          "Erro",
          error.response?.data?.message ||
            "Erro ao validar a urna. Tente novamente.",
        );
      } finally {
        this.validandoUrna = false;
      }
    },

    async reiniciarLeituraUrna() {
      this.resultadoValidacaoUrna = null;
      this.qrcodeUrnaManual = "";
      this.erroCameraUrna = null;
      this.$nextTick(() => {
        this.iniciarLeitorUrna();
      });
    },

    async trocarUrnaPorQrcode() {
      if (!this.itemUrnaValidacao || !this.resultadoValidacaoUrna?.qrcodeLido) {
        return;
      }

      this.trocandoUrnaPorQrcode = true;
      try {
        const response = await funerariaService.trocar_urna_por_qrcode(
          this.itemUrnaValidacao.id,
          this.resultadoValidacaoUrna.qrcodeLido,
        );
        this.resultadoValidacaoUrna = response.data;
        this.atualizarItemUrnaValidacao(response.data?.item);
        this.itemUrnaValidacao = response.data?.item || this.itemUrnaValidacao;
        this.agendarFechamentoValidacaoUrna();
      } catch (error) {
        console.error("Erro ao trocar urna por QR Code:", error);
        this.showAlert(
          "Erro",
          error.response?.data?.message ||
            "Erro ao trocar a urna. Tente novamente.",
        );
      } finally {
        this.trocandoUrnaPorQrcode = false;
      }
    },

    atualizarItemUrnaValidacao(itemAtualizado) {
      if (!itemAtualizado || !this.servicoEditando?.itens) return;

      const itemOriginalId = this.itemUrnaValidacao?.id;
      const index = this.servicoEditando.itens.findIndex(
        (item) => item.id === itemAtualizado.id || item.id === itemOriginalId,
      );

      if (index >= 0) {
        this.$set(this.servicoEditando.itens, index, {
          ...this.servicoEditando.itens[index],
          ...itemAtualizado,
        });
      } else {
        this.servicoEditando.itens.push(itemAtualizado);
      }
    },

    agendarFechamentoValidacaoUrna() {
      if (this.resultadoValidacaoUrna?.status !== "VALIDADA") return;
      clearTimeout(this.timeoutFecharValidacaoUrna);
      this.timeoutFecharValidacaoUrna = setTimeout(() => {
        this.fecharDialogValidarUrna();
      }, 3000);
    },

    async fecharDialogValidarUrna() {
      clearTimeout(this.timeoutFecharValidacaoUrna);
      this.timeoutFecharValidacaoUrna = null;
      await this.pararLeitorUrna();
      this.dialogValidarUrna = false;
      this.itemUrnaValidacao = null;
      this.qrcodeUrnaManual = "";
      this.resultadoValidacaoUrna = null;
      this.erroCameraUrna = null;
    },

    // Trocar Urna
    abrirDialogTrocarUrna(item) {
      if (item?.urnaValidada) {
        this.itemUrnaAvisoTroca = item;
        this.cienteTrocaUrnaValidada = false;
        this.dialogAvisoTrocaUrnaValidada = true;
        return;
      }
      this.abrirSelecaoTrocaUrna(item);
    },

    cancelarAvisoTrocaUrnaValidada() {
      this.dialogAvisoTrocaUrnaValidada = false;
      this.cienteTrocaUrnaValidada = false;
      this.itemUrnaAvisoTroca = null;
    },

    confirmarAvisoTrocaUrnaValidada() {
      if (!this.cienteTrocaUrnaValidada) return;
      const item = this.itemUrnaAvisoTroca;
      this.cancelarAvisoTrocaUrnaValidada();
      this.abrirSelecaoTrocaUrna(item);
    },

    async abrirSelecaoTrocaUrna(item) {
      this.itemUrnaAtual = item;
      this.novaUrnaSelecionada = null;
      this.descontoTrocaUrna = 0;
      this.dialogTrocarUrna = true;

      this.carregandoProdutosUrna = true;
      try {
        const response = await funerariaService.listar_produtos_urna();
        this.produtosUrna = response.data || [];
      } catch (error) {
        console.error("Erro ao carregar produtos de urna:", error);
        this.showAlert("Erro", "Erro ao carregar opções de urna.");
      } finally {
        this.carregandoProdutosUrna = false;
      }
    },

    async confirmarTrocaUrna() {
      if (!this.novaUrnaSelecionada || !this.itemUrnaAtual) return;

      this.loadingTrocaUrna = true;
      try {
        await funerariaService.trocar_urna(
          this.itemUrnaAtual.id,
          this.novaUrnaSelecionada.idProduto,
          this.novaUrnaSelecionada.idGrade,
          this.novaUrnaSelecionada.valorProduto,
          parseFloat(this.descontoTrocaUrna) || 0,
        );

        this.showAlert("Sucesso", "Urna trocada com sucesso!");
        this.dialogTrocarUrna = false;

        // Recarregar os dados do serviço
        await this.carregarServicoEditando(this.servicoEditando.id);
      } catch (error) {
        console.error("Erro ao trocar urna:", error);
        this.showAlert("Erro", "Erro ao trocar urna. Tente novamente.");
      } finally {
        this.loadingTrocaUrna = false;
      }
    },

    // Desconto Individual
    abrirDialogDescontoItem(item) {
      this.itemDesconto = item;
      // Inicializa com o desconto atual (permite aumentar, diminuir ou zerar)
      this.valorDescontoItem = item.descontoAplicado || 0;
      this.dialogDescontoItem = true;
    },

    async aplicarDescontoItem() {
      if (this.valorDescontoItem == null || this.valorDescontoItem < 0) return;
      if (!this.itemDesconto) return;

      this.loadingDescontoItem = true;
      try {
        await funerariaService.aplicar_desconto_item(
          this.itemDesconto.id,
          parseFloat(this.valorDescontoItem),
        );

        this.showAlert("Sucesso", "Desconto aplicado com sucesso!");
        this.dialogDescontoItem = false;

        // Recarregar os dados do serviço
        await this.carregarServicoEditando(this.servicoEditando.id);
      } catch (error) {
        console.error("Erro ao aplicar desconto:", error);
        this.showAlert("Erro", "Erro ao aplicar desconto. Tente novamente.");
      } finally {
        this.loadingDescontoItem = false;
      }
    },

    abrirDialogEstoqueQrcodesUrnas() {
      this.estoqueImpressaoQrcode = null;
      this.dialogEstoqueQrcodesUrnas = true;
    },

    async gerarPdfQrcodesUrnas() {
      if (!this.estoqueImpressaoQrcode) {
        this.showAlert("Aviso", "Selecione o estoque de impressão.");
        return;
      }

      this.gerandoPdfQrcodes = true;
      try {
        const response = await funerariaService.listar_urnas_qrcode();
        const estoqueSelecionado = this.estoqueImpressaoQrcode;
        const urnas = (response.data || []).filter(
          (u) => u.qrcodeUrna && u.estoque === estoqueSelecionado,
        );
        if (!urnas.length) {
          this.showAlert(
            "Aviso",
            "Nenhuma urna com QR Code cadastrada para o estoque selecionado.",
          );
          return;
        }

        const doc = new jsPDF({ unit: "mm", format: "a4" });
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const margemX = 10;
        const margemY = 10;
        const gapX = 6;
        const gapY = 6;
        const colunas = 2;
        const larguraCelula = (pageWidth - margemX * 2 - gapX) / colunas;
        const alturaCelula = 44;
        const linhas = Math.floor(
          (pageHeight - margemY * 2 + gapY) / (alturaCelula + gapY),
        );
        const tamanhoQr = 18;
        const porPagina = colunas * linhas;
        const logoDataUrl = await this.carregarImagemComoDataUrl(previdaLogo);
        const logoProps = doc.getImageProperties(logoDataUrl);
        const escalaLogo = Math.min(22 / logoProps.width, 12 / logoProps.height);
        const logoLargura = logoProps.width * escalaLogo;
        const logoAltura = logoProps.height * escalaLogo;

        for (let i = 0; i < urnas.length; i++) {
          const posicao = i % porPagina;
          if (posicao === 0 && i > 0) {
            doc.addPage();
          }

          const urna = urnas[i];
          const x = margemX + (posicao % colunas) * (larguraCelula + gapX);
          const y =
            margemY +
            Math.floor(posicao / colunas) * (alturaCelula + gapY);

          doc.setDrawColor(15);
          doc.setLineWidth(0.5);
          doc.rect(x, y, larguraCelula, alturaCelula);
          doc.addImage(
            logoDataUrl,
            "PNG",
            x + 5,
            y + 11 - logoAltura / 2,
            logoLargura,
            logoAltura,
          );

          doc.setFont("courier", "bold");
          doc.setFontSize(10);
          doc.text("PREVIPARQ LTDA", x + 31, y + 9);
          doc.setFontSize(9);
          doc.text("CNPJ: 04.396.985/0001-77", x + 31, y + 15);

          const qrDataUrl = await QRCode.toDataURL(String(urna.qrcodeUrna), {
            width: 400,
            margin: 1,
          });
          doc.addImage(qrDataUrl, "PNG", x + 5, y + 22, tamanhoQr, tamanhoQr);

          const nomeUrna = [urna.nomeUrna, urna.nomeUrnaGrade]
            .filter(Boolean)
            .join(" ");
          const nome = doc
            .splitTextToSize(nomeUrna || "-", larguraCelula - 34)
            .slice(0, 2);
          doc.setFont("courier", "bold");
          doc.setFontSize(9);
          doc.text(nome, x + 29, y + 27);

          const estoqueUrna = [urna.siglaEstoque, urna.estoque]
            .filter(Boolean)
            .join(" - ");
          if (estoqueUrna) {
            const estoqueTexto = doc
              .splitTextToSize(estoqueUrna, larguraCelula - 34)
              .slice(0, 1);
            doc.setFont("courier", "normal");
            doc.setFontSize(7);
            doc.text(estoqueTexto, x + 29, y + 38);
          }
        }

        const estoqueArquivo = estoqueSelecionado.replace(/[^\w-]+/g, "_");
        doc.save(`qrcodes_urnas_${estoqueArquivo}_${Date.now()}.pdf`);
        this.dialogEstoqueQrcodesUrnas = false;
      } catch (error) {
        console.error("Erro ao gerar PDF de QR Codes:", error);
        this.showAlert("Erro", "Nao foi possivel gerar o PDF de QR Codes.");
      } finally {
        this.gerandoPdfQrcodes = false;
      }
    },

    async carregarImagemComoDataUrl(src) {
      const response = await fetch(src);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },
    // Recarregar Cobertura
    confirmarRecarregarCobertura() {
      this.dialogRecarregarCobertura = true;
    },

    async recarregarCobertura() {
      this.loadingRecarregarCobertura = true;
      try {
        await funerariaService.recarregar_cobertura(
          this.servicoEditando.idAtendimento,
        );

        this.showAlert("Sucesso", "Cobertura recarregada com sucesso!");
        this.dialogRecarregarCobertura = false;

        // Recarregar os dados do serviço
        await this.carregarServicoEditando(this.servicoEditando.id);
      } catch (error) {
        console.error("Erro ao recarregar cobertura:", error);
        this.showAlert(
          "Erro",
          "Erro ao recarregar cobertura. Tente novamente.",
        );
      } finally {
        this.loadingRecarregarCobertura = false;
      }
    },

    registrarEstoqueAnterior(item) {
      this.$set(item, "_estoqueAnterior", item.estoque || null);
    },

    async atualizarEstoqueItem(item) {
      if (!item || !item.isUrna) {
        return;
      }
      if (item.urnaValidada) {
        return;
      }

      const estoqueAnterior = item._estoqueAnterior || null;
      const estoqueAtual = item.estoque || null;
      if (estoqueAnterior === estoqueAtual) {
        return;
      }

      this.estoqueSalvandoItemId = item.id;
      try {
        const response = await funerariaService.atualizar_item(item.id, {
          estoque: estoqueAtual || "",
        });

        const itemAtualizado = response.data;
        if (this.servicoEditando?.itens && itemAtualizado) {
          const index = this.servicoEditando.itens.findIndex(
            (servicoItem) => servicoItem.id === itemAtualizado.id,
          );
          if (index >= 0) {
            this.$set(this.servicoEditando.itens, index, {
              ...this.servicoEditando.itens[index],
              ...itemAtualizado,
            });
          }
        }
      } catch (error) {
        console.error("Erro ao atualizar estoque da urna:", error);
        this.$set(item, "estoque", estoqueAnterior);
        this.showAlert(
          "Erro",
          "Erro ao atualizar o estoque da urna. Tente novamente.",
        );
      } finally {
        this.estoqueSalvandoItemId = null;
      }
    },

    // Editar Item
    abrirDialogEditarItem(item) {
      this.itemEditando = { ...item };
      this.quantidadeEditando = item.quantidade;
      this.dialogEditarItem = true;
    },

    async confirmarEdicaoItem() {
      if (
        !this.itemEditando ||
        this.quantidadeEditando <= 0 ||
        this.quantidadeEditando > 1000
      ) {
        return;
      }

      this.loadingEditarItem = true;
      try {
        // Calcular o novo valor total
        const valorUnitario = this.itemEditando.valorUnitario || 0;
        const descontoAplicado = this.itemEditando.descontoAplicado || 0;
        const valorTotal =
          this.quantidadeEditando * valorUnitario - descontoAplicado;

        const dto = {
          quantidade: this.quantidadeEditando,
          valorUnitario: valorUnitario,
          descontoAplicado: descontoAplicado,
          valorTotal: valorTotal,
          nomeItem: this.itemEditando.nomeItem,
          nomeGradeItem: this.itemEditando.nomeGradeItem,
          idGradeItem: this.itemEditando.idGradeItem,
          valorOriginal: this.itemEditando.valorOriginal,
          tipo: this.itemEditando.tipo,
          isUrna: this.itemEditando.isUrna,
          estoque: this.itemEditando.estoque || "",
        };

        await funerariaService.atualizar_item(this.itemEditando.id, dto);

        this.showAlert("Sucesso", "Item atualizado com sucesso!");
        this.dialogEditarItem = false;

        // Recarregar os dados do serviço
        await this.carregarServicoEditando(this.servicoEditando.id);
      } catch (error) {
        console.error("Erro ao atualizar item:", error);
        this.showAlert("Erro", "Erro ao atualizar item. Tente novamente.");
      } finally {
        this.loadingEditarItem = false;
      }
    },

    // Adicionar Item
    async abrirDialogAdicionarItem() {
      this.dialogAdicionarItem = true;
      this.itemSelecionadoParaAdicionar = [];
      this.paginaItensCobertura = 1;
      this.loadingItensCobertura = true;
      try {
        const response = await funerariaService.consultar_itens_cobertura(
          this.servicoEditando.idAtendimento,
        );
        this.itensCoberturaDisponiveis = response.data || [];
      } catch (error) {
        console.error("Erro ao carregar itens de cobertura:", error);
        this.showAlert("Erro", "Erro ao carregar itens disponíveis.");
      } finally {
        this.loadingItensCobertura = false;
      }
    },

    async adicionarItemSelecionado() {
      if (
        !this.itemSelecionadoParaAdicionar ||
        this.itemSelecionadoParaAdicionar.length === 0
      ) {
        return;
      }

      // VDataTable com single-select retorna um array com o item selecionado
      const item = this.itemSelecionadoParaAdicionar[0];
      this.loadingAdicionarItem = true;
      try {
        const dto = {
          idAtendimento: this.servicoEditando.idAtendimento,
          idItem: item.idItem,
          nomeItem: item.nomeItem,
          nomeGradeItem: item.nomeGradeItem,
          idGradeItem: item.idGradeItem,
          tipo: item.tipo,
          isUrna: item.isUrna || false,
          quantidade: item.quantidade || 1,
          valorUnitario: item.valorUnitario || item.valorTotal,
          descontoAplicado: item.descontoAplicado || 0,
          valorTotal: item.valorTotal,
          valorOriginal: item.valorOriginal || item.valorTotal,
        };

        await funerariaService.adicionar_item(dto);

        this.showAlert("Sucesso", "Item adicionado com sucesso!");
        this.dialogAdicionarItem = false;

        // Recarregar os dados do serviço
        await this.carregarServicoEditando(this.servicoEditando.id);
      } catch (error) {
        console.error("Erro ao adicionar item:", error);
        this.showAlert("Erro", "Erro ao adicionar item. Tente novamente.");
      } finally {
        this.loadingAdicionarItem = false;
      }
    },

    // Recarrega os dados do serviço mantendo o dialog aberto (usado após alterações)
    async carregarServicoEditando(id) {
      const servicoOri = await this.consultarId(id);

      // Preservar o estado atual do panel e tab
      const panelAtual = this.panel;
      const tabAtual = this.tab;

      // Atualizar dados do servicoEditando mantendo a estrutura
      this.servicoEditando = JSON.parse(JSON.stringify(servicoOri));
      this.$set(
        this.servicoEditando,
        "numeroDeclaracaoObito",
        this.servicoEditando.numeroDeclaracaoObito ||
          this.servicoEditando.numero_declaracao_obito ||
          null,
      );
      this.servicoEditando.dataAtendimento = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataAtendimento,
      );

      // Garantir que etapas existe
      if (!this.servicoEditando.etapas) {
        this.servicoEditando.etapas = [];
      }

      // Converter datas das etapas
      this.servicoEditando.etapas.forEach((etapa) => {
        etapa.dtInicio = converteDataHoraBRParaInputISO(etapa.dtInicio);
        etapa.dtFim = converteDataHoraBRParaInputISO(etapa.dtFim);

        if (!etapa.colaboradores) etapa.colaboradores = [];
        if (!etapa.supervisores) etapa.supervisores = [];
        if (!etapa.observacoes) etapa.observacoes = null;
        if (!etapa.ocorrenciaJustificativa)
          etapa.ocorrenciaJustificativa = null;
        if (!etapa.tempoOcorrencia) etapa.tempoOcorrencia = 0;
        etapa.tempoOcorrenciaFormatted = this.minutosParaTempo(
          etapa.tempoOcorrencia,
        );
        this.$set(etapa, "etapaDispensada", !!etapa.etapaDispensada);
        if (etapa.etapaDispensada) {
          this.dispensarEtapaOperacional(etapa.etapaId, true);
        }
        if (!etapa.ticketId) etapa.ticketId = servicoOri.id;
      });

      // Atualizar colaboradores de somato
      const etapaExistenteSomato = servicoOri.etapas?.find(
        (e) => e.etapaId === 9,
      );
      this.servicoEditando.colaboradoresSomato =
        etapaExistenteSomato?.colaboradores || [];

      // Converter datas
      this.servicoEditando.nascimentoFalecido = converteDataParaFormatoISO(
        this.servicoEditando.nascimentoFalecido,
      );
      this.servicoEditando.dtFalecido = converteDataHoraBRParaInputISO(
        this.servicoEditando.dtFalecido,
      );
      this.servicoEditando.dataInicioSomato = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataInicioSomato,
      );
      this.servicoEditando.dataFimSomato = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataFimSomato,
      );
      this.servicoEditando.dataVelorio = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataVelorio,
      );
      this.servicoEditando.dataSepultamento = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataSepultamento,
      );

      this.carregarTagsSelecionadasServicoEditando();

      // Recarregar histórico
      this.consultarHistorico(this.servicoEditando.id);

      // Restaurar estado do panel e tab
      this.$nextTick(() => {
        this.panel = panelAtual;
        this.tab = tabAtual;
      });

      return servicoOri;
    },
  },
};

function converteDataParaFormatoISO(dataNoFormatoBR) {
  if (!dataNoFormatoBR) return null;
  const partes = dataNoFormatoBR.split("/");
  if (partes.length === 3) {
    const [dia, mes, ano] = partes;
    return `${ano}-${mes}-${dia}`;
  }
  return null;
}

function converteDataParaFormatoBR(dataNoFormatoISO) {
  if (!dataNoFormatoISO) return "";
  const [year, month, day] = dataNoFormatoISO.split("-");
  return `${day}/${month}/${year}`;
}

function converteDataHoraBRParaInputISO(dataHoraBR) {
  if (!dataHoraBR) return null;
  if (dataHoraBR.includes("T")) return dataHoraBR.slice(0, 16);
  if (!dataHoraBR.includes("/")) return null;
  // Ex: "25/07/2025 02:42:50" → "2025-07-25T02:42"
  const [data, hora = "00:00"] = dataHoraBR.split(" ");
  const [dia, mes, ano] = data.split("/");

  const [horaStr, minutoStr] = hora.split(":");
  return `${ano}-${mes.padStart(2, "0")}-${dia.padStart(
    2,
    "0",
  )}T${horaStr}:${minutoStr}`;
}

function converteDataHoraInputISOParaBR(dataHoraISO) {
  // Ex: "2025-07-25T02:42" → "25/07/2025 02:42:00"
  if (!dataHoraISO) return "";
  if (!dataHoraISO.includes("T")) return dataHoraISO;
  const [data, hora] = dataHoraISO.split("T");
  const [ano, mes, dia] = data.split("-");
  const [hh, mm] = hora.split(":");
  return `${dia}/${mes}/${ano} ${hh}:${mm}:00`;
}

function dateToInputISO(date) {
  const pad = (n) => n.toString().padStart(2, "0");
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes())
  );
}
</script>

<style scoped>
.fluxo-funerario-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100%;
  padding: 16px;
  color: var(--pulse-text);
  background: var(--app-bg);
}

.metricas-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.fluxo-funerario-board {
  min-width: 0;
}

.fluxo-funerario-page ::v-deep .v-dialog > .v-card {
  border-radius: 12px !important;
  box-shadow: 0 20px 25px -5px rgba(15, 23, 42, 0.12),
    0 8px 10px -6px rgba(15, 23, 42, 0.08) !important;
}

@media (min-width: 640px) {
  .fluxo-funerario-page {
    padding: 24px;
  }

  .metricas-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1264px) {
  .metricas-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.custom-tabs {
  background-color: #fafafa;
  margin-top: 1rem;
}

/* Estilos para cards de itens */
.item-card {
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
}

.item-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.urna-card {
  border-left-color: #1976d2;
  background-color: #f5f9ff;
}

.urna-card:hover {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}

/* Estilos para lista de itens em linhas */
.itens-lista {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.item-linha {
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s ease;
}

.item-linha:last-child {
  border-bottom: none;
}

.item-linha:hover {
  background-color: #f5f5f5;
}

.item-linha-par {
  background-color: #fafafa;
}

.item-linha-impar {
  background-color: #ffffff;
}

.item-linha-urna {
  background-color: #f5f9ff !important;
  border-left: 3px solid #1565c0; /* blue darken-4 */
}

.item-linha-urna:hover {
  background-color: #e3f2fd !important;
}

.item-linha-produto {
  border-left: 3px solid #00796b; /* teal darken-3 */
}

.item-linha-servico {
  border-left: 3px solid #ef6c00; /* orange darken-3 */
}
.item-tipo {
  min-width: 90px;
}

.item-info {
  min-width: 0;
}

.item-nome {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 0;
}

.item-estoque-select {
  flex: 0 1 360px;
  max-width: 420px;
  min-width: 260px;
}

.item-destaque-chip {
  flex-shrink: 0;
}

.item-qtd {
  flex-shrink: 0;
}

.item-valor {
  flex-shrink: 0;
}

.item-acoes {
  border-top: 1px dashed #e0e0e0;
  background-color: rgba(0, 0, 0, 0.02);
  display: flex;
  gap: 8px;
}

.item-acoes-urna {
  flex-wrap: nowrap;
}

.item-acoes-urna .v-btn {
  flex: 0 0 auto;
}

.urna-qrcode-reader {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  min-height: 280px;
  overflow: hidden;
}

/* Estilos para lista de procedimentos */
.procedimentos-lista {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.procedimento-linha {
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s ease;
}

.procedimento-linha:last-child {
  border-bottom: none;
}

.procedimento-linha:hover {
  background-color: #f5f5f5;
}

.procedimento-linha-par {
  background-color: #fafafa;
}

.procedimento-linha-impar {
  background-color: #ffffff;
}

.procedimento-linha-pendente {
  border-left: 4px solid #fb8c00;
}

.procedimento-conteudo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  gap: 16px;
}

.procedimento-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.procedimento-descricao {
  font-weight: 400;
  color: #424242;
  flex: 1;
  min-width: 0;
  word-wrap: break-word;
  font-size: 14px;
}

.procedimento-resposta {
  min-width: 140px;
  max-width: 300px;
}

.procedimento-acoes {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.procedimento-edicao-card {
  border: 1px solid #e0e0e0;
}

/* Ajuste para mobile */
@media (max-width: 768px) {
  .item-linha > div:first-child {
    flex-wrap: wrap;
  }

  .item-info {
    width: 100%;
    order: 2;
    margin-top: 8px;
    margin-right: 0 !important;
  }

  .item-estoque,
  .item-estoque-select {
    flex: 1 1 auto;
    max-width: none;
    min-width: 0;
    width: 100%;
  }

  .item-qtd {
    order: 3;
  }

  .item-valor {
    order: 4;
    margin-left: auto;
  }

  .item-acoes {
    flex-wrap: wrap;
    justify-content: center;
  }

  .item-acoes-urna {
    flex-wrap: nowrap;
    justify-content: flex-end;
  }

  .item-acoes .v-btn {
    margin-bottom: 4px;
  }

  .item-acoes-urna .v-btn {
    margin-bottom: 0;
  }

  .procedimento-conteudo {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .procedimento-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }

  .procedimento-resposta {
    max-width: 100%;
  }

  .procedimento-acoes {
    width: 100%;
    justify-content: flex-end;
  }
}

.cards-container {
  background-color: #f5f5f5;
  border-radius: 0 0 4px 4px;
  margin-top: -4px;
}

.observacao-etapa-kanban {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  white-space: normal;
}

/* Ajuste para mobile */
@media (max-width: 600px) {
  .custom-tabs .v-tab {
    font-size: 0.8rem;
    padding: 0 8px;
    min-width: auto; /* deixa o botão mais estreito */
  }
}
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

/* Defina uma classe para preencher a largura horizontalmente e centralizar verticalmente */
.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.v-menu__content {
  box-shadow: none !important;
  top: 4px !important;
}

.gray-row {
  background-color: #e7f1ff; /* ou qualquer outra cor cinza que você preferir */
}
.cor-row {
  background-color: #f8ded4;
  transition: none !important; /* Desativa a transição de cor */
}

.linha {
  font-size: 11px !important;
  font-weight: normal;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}

.fluxo-toolbar {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.fluxo-toolbar-linha {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.fluxo-toolbar-busca {
  flex: 0 1 300px;
  max-width: 300px;
}

.fluxo-toolbar-select {
  flex: 0 1 220px;
  max-width: 220px;
}

.fluxo-select-resumo {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fluxo-toolbar-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.fluxo-toolbar-acoes {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}

.fluxo-acao-icone {
  cursor: pointer;
  font-size: 26px !important;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.fluxo-acao-icone:hover {
  opacity: 0.8;
  transform: scale(1.1);
}

.fluxo-acao-icone::after {
  display: none;
}

.fluxo-toolbar-rapidos {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

@media (max-width: 599px) {
  .fluxo-toolbar-busca {
    flex-basis: 100%;
    max-width: none;
  }
}

.fluxo-view-toggle {
  display: inline-flex;
  padding: 0;
  background: #f8fafc;
  overflow: hidden;
}

.fluxo-view-toggle .v-btn {
  box-shadow: none !important;
  border-radius: 0 !important;
  min-width: 86px !important;
  height: 34px !important;

  text-transform: none;
  letter-spacing: 0;
  font-size: 12px;
  font-weight: 600;

  color: #475569 !important;
  background: transparent !important;

  transition: 0.18s;
}

.fluxo-view-toggle .v-btn:first-child {
  border-radius: 5px 0 0 5px !important;
}

.fluxo-view-toggle .v-btn:last-child {
  border-radius: 0 5px 5px 0 !important;
}

.fluxo-view-toggle .v-btn:hover {
  transition: scale 0.18s;
}

.fluxo-view-toggle .v-btn--active {
  background: #111827 !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18) !important;
}

.fluxo-view-toggle .v-btn--active .v-icon {
  color: white !important;
}

.fluxo-view-toggle .v-btn .v-icon {
  margin-right: 6px;
}

.funerario-list-view {
  overflow: visible;
}

.funerario-list-table {
  background: #fff;
}

.funerario-list-table >>> th {
  font-size: 11px !important;
  font-weight: bold !important;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.pointer {
  cursor: pointer;
}

.lista-subtexto {
  color: #64748b;
  font-size: 10px;
  font-weight: 400;
  margin-top: 2px;
}

.excel-export-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 58px;
  padding-top: 12px;
  padding-bottom: 2rem;
}

.excel-export-icon {
  color: green;
  font-size: 48px;
  line-height: 1;
  margin-right: 12px;
  cursor: pointer;
  min-width: 48px;
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.excel-export-icon.disabled {
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.65;
}
.card-container {
  display: flex;
  justify-content: space-around; /* ou outro alinhamento que desejar */
}

.primeira-linha-estilo {
  font-size: 5px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.indicadores-container {
  background-color: #eee;
  padding-bottom: 0;
}

.indicador-card-wrapper {
  position: relative;
}

.indicador-card-wrapper >>> .v-card--material-stats > .d-flex > .ml-6 {
  flex: 1 1 0;
  min-width: 0;
}

.indicador-card-wrapper >>> .v-card--material-stats .ml-auto.text-right > div:first-child {
  white-space: normal;
  overflow-wrap: break-word;
  line-height: 1.25;
}

.kanban-container {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 0;
}

.kanban-board {
  padding: 16px;
  overflow-x: auto;
  padding-top: 0;
}

.kanban-colunas {
  display: flex;
  gap: 16px;
  min-height: calc(100vh - 30vh);
}

.kanban-coluna {
  flex: 0 0 340px;
  min-width: 340px;
  max-width: 360px;
}

.kanban-card {
  display: flex;
  flex-direction: column;
  background: #fafafa;
  margin-top: 0;
}

.kanban-cabecalho {
  border-bottom: 1px solid #e0e0e0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.indicador-coluna {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.tarefas-container {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.tarefa-card {
  cursor: pointer;
  transition: 0.2s ease;
  background: white;
  border: 1px solid #e0e0e0;
}

.tarefa-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-adicionar {
  margin-top: 8px;
  min-height: 32px !important;
  font-size: 0.8rem !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.text-gray {
  color: #616161 !important;
}

.text-white {
  color: white;
}
.text-black {
  color: black;
}
.card-placeholder {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.4;
  border: 2px dashed #ccc;
}

.fixed-action-buttons-bottom {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
}

.pendencias-filtro-select {
  max-width: 360px;
  min-width: 280px;
}

.fluxo-sync-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0 8px;
}

.fluxo-sync-link {
  border: 0;
  background: transparent;
  color: #1976d2;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
  text-decoration: underline;
}

.fluxo-sync-link:disabled {
  color: #9e9e9e;
  cursor: default;
}

.kanban-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-height: 60px;
  overflow: hidden;
}

.kanban-tag-chip {
  max-width: 100%;
  height: auto !important;
  min-height: 16px;
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}

.kanban-tag-chip >>> .v-chip__content {
  white-space: normal;
  line-height: 14px;
}

.tags-funerario-lista {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  min-width: 120px;
}
</style>

